import { HttpClient } from "@angular/common/http";
import {
  Component,
  Inject,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  AfterViewInit,
  ChangeDetectorRef,
} from "@angular/core";
import { AuthService } from "@auth0/auth0-angular";
import { MessageService } from "primeng/api";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import { NGXLogger } from "ngx-logger";
import { DOCUMENT } from "@angular/common";
import { Router, ActivatedRoute } from "@angular/router";
import { UtentiService } from "src/app/services/utenti.service";
import { UserService } from "src/app/services/user.service";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { StatsService } from "src/app/services/notification.service";
import { ImpreseService } from "src/app/services/imprese.service";
import { onSnapshot } from "firebase/firestore";
import { environment } from "src/environments/environment";
import {
  DatiAppuntamentiPerImpresa,
  DatiSopralluogoPerImpresa,
  PraticaFlowdy2_Firestore,
} from "src/app/models/praticaFirestore.model";
import { StatsFlowdy2 } from "src/app/models/statsFlowdy2.model";
import { UtilService } from "src/app/services/util.service";
import { ExcelService } from "src/app/services/excelService.service";
import { ListeService } from "src/app/services/liste.service";
import { StiliService } from "src/app/services/stili.service";
import { v4 as uuidv4 } from "uuid";
import { ImportLog_Firestore } from "src/app/models/firestore/importLogFirestore.model";

declare const CSVBoxImporter: any;

@Component({
  selector: "app-home-flowdy2-wip",
  templateUrl: "./home.flowdy2.wip.component.html",
  styleUrls: ["./home.component.css"],
  styles: [
    `
      :host ::ng-deep .p-datatable {
        border-radius: 8px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      }

      :host ::ng-deep .p-datatable .p-datatable-header {
        background: #f8f9fa;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
      }

      :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
        background: #f8f9fa;
        color: #495057;
        font-weight: 600;
        padding: 0.5rem;
        border: none;
        border-bottom: 2px solid #dee2e6;
      }

      :host ::ng-deep .p-datatable .p-datatable-thead > tr > th:last-child {
        background: #e9ecef;
        font-weight: 700;
        color: #212529;
        border-left: 2px solid #dee2e6;
      }

      :host ::ng-deep .p-datatable .p-datatable-tbody > tr {
        transition: background-color 0.2s;
      }

      :host ::ng-deep .p-datatable .p-datatable-tbody > tr:nth-child(even) {
        background-color: #f8f9fa;
      }

      :host ::ng-deep .p-datatable .p-datatable-tbody > tr:nth-child(odd) {
        background-color: #ffffff;
      }

      :host ::ng-deep .p-datatable .p-datatable-tbody > tr:hover {
        background-color: #e9ecef;
      }

      :host ::ng-deep .p-datatable .p-datatable-tbody > tr > td {
        padding: 0.5rem;
        border: none;
        border-bottom: 1px solid #dee2e6;
      }

      :host ::ng-deep .p-datatable .p-datatable-tbody > tr > td:last-child {
        background: #f8f9fa;
        font-weight: 600;
        border-left: 2px solid #dee2e6;
      }

      :host ::ng-deep .p-tag {
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
        transition: all 0.2s;
        padding: 0.25rem 0.5rem !important;
      }

      :host ::ng-deep .p-tag:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
      }

      :host ::ng-deep .p-datatable .p-datatable-footer {
        background: #2c3e50;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
        padding: 0.75rem;
        border-top: 2px solid #34495e;
        color: #ffffff;
      }

      :host ::ng-deep .p-datatable .p-datatable-footer tr td {
        padding: 0.5rem;
        border: none;
      }

      :host ::ng-deep .p-datatable .p-datatable-footer tr td:first-child {
        font-weight: 700;
        color: #ffffff;
        font-size: 1.1em;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }

      :host ::ng-deep .p-datatable .p-datatable-footer .p-tag {
        font-weight: 700;
        font-size: 1.1em;
        padding: 0.35rem 0.75rem !important;
        border-radius: 4px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
      }

      :host ::ng-deep .p-datatable .p-datatable-footer .p-tag:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
      }

      /* Colori pastello per i tag nel footer */
      :host
        ::ng-deep
        .p-datatable
        .p-datatable-footer
        .p-tag.no-appuntamento-manca-pf-no-ntw {
        background-color: #ffb3ba !important;
        color: #8b0000 !important;
      }

      :host
        ::ng-deep
        .p-datatable
        .p-datatable-footer
        .p-tag.no-appuntamento-manca-pf-con-ntw {
        background-color: #baffc9 !important;
        color: #006400 !important;
      }

      :host
        ::ng-deep
        .p-datatable
        .p-datatable-footer
        .p-tag.no-appuntamento-pf-pronto {
        background-color: #bae1ff !important;
        color: #00008b !important;
      }

      :host
        ::ng-deep
        .p-datatable
        .p-datatable-footer
        .p-tag.appuntamento-fissato {
        background-color: #ffffba !important;
        color: #8b8b00 !important;
      }

      :host
        ::ng-deep
        .p-datatable
        .p-datatable-footer
        .p-tag.appuntamento-scaduto {
        background-color: #ffb3ba !important;
        color: #8b0000 !important;
      }

      :host ::ng-deep .p-datatable .p-datatable-footer .p-tag.attivazione-ko {
        background-color: #ffb3ba !important;
        color: #8b0000 !important;
      }

      :host ::ng-deep .p-datatable .p-datatable-footer .p-tag.attivazione-ok {
        background-color: #baffc9 !important;
        color: #006400 !important;
      }

      :host ::ng-deep .p-datatable .p-datatable-footer .p-tag.installazione-ok {
        background-color: #bae1ff !important;
        color: #00008b !important;
      }

      /* Stili per la tabella vincoli OF */
      :host ::ng-deep .vincoli-of-table .p-datatable-thead > tr > th {
        background: #f8f9fa;
        color: #495057;
        border-bottom: 2px solid #dee2e6;
        padding: 0.75rem 0.5rem;
      }

      :host ::ng-deep .vincoli-of-table .p-datatable-tbody > tr > td {
        padding: 0.65rem 0.5rem;
        border-bottom: 1px solid #e9ecef;
      }

      :host
        ::ng-deep
        .vincoli-of-table
        .p-datatable-tbody
        > tr:nth-child(even) {
        background-color: #ffffff;
      }

      :host ::ng-deep .vincoli-of-table .p-datatable-tbody > tr:nth-child(odd) {
        background-color: #f8f9fa;
      }

      :host ::ng-deep .vincoli-of-table .p-datatable-tbody > tr:hover {
        background-color: #e9ecef;
      }

      :host
        ::ng-deep
        .vincoli-of-table
        .p-datatable-tbody
        > tr.highlighted-row {
        background-color: #fff3cd !important;
        border-left: 4px solid #ffc107 !important;
        box-shadow: 0 2px 8px rgba(255, 193, 7, 0.3);
        animation: pulseHighlight 2s ease-in-out infinite;
      }

      @keyframes pulseHighlight {
        0%,
        100% {
          box-shadow: 0 2px 8px rgba(255, 193, 7, 0.3);
        }
        50% {
          box-shadow: 0 4px 12px rgba(255, 193, 7, 0.5);
        }
      }

      :host
        ::ng-deep
        .vincoli-of-table
        .p-datatable-tbody
        > tr.highlighted-row
        > td {
        font-weight: 700 !important;
      }

      :host
        ::ng-deep
        .vincoli-of-table
        .p-datatable-tbody
        > tr.highlighted-row
        > td:last-child {
        background-color: #ffe69c !important;
      }

      /* Tooltip personalizzato per statoOF */
      :host ::ng-deep .custom-tooltip-stato-of {
        background: linear-gradient(
          135deg,
          #667eea 0%,
          #764ba2 100%
        ) !important;
        color: #ffffff !important;
        border-radius: 8px !important;
        padding: 0.75rem 1rem !important;
        font-family: "Poppins", sans-serif !important;
        font-size: 12px !important;
        font-weight: 500 !important;
        box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4) !important;
        border: none !important;
        max-width: 300px !important;
        white-space: pre-line !important;
        line-height: 1.6 !important;
        letter-spacing: 0.3px !important;
      }

      :host ::ng-deep .custom-tooltip-stato-of .p-tooltip-arrow {
        border-top-color: #667eea !important;
      }

      /* Stili uniformi per i filtri REGIONE e Servizio OF */
      :host ::ng-deep .fieldFilterControl.p-dropdown,
      :host ::ng-deep .fieldFilterControl.p-multiselect {
        height: 2.5rem !important;
        min-height: 2.5rem !important;
      }

      :host ::ng-deep .fieldFilterControl.p-dropdown .p-dropdown-label,
      :host ::ng-deep .fieldFilterControl.p-dropdown .p-inputtext,
      :host ::ng-deep .fieldFilterControl.p-multiselect .p-multiselect-label,
      :host ::ng-deep .fieldFilterControl.p-multiselect .p-inputtext {
        height: 2.5rem !important;
        min-height: 2.5rem !important;
        font-size: 14px !important;
        line-height: normal !important;
        padding: 0.5rem 0.75rem !important;
        display: flex !important;
        align-items: center !important;
      }

      :host ::ng-deep .fieldFilterControl.p-dropdown .p-dropdown-trigger,
      :host ::ng-deep .fieldFilterControl.p-multiselect .p-multiselect-trigger {
        height: 2.5rem !important;
        width: 2.5rem !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
      }
    `,
  ],
})
export class HomeFlowdy2WipComponent
  implements OnInit, OnChanges, AfterViewInit
{
  @Input() impresa: any;
  @Input() isImpresa: boolean = null;
  @Input() isPresidioTIM: boolean = null;
  @Input() isPresidioSF: boolean = null;

  // Nuovi input per gestire la selezione dei tab
  @Input() activeTabType?: string; // 0 per Sopralluoghi, 1 per Appuntamenti/Attivazioni
  @Input() activeBandoNumber?: number; // 1 per Bando 1, 2 per Bando 2

  private importID: string;
  private csvbox_licenseKey_aggiornaSituazioneOF: string =
    environment.csvBox.secret_aggiornaSituazioneOF;
  private csvbox_importer_aggiornaSituazioneOF: any;

  private collection_importLog: string =
    environment.firebase.collection_import_log;

  ref: DynamicDialogRef;

  // Appuntamenti/Attivazioni
  protected datiRaggruppatiBando1App: DatiAppuntamentiPerImpresa[] = [];
  protected datiRaggruppatiBando1AppFiltrati: DatiAppuntamentiPerImpresa[] = [];
  protected datiRaggruppatiBando2AppFiltrati: DatiAppuntamentiPerImpresa[] = [];
  protected datiRaggruppatiBando2App: DatiAppuntamentiPerImpresa[] = [];

  // Sopralluoghi
  protected datiRaggruppatiBando1Sop: DatiSopralluogoPerImpresa[] = [];
  protected datiRaggruppatiBando1SopFiltrati: DatiSopralluogoPerImpresa[] = [];
  protected datiRaggruppatiBando2SopFiltrati: DatiSopralluogoPerImpresa[] = [];
  protected datiRaggruppatiBando2Sop: DatiSopralluogoPerImpresa[] = [];

  // Stato Open Fiber
  protected praticheTipoC: PraticaFlowdy2_Firestore[] = [];
  protected praticheTipoCFiltrate: PraticaFlowdy2_Firestore[] = [];
  protected activeOFIndex: number = 0; // Indice per i tab annidati nello Stato Open Fiber

  // Dati per la tabella vincoli OF
  protected vincoliOFData: any[] = [];

  // Array per tracciare pratiche con lotti non validi
  private praticheLottoNonValido: Array<{
    cui: string;
    lotto: any;
    regione: string;
    azienda: string;
  }> = [];

  // Array per tracciare pratiche non categorizzate
  protected praticheNonCategorizzate: PraticaFlowdy2_Firestore[] = [];

  // Variabili Vincolo OF Bando 2
  protected vincoloOFBando2: number = 0;
  protected vincoloOFBando2Lotto1: number = 0;
  protected vincoloOFBando2Lotto5: number = 0;
  protected vincoloOFBando2Lotto7: number = 0;
  protected vincoloOFBando2Lotto8: number = 0;

  protected vincoloOFBando2_2_1: number = 0;
  protected vincoloOFBando2_2_1_Lotto1: number = 0;
  protected vincoloOFBando2_2_1_Lotto5: number = 0;
  protected vincoloOFBando2_2_1_Lotto7: number = 0;
  protected vincoloOFBando2_2_1_Lotto8: number = 0;

  protected vincoloOFBando2_2_2: number = 0;
  protected vincoloOFBando2_2_2_Lotto1: number = 0;
  protected vincoloOFBando2_2_2_Lotto5: number = 0;
  protected vincoloOFBando2_2_2_Lotto7: number = 0;
  protected vincoloOFBando2_2_2_Lotto8: number = 0;

  protected vincoloOFBando2_2_3: number = 0;
  protected vincoloOFBando2_2_3_Lotto1: number = 0;
  protected vincoloOFBando2_2_3_Lotto5: number = 0;
  protected vincoloOFBando2_2_3_Lotto7: number = 0;
  protected vincoloOFBando2_2_3_Lotto8: number = 0;

  protected vincoloOFBando2_2_4: number = 0;
  protected vincoloOFBando2_2_4_Lotto1: number = 0;
  protected vincoloOFBando2_2_4_Lotto5: number = 0;
  protected vincoloOFBando2_2_4_Lotto7: number = 0;
  protected vincoloOFBando2_2_4_Lotto8: number = 0;

  protected vincoloOFBando2_2_5: number = 0;
  protected vincoloOFBando2_2_5_Lotto1: number = 0;
  protected vincoloOFBando2_2_5_Lotto5: number = 0;
  protected vincoloOFBando2_2_5_Lotto7: number = 0;
  protected vincoloOFBando2_2_5_Lotto8: number = 0;

  protected vincoloOFBando2_2_6: number = 0;
  protected vincoloOFBando2_2_6_Lotto1: number = 0;
  protected vincoloOFBando2_2_6_Lotto5: number = 0;
  protected vincoloOFBando2_2_6_Lotto7: number = 0;
  protected vincoloOFBando2_2_6_Lotto8: number = 0;

  protected vincoloOFBando2_2_7: number = 0;
  protected vincoloOFBando2_2_7_Lotto1: number = 0;
  protected vincoloOFBando2_2_7_Lotto5: number = 0;
  protected vincoloOFBando2_2_7_Lotto7: number = 0;
  protected vincoloOFBando2_2_7_Lotto8: number = 0;

  protected vincoloOFBando2_2_8: number = 0;
  protected vincoloOFBando2_2_8_Lotto1: number = 0;
  protected vincoloOFBando2_2_8_Lotto5: number = 0;
  protected vincoloOFBando2_2_8_Lotto7: number = 0;
  protected vincoloOFBando2_2_8_Lotto8: number = 0;

  protected vincoloOFBando2_2_9: number = 0;
  protected vincoloOFBando2_2_9_Lotto1: number = 0;
  protected vincoloOFBando2_2_9_Lotto5: number = 0;
  protected vincoloOFBando2_2_9_Lotto7: number = 0;
  protected vincoloOFBando2_2_9_Lotto8: number = 0;

  // Variabili per ATTIVO e PASSIVO (totale per categoria)
  protected vincoloOFBando2_2_1_Attivo: number = 0;
  protected vincoloOFBando2_2_1_Passivo: number = 0;
  protected vincoloOFBando2_2_1_SenzaServizio: number = 0;
  protected vincoloOFBando2_2_2_Attivo: number = 0;
  protected vincoloOFBando2_2_2_Passivo: number = 0;
  protected vincoloOFBando2_2_2_SenzaServizio: number = 0;
  protected vincoloOFBando2_2_3_Attivo: number = 0;
  protected vincoloOFBando2_2_3_Passivo: number = 0;
  protected vincoloOFBando2_2_3_SenzaServizio: number = 0;
  protected vincoloOFBando2_2_4_Attivo: number = 0;
  protected vincoloOFBando2_2_4_Passivo: number = 0;
  protected vincoloOFBando2_2_4_SenzaServizio: number = 0;
  protected vincoloOFBando2_2_5_Attivo: number = 0;
  protected vincoloOFBando2_2_5_Passivo: number = 0;
  protected vincoloOFBando2_2_5_SenzaServizio: number = 0;
  protected vincoloOFBando2_2_6_Attivo: number = 0;
  protected vincoloOFBando2_2_6_Passivo: number = 0;
  protected vincoloOFBando2_2_6_SenzaServizio: number = 0;
  protected vincoloOFBando2_2_7_Attivo: number = 0;
  protected vincoloOFBando2_2_7_Passivo: number = 0;
  protected vincoloOFBando2_2_7_SenzaServizio: number = 0;
  protected vincoloOFBando2_2_8_Attivo: number = 0;
  protected vincoloOFBando2_2_8_Passivo: number = 0;
  protected vincoloOFBando2_2_8_SenzaServizio: number = 0;
  protected vincoloOFBando2_2_9_Attivo: number = 0;
  protected vincoloOFBando2_2_9_Passivo: number = 0;
  protected vincoloOFBando2_2_9_SenzaServizio: number = 0;

  // Variabili per ATTIVATE e RILASCIATE FIBERCOP per categoria
  protected vincoloOFBando2_2_1_Attivate: number = 0;
  protected vincoloOFBando2_2_1_RilasciateFibercop: number = 0;
  protected vincoloOFBando2_2_2_Attivate: number = 0;
  protected vincoloOFBando2_2_2_RilasciateFibercop: number = 0;
  protected vincoloOFBando2_2_3_Attivate: number = 0;
  protected vincoloOFBando2_2_3_RilasciateFibercop: number = 0;
  protected vincoloOFBando2_2_4_Attivate: number = 0;
  protected vincoloOFBando2_2_4_RilasciateFibercop: number = 0;
  protected vincoloOFBando2_2_5_Attivate: number = 0;
  protected vincoloOFBando2_2_5_RilasciateFibercop: number = 0;
  protected vincoloOFBando2_2_6_Attivate: number = 0;
  protected vincoloOFBando2_2_6_RilasciateFibercop: number = 0;
  protected vincoloOFBando2_2_7_Attivate: number = 0;
  protected vincoloOFBando2_2_7_RilasciateFibercop: number = 0;
  protected vincoloOFBando2_2_8_Attivate: number = 0;
  protected vincoloOFBando2_2_8_RilasciateFibercop: number = 0;
  protected vincoloOFBando2_2_9_Attivate: number = 0;
  protected vincoloOFBando2_2_9_RilasciateFibercop: number = 0;

  // Variabili per IN ATTESA per categoria
  protected vincoloOFBando2_2_1_InAttesa: number = 0;
  protected vincoloOFBando2_2_2_InAttesa: number = 0;
  protected vincoloOFBando2_2_3_InAttesa: number = 0;
  protected vincoloOFBando2_2_4_InAttesa: number = 0;
  protected vincoloOFBando2_2_5_InAttesa: number = 0;
  protected vincoloOFBando2_2_6_InAttesa: number = 0;
  protected vincoloOFBando2_2_7_InAttesa: number = 0;
  protected vincoloOFBando2_2_8_InAttesa: number = 0;
  protected vincoloOFBando2_2_9_InAttesa: number = 0;

  // Variabili per NULL per categoria (statoPF mancante)
  protected vincoloOFBando2_2_1_Null: number = 0;
  protected vincoloOFBando2_2_2_Null: number = 0;
  protected vincoloOFBando2_2_3_Null: number = 0;
  protected vincoloOFBando2_2_4_Null: number = 0;
  protected vincoloOFBando2_2_5_Null: number = 0;
  protected vincoloOFBando2_2_6_Null: number = 0;
  protected vincoloOFBando2_2_7_Null: number = 0;
  protected vincoloOFBando2_2_8_Null: number = 0;
  protected vincoloOFBando2_2_9_Null: number = 0;

  // Totali ATTIVO, PASSIVO e SENZA SERVIZIO complessivi
  protected vincoloOFBando2_Attivo: number = 0;
  protected vincoloOFBando2_Passivo: number = 0;
  protected vincoloOFBando2_SenzaServizio: number = 0;

  // Contatori per ATTIVATE, RILASCIATE FIBERCOP e IN ATTESA
  protected vincoloOFBando2_Attivate: number = 0;
  protected vincoloOFBando2_RilasciateFibercop: number = 0;
  protected vincoloOFBando2_InAttesa: number = 0;
  protected vincoloOFBando2_Null: number = 0;

  // Variabili per casi LAVORABILE
  protected vincoloOFBando2_Lavorabili: number = 0;
  protected vincoloOFBando2_Lavorabili_Lotto1: number = 0;
  protected vincoloOFBando2_Lavorabili_Lotto5: number = 0;
  protected vincoloOFBando2_Lavorabili_Lotto7: number = 0;
  protected vincoloOFBando2_Lavorabili_Lotto8: number = 0;
  protected vincoloOFBando2_Lavorabili_Attivo: number = 0;
  protected vincoloOFBando2_Lavorabili_Passivo: number = 0;
  protected vincoloOFBando2_Lavorabili_SenzaServizio: number = 0;
  protected vincoloOFBando2_Lavorabili_Attivate: number = 0;
  protected vincoloOFBando2_Lavorabili_RilasciateFibercop: number = 0;
  protected vincoloOFBando2_Lavorabili_InAttesa: number = 0;
  protected vincoloOFBando2_Lavorabili_Null: number = 0;

  // Variabili per VINCOLO FIBERCOP (vincoloTipologiaID = 1)
  protected vincoloOFBando2_Fibercop: number = 0;
  protected vincoloOFBando2_Fibercop_Lotto1: number = 0;
  protected vincoloOFBando2_Fibercop_Lotto5: number = 0;
  protected vincoloOFBando2_Fibercop_Lotto7: number = 0;
  protected vincoloOFBando2_Fibercop_Lotto8: number = 0;
  protected vincoloOFBando2_Fibercop_Attivo: number = 0;
  protected vincoloOFBando2_Fibercop_Passivo: number = 0;
  protected vincoloOFBando2_Fibercop_SenzaServizio: number = 0;
  protected vincoloOFBando2_Fibercop_Attivate: number = 0;
  protected vincoloOFBando2_Fibercop_RilasciateFibercop: number = 0;
  protected vincoloOFBando2_Fibercop_InAttesa: number = 0;
  protected vincoloOFBando2_Fibercop_Null: number = 0;

  // Variabili per VINCOLO INFRATEL (vincoloTipologiaID = 3)
  protected vincoloOFBando2_Infratel: number = 0;
  protected vincoloOFBando2_Infratel_Lotto1: number = 0;
  protected vincoloOFBando2_Infratel_Lotto5: number = 0;
  protected vincoloOFBando2_Infratel_Lotto7: number = 0;
  protected vincoloOFBando2_Infratel_Lotto8: number = 0;
  protected vincoloOFBando2_Infratel_Attivo: number = 0;
  protected vincoloOFBando2_Infratel_Passivo: number = 0;
  protected vincoloOFBando2_Infratel_SenzaServizio: number = 0;
  protected vincoloOFBando2_Infratel_Attivate: number = 0;
  protected vincoloOFBando2_Infratel_RilasciateFibercop: number = 0;
  protected vincoloOFBando2_Infratel_InAttesa: number = 0;
  protected vincoloOFBando2_Infratel_Null: number = 0;

  // Variabili per FUORI PERIMETRO (vincoloTipologiaID = 4)
  protected vincoloOFBando2_FuoriPerimetro: number = 0;
  protected vincoloOFBando2_FuoriPerimetro_Lotto1: number = 0;
  protected vincoloOFBando2_FuoriPerimetro_Lotto5: number = 0;
  protected vincoloOFBando2_FuoriPerimetro_Lotto7: number = 0;
  protected vincoloOFBando2_FuoriPerimetro_Lotto8: number = 0;
  protected vincoloOFBando2_FuoriPerimetro_Attivo: number = 0;
  protected vincoloOFBando2_FuoriPerimetro_Passivo: number = 0;
  protected vincoloOFBando2_FuoriPerimetro_SenzaServizio: number = 0;
  protected vincoloOFBando2_FuoriPerimetro_Attivate: number = 0;
  protected vincoloOFBando2_FuoriPerimetro_RilasciateFibercop: number = 0;
  protected vincoloOFBando2_FuoriPerimetro_InAttesa: number = 0;
  protected vincoloOFBando2_FuoriPerimetro_Null: number = 0;

  protected labelRegioniApp: string = "Tutte le regioni";
  protected labelRegioniSop: string = "Tutte le regioni";
  protected labelRegioniOF: string = "Tutte le regioni";
  protected labelCategoriaVincoloOF: string = "Tutti i servizi OF";

  protected isLoadingApp: boolean = true;
  protected isLoadingSop: boolean = true;

  protected filtroRegioneApp: string = "";
  protected filtroImpresaApp: number | null = null;
  protected filtroTipoSedeEffettivaApp: string = "";
  protected filtroRegioneSop: string = "";
  protected filtroImpresaSop: number | null = null;
  protected filtroTipoSedeEffettivaSop: string = "";
  protected filtroRegioneOF: string[] = [];
  protected filtroCategoriaVincoloOF: string = "";
  protected filtroStatoOF: string = "";
  protected filtroVincoloCategoriaPrefisso: string = ""; // Prefisso per filtrare vincoloCategoriaCodice (es. "1", "3", "4")
  protected filtroCuiOF: string = "";
  protected filtroVendibile: boolean = false;

  protected filterIsSetApp: boolean = false;
  protected filterIsSetSop: boolean = false;
  protected filterIsSetOF: boolean = false;

  protected opzioniImpreseBando1Sop: { label: string; value: number }[] = [];
  protected opzioniImpreseBando1App: { label: string; value: number }[] = [];
  protected opzioniTipoSedeBando1Sop: { label: string; value: string }[] = [];
  protected opzioniTipoSedeBando1App: { label: string; value: string }[] = [];
  protected opzioniImpreseBando2Sop: { label: string; value: number }[] = [];
  protected opzioniImpreseBando2App: { label: string; value: number }[] = [];
  protected opzioniTipoSedeBando2Sop: { label: string; value: string }[] = [];
  protected opzioniTipoSedeBando2App: { label: string; value: string }[] = [];

  /** Label impresa selezionata per il titolo Sopralluoghi */
  get labelImpresaSelezionataSop(): string {
    const opzioni =
      this.activeBandoIndex === 0
        ? this.opzioniImpreseBando1Sop
        : this.opzioniImpreseBando2Sop;
    return opzioni.find((o) => o.value === this.filtroImpresaSop)?.label ?? "";
  }

  /** Label impresa selezionata per il titolo Appuntamenti */
  get labelImpresaSelezionataApp(): string {
    const opzioni =
      this.activeBandoIndex === 0
        ? this.opzioniImpreseBando1App
        : this.opzioniImpreseBando2App;
    return opzioni.find((o) => o.value === this.filtroImpresaApp)?.label ?? "";
  }

  /** Aggiorna le opzioni imprese Bando 1 filtrate per regione. Mantiene l'impresa selezionata nelle opzioni anche se la regione non ha dati. */
  private aggiornaOpzioniImpreseBando1Sop() {
    if (!this.datiRaggruppatiBando1Sop?.length) {
      this.opzioniImpreseBando1Sop = [];
      return;
    }
    const hasRegione = (this.filtroRegioneSop?.length ?? 0) > 0;
    if (!hasRegione) {
      this.opzioniImpreseBando1Sop = this.datiRaggruppatiBando1Sop.map((d) => ({
        label: d.impresa,
        value: Number(d.idImpresa),
      }));
    } else {
      let base = this.datiRaggruppatiBando1Sop
        .filter((d) => d.datiPerRegione[this.filtroRegioneSop]?.totale > 0)
        .map((d) => ({
          label: d.impresa,
          value: Number(d.idImpresa),
        }));
      if (
        base.length === 0 &&
        this.filtroImpresaSop != null &&
        this.filtroImpresaSop !== undefined
      ) {
        const sel = this.datiRaggruppatiBando1Sop.find(
          (d) => Number(d.idImpresa) === Number(this.filtroImpresaSop),
        );
        if (sel) {
          base = [{ label: sel.impresa, value: Number(sel.idImpresa) }];
        }
      }
      this.opzioniImpreseBando1Sop = base;
    }
  }

  /** Aggiorna le opzioni imprese Bando 1 filtrate per regione. Mantiene l'impresa selezionata nelle opzioni anche se la regione non ha dati. */
  private aggiornaOpzioniImpreseBando1App() {
    if (!this.datiRaggruppatiBando1App?.length) {
      this.opzioniImpreseBando1App = [];
      return;
    }
    const hasRegione = (this.filtroRegioneApp?.length ?? 0) > 0;
    if (!hasRegione) {
      this.opzioniImpreseBando1App = this.datiRaggruppatiBando1App.map((d) => ({
        label: d.impresa,
        value: Number(d.idImpresa),
      }));
    } else {
      let base = this.datiRaggruppatiBando1App
        .filter((d) => d.datiPerRegione[this.filtroRegioneApp]?.totale > 0)
        .map((d) => ({
          label: d.impresa,
          value: Number(d.idImpresa),
        }));
      if (
        base.length === 0 &&
        this.filtroImpresaApp != null &&
        this.filtroImpresaApp !== undefined
      ) {
        const sel = this.datiRaggruppatiBando1App.find(
          (d) => Number(d.idImpresa) === Number(this.filtroImpresaApp),
        );
        if (sel) {
          base = [{ label: sel.impresa, value: Number(sel.idImpresa) }];
        }
      }
      this.opzioniImpreseBando1App = base;
    }
  }

  private mergeTipiSedeConOpzioniStatiche(
    tipiSedeDaDati: string[],
    opzioniStatiche: { value: string }[],
  ): { label: string; value: string }[] {
    const merged = new Set<string>();
    opzioniStatiche.forEach((o) => merged.add(o.value));
    tipiSedeDaDati.filter((t) => t).forEach((t) => merged.add(t));
    return Array.from(merged)
      .sort()
      .map((t) => ({ label: t, value: t }));
  }

  private aggiornaOpzioniTipoSedeBando1Sop(tipiSede: string[]) {
    this.opzioniTipoSedeBando1Sop = this.mergeTipiSedeConOpzioniStatiche(
      tipiSede,
      this.listeService.opzioniTipoSedeBando1,
    );
  }

  private aggiornaOpzioniTipoSedeBando1App(tipiSede: string[]) {
    this.opzioniTipoSedeBando1App = this.mergeTipiSedeConOpzioniStatiche(
      tipiSede,
      this.listeService.opzioniTipoSedeBando1,
    );
  }

  /** Aggiorna le opzioni imprese filtrate per regione. Mantiene l'impresa selezionata nelle opzioni anche se la regione non ha dati. */
  private aggiornaOpzioniImpreseBando2Sop() {
    if (!this.datiRaggruppatiBando2Sop?.length) {
      this.opzioniImpreseBando2Sop = [];
      return;
    }
    const hasRegione = (this.filtroRegioneSop?.length ?? 0) > 0;
    if (!hasRegione) {
      this.opzioniImpreseBando2Sop = this.datiRaggruppatiBando2Sop.map((d) => ({
        label: d.impresa,
        value: Number(d.idImpresa),
      }));
    } else {
      let base = this.datiRaggruppatiBando2Sop
        .filter((d) => d.datiPerRegione[this.filtroRegioneSop]?.totale > 0)
        .map((d) => ({
          label: d.impresa,
          value: Number(d.idImpresa),
        }));
      if (
        base.length === 0 &&
        this.filtroImpresaSop != null &&
        this.filtroImpresaSop !== undefined
      ) {
        const sel = this.datiRaggruppatiBando2Sop.find(
          (d) => Number(d.idImpresa) === Number(this.filtroImpresaSop),
        );
        if (sel) {
          base = [{ label: sel.impresa, value: Number(sel.idImpresa) }];
        }
      }
      this.opzioniImpreseBando2Sop = base;
    }
  }

  /** Aggiorna le opzioni imprese filtrate per regione. Mantiene l'impresa selezionata nelle opzioni anche se la regione non ha dati. */
  private aggiornaOpzioniImpreseBando2App() {
    if (!this.datiRaggruppatiBando2App?.length) {
      this.opzioniImpreseBando2App = [];
      return;
    }
    const hasRegione = (this.filtroRegioneApp?.length ?? 0) > 0;
    if (!hasRegione) {
      this.opzioniImpreseBando2App = this.datiRaggruppatiBando2App.map((d) => ({
        label: d.impresa,
        value: Number(d.idImpresa),
      }));
    } else {
      let base = this.datiRaggruppatiBando2App
        .filter((d) => d.datiPerRegione[this.filtroRegioneApp]?.totale > 0)
        .map((d) => ({
          label: d.impresa,
          value: Number(d.idImpresa),
        }));
      if (
        base.length === 0 &&
        this.filtroImpresaApp != null &&
        this.filtroImpresaApp !== undefined
      ) {
        const sel = this.datiRaggruppatiBando2App.find(
          (d) => Number(d.idImpresa) === Number(this.filtroImpresaApp),
        );
        if (sel) {
          base = [{ label: sel.impresa, value: Number(sel.idImpresa) }];
        }
      }
      this.opzioniImpreseBando2App = base;
    }
  }

  private aggiornaOpzioniTipoSedeBando2App(tipiSede: string[]) {
    this.opzioniTipoSedeBando2App = this.mergeTipiSedeConOpzioniStatiche(
      tipiSede,
      this.listeService.opzioniTipoSedeBando2,
    );
  }

  private aggiornaOpzioniTipoSedeBando2Sop(tipiSede: string[]) {
    this.opzioniTipoSedeBando2Sop = this.mergeTipiSedeConOpzioniStatiche(
      tipiSede,
      this.listeService.opzioniTipoSedeBando2,
    );
  }

  // Getter per il totale delle pratiche filtrate
  get totalePraticheFiltrateOF(): number {
    return this.praticheTipoCFiltrate ? this.praticheTipoCFiltrate.length : 0;
  }

  // Getter per il totale delle pratiche senza filtri (per mostrare sempre il totale)
  get totalePraticheOF(): number {
    return this.praticheTipoC ? this.praticheTipoC.length : 0;
  }

  // Verifica se ci sono filtri attivi per il tab OF
  get hasActiveFiltersOF(): boolean {
    return (
      (this.filtroRegioneOF && this.filtroRegioneOF.length > 0) ||
      (this.filtroCategoriaVincoloOF &&
        typeof this.filtroCategoriaVincoloOF === "string" &&
        this.filtroCategoriaVincoloOF.trim().length > 0) ||
      (this.filtroStatoOF &&
        typeof this.filtroStatoOF === "string" &&
        this.filtroStatoOF.trim().length > 0) ||
      (this.filtroCuiOF &&
        typeof this.filtroCuiOF === "string" &&
        this.filtroCuiOF.trim().length > 0) ||
      this.filtroVendibile
    );
  }

  // Verifica se ci sono filtri comuni attivi (regione o servizio OF)
  get hasActiveCommonFiltersOF(): boolean {
    return (
      (this.filtroRegioneOF && this.filtroRegioneOF.length > 0) ||
      (this.filtroCategoriaVincoloOF &&
        typeof this.filtroCategoriaVincoloOF === "string" &&
        this.filtroCategoriaVincoloOF.trim().length > 0)
    );
  }

  // Opzioni per il filtro SERVIZIO OF (ATTIVO / PASSIVO)
  protected opzioniCategoriaVincoloOF: { value: string; label: string }[] = [
    { value: "ATTIVO", label: "ATTIVO" },
    { value: "PASSIVO", label: "PASSIVO" },
  ];

  // Opzioni per il filtro STATO OF
  protected opzioniStatoOF: { value: string; label: string }[] = [
    { value: "LAVORABILE", label: "ESPLETATA" },
    { value: "2.1", label: "2.1 TRIPLETTA NON COMPLETA" },
    { value: "2.2", label: "2.2 OF NON VENDIBILE" },
    { value: "2.3", label: "2.3 MANCA MOC OF" },
    { value: "2.4", label: "2.4 ASSENZA SEGNALE OF" },
    { value: "2.5", label: "2.5 MANCA 1 ORDINE" },
    { value: "2.6", label: "2.6 MANCANO 2 ORDINI" },
    { value: "2.7", label: "2.7 MANCANO 3 ORDINI" },
    { value: "2.8", label: "2.8 ORDINI EMESSI" },
    { value: "2.9", label: "2.9 ORDINE ANNULLATO" },
    { value: "ALTRI", label: "ALTRI" },
    { value: "NON_CATEGORIZZATE", label: "NON CATEGORIZZATE" },
  ];

  protected activeBandoIndex: number = 1; // Default: Bando 2
  protected activeTipoIndex: number = 0;

  private collection_pratiche: string =
    environment.firebase.collection_pratiche;

  // Totali Appuntamenti/Attivazioni Bando 1
  protected totaliAppBando1: number = 0;
  protected totaliAppBando1NoAppuntamentoMancaPF_noNTW: number = 0;
  protected totaliAppBando1NoAppuntamentoMancaPF_conNTW: number = 0;
  protected totaliAppBando1NoAppuntamentoPFPronto: number = 0;
  protected totaliAppBando1AppuntamentoFissato: number = 0;
  protected totaliAppBando1AppuntamentoScaduto: number = 0;
  protected totaliAppBando1AttivazioneKO: number = 0;
  protected totaliAppBando1AttivazioneOK: number = 0;
  protected totaliAppBando1installazioneOK: number = 0;

  // Totali Appuntamenti/Attivazioni Bando 2
  protected totaliAppBando2: number = 0;
  protected totaliAppBando2NoAppuntamentoMancaPF_noNTW: number = 0;
  protected totaliAppBando2NoAppuntamentoMancaPF_conNTW: number = 0;
  protected totaliAppBando2NoAppuntamentoPFPronto: number = 0;
  protected totaliAppBando2AppuntamentoFissato: number = 0;
  protected totaliAppBando2AppuntamentoScaduto: number = 0;
  protected totaliAppBando2AttivazioneKO: number = 0;
  protected totaliAppBando2AttivazioneOK: number = 0;
  protected totaliAppBando2installazioneOK: number = 0;

  // Totali Sopralluoghi Bando 1
  protected totaliSopralluogoBando1: number = 0;
  protected totaliNoSopralluogoBando1: number = 0;
  protected totaliNoSopralluogoPFBando1: number = 0;
  protected totaliSopralluogoPianificatoBando1: number = 0;
  protected totaliSopralluogoEseguitoBando1: number = 0;
  protected totaliSopralluogoKOBando1: number = 0;

  // Totali Sopralluoghi Bando 2
  protected totaliSopralluogoBando2: number = 0;
  protected totaliNoSopralluogoBando2: number = 0;
  protected totaliNoSopralluogoPFBando2: number = 0;
  protected totaliSopralluogoPianificatoBando2: number = 0;
  protected totaliSopralluogoEseguitoBando2: number = 0;
  protected totaliSopralluogoKOBando2: number = 0;

  // Flags per tracciare se i dati sono stati caricati
  private bando1AppLoaded: boolean = false;
  private bando2AppLoaded: boolean = false;
  private bando1SopLoaded: boolean = false;
  private bando2SopLoaded: boolean = false;

  // Flag per tracciare se è il primo caricamento
  private isFirstLoad: boolean = true;

  // Flag per evitare chiamate multiple nello stesso tick
  private isLoadingBando1Sop: boolean = false;
  private isLoadingBando2Sop: boolean = false;
  private isLoadingBando1App: boolean = false;
  private isLoadingBando2App: boolean = false;

  // Proprietà per gestire i tab pending
  private pendingTipoIndex: number | null = null;
  private pendingBandoIndex: number | null = null;

  constructor(
    public auth: AuthService,
    private userService: UserService,
    public dialogService: DialogService,
    private logger: NGXLogger,
    private router: Router,
    private route: ActivatedRoute,
    private firestore: AngularFirestore,
    private cdr: ChangeDetectorRef,
    public utilService: UtilService,
    public excelService: ExcelService,
    public listeService: ListeService,
    public stiliService: StiliService,
    private messageService: MessageService,
    @Inject(DOCUMENT) private doc: Document,
  ) {}

  private resetLoadingFlags() {
    this.bando1AppLoaded = false;
    this.bando2AppLoaded = false;
    this.bando1SopLoaded = false;
    this.bando2SopLoaded = false;
    this.isLoadingBando1Sop = false;
    this.isLoadingBando2Sop = false;
    this.isLoadingBando1App = false;
    this.isLoadingBando2App = false;
  }

  ngOnInit() {
    // Prima legge i query parameters e memorizza i tab da selezionare
    //this.readTabSelectionFromQueryParams();
    //this.logger.info(`[HOME WIP] NG ON INIT CON `+ this.activeBandoNumber);
    // Se ci sono input properties già impostati, usa quelli
    if (
      (this.activeTabType !== undefined && this.activeTabType !== null) ||
      (this.activeBandoNumber !== undefined && this.activeBandoNumber !== null)
    ) {
      this.setActiveTabsFromInputs();
      this.isFirstLoad = false;
    } else {
      // Se non ci sono input properties, imposta Bando 2 come default prima di caricare i dati
      if (
        this.activeBandoNumber === undefined ||
        this.activeBandoNumber === null
      ) {
        this.activeBandoIndex = 1; // Default: Bando 2
      }
      if (this.isFirstLoad) {
        // Carica i dati solo se non sono già stati caricati da ngOnChanges
        this.loadActiveTabData();
        this.isFirstLoad = false;
      }
    }
    this.initCSVBox();
  }

  ngAfterViewInit() {
    //this.logger.info(`[HOME WIP] NG AFTER VIEW INIT CON `+ this.activeBandoNumber);
    // Imposta il tab del bando corretto basandosi su activeBandoNumber
    if (this.activeBandoNumber == 1) {
      this.activeBandoIndex = 0;
    } else if (this.activeBandoNumber == 2) {
      this.activeBandoIndex = 1;
    } else {
      // Se activeBandoNumber non è impostato, usa Bando 2 come default
      this.activeBandoIndex = 1;
    }

    // Carica i dati del tab selezionato SOLO se non sono già stati caricati in ngOnInit
    // e se activeBandoNumber è impostato ma non ci sono input properties specifici
    if (this.activeBandoNumber && this.isFirstLoad) {
      this.loadActiveTabData();
      this.isFirstLoad = false;
    }

    // Applica la selezione dei tab se presente dai query parameters
    /* if (this.pendingTipoIndex !== null || this.pendingBandoIndex !== null) {
      setTimeout(() => {
        if (this.pendingTipoIndex !== null) {
          const oldTipoIndex = this.activeTipoIndex;
          this.activeTipoIndex = this.pendingTipoIndex;
          this.logger.info(`[HOME WIP] Tab tipo applicato: ${oldTipoIndex} → ${this.activeTipoIndex}`);
        }
        
        if (this.pendingBandoIndex !== null) {
          const oldBandoIndex = this.activeBandoIndex;
          this.activeBandoIndex = this.pendingBandoIndex;
          this.logger.info(`[HOME WIP] Tab bando applicato: ${oldBandoIndex} → ${this.activeBandoIndex}`);
        }
        
        this.cdr.detectChanges();
        
        // Reset dei pending
        this.pendingTipoIndex = null;
        this.pendingBandoIndex = null;
        
        // Carica i dati del tab selezionato
        this.loadActiveTabData();
      }, 100);
    } */
  }

  readImportLog() {
    const collectionRef = this.firestore.collection(
      this.collection_importLog,
    ).ref;
    let queryErrori;
    queryErrori = collectionRef.where("id", "==", this.importID);

    onSnapshot(queryErrori, (qs) => {
      this.isLoadingApp = false;
      qs.forEach((doc) => {
        let log: ImportLog_Firestore = doc.data() as ImportLog_Firestore;
        if (!log.errori || log.errori.length == 0) {
          if (!log.warning || log.warning.length == 0) {
            let messaggio: string = "";
            if (log.numeroRecordNonProcessati != 0) {
              if (log.numeroRecordNonProcessati == 1) {
                messaggio =
                  "Delle " +
                  log.numeroTotaleRecord +
                  " pratiche presenti nel file " +
                  log.numeroRecordProcessati +
                  " sono state processate con successo mentre " +
                  log.numeroRecordNonProcessati +
                  " non è stata processata.";
              } else {
                messaggio =
                  "Delle " +
                  log.numeroTotaleRecord +
                  " pratiche presenti nel file " +
                  log.numeroRecordProcessati +
                  " sono state processate con successo mentre " +
                  log.numeroRecordNonProcessati +
                  " non sono state processate.";
              }
            } else {
              messaggio =
                "Tutte le " +
                log.numeroTotaleRecord +
                " pratiche presenti nel file sono state processate con successo. ";
              /* if(log.praticheSenzaODA && log.praticheSenzaODA!=0){
                  messaggio+= log.praticheSenzaODA+ " pratiche però risultano senza ODA."
                }  */
            }

            this.messageService.add({
              severity: "success",
              summary: "AGGIORNAMENTO SITUAZIONE OF",
              detail: messaggio,
              life: 10000,
            });
          } else {
            this.messageService.add({
              severity: "warn",
              summary: "Warning",
              detail:
                "L'aggiornamento della situazione OF si è concluso con " +
                log.numeroRecordNonProcessati +
                " warning",
              life: 10000,
            });
          }
        } else {
          this.messageService.add({
            severity: "info",
            summary: "Errore",
            detail:
              "L'aggiornamento della situazione OF si è concluso con " +
              log.numeroRecordNonProcessati +
              " errori",
            life: 10000,
          });
        }
      });
    });
    this.azzeraContatoriVincoloOF();
    this.loadDatiStatoOpenFiber();
  }

  initCSVBox() {
    this.csvbox_importer_aggiornaSituazioneOF = new CSVBoxImporter(
      this.csvbox_licenseKey_aggiornaSituazioneOF,
      {},
      (result: boolean, data: any) => {
        if (result) {
          this.readImportLog();
        }
      },
    );

    this.csvbox_importer_aggiornaSituazioneOF.setUser({
      user_id: "default123",
    });

    this.csvbox_importer_aggiornaSituazioneOF.language = "it";
  }

  private readTabSelectionFromQueryParams() {
    // Legge i query parameters per determinare quale tab selezionare
    this.route.queryParams.subscribe((params) => {
      const bando = params["bando"];
      const from = params["from"];

      if (from && bando) {
        this.logger.info(
          `[HOME WIP] Query params rilevati - from: ${from}, bando: ${bando}`,
        );

        // Determina il tipo di tab basandosi sul parametro 'from'
        if (from === "WIP") {
          // Imposta il tab per "Work In Progress" - assumiamo che sia il tab appropriato
          // Potresti voler aggiungere più logica qui per determinare se Sopralluoghi o Appuntamenti
          this.pendingTipoIndex = 0; // Default a Sopralluoghi
        }

        // Determina il bando
        const bandoNumber = parseInt(bando);
        if (bandoNumber === 1) {
          this.activeBandoIndex = 0; // Bando 1
        } else if (bandoNumber === 2) {
          this.activeBandoIndex = 1; // Bando 2
        } else {
          this.activeBandoIndex = 1; // Default: Bando 2
        }

        this.logger.info(
          `[HOME WIP] Tab da impostare - tipo: ${this.pendingTipoIndex}, bando: ${this.pendingBandoIndex}`,
        );
      }

      // Supporta anche i parametri più specifici se presenti
      /* const activeTabType = params['activeTabType'];
      const activeBandoNumber = params['activeBandoNumber'];
      
      if (activeTabType !== undefined) {
        this.pendingTipoIndex = parseInt(activeTabType);
      }
      
      if (activeBandoNumber !== undefined) {
        const bandoNum = parseInt(activeBandoNumber);
        this.activeBandoIndex = bandoNum === 1 ? 0 : bandoNum === 2 ? 1 : null;
      } */
    });
  }

  /**
   * Carica i dati per il tab attualmente attivo
   * @param forceLoad Se true, forza il caricamento anche se i dati sono già stati caricati
   */
  private loadActiveTabData(forceLoad: boolean = false) {
    // this.logger.info(`[HOME WIP] LOAD ACTIVE TAB DATA - activeTipoIndex: ${this.activeTipoIndex}, activeBandoIndex: ${this.activeBandoIndex}, forceLoad: ${forceLoad}`);

    // Se activeBandoNumber non è impostato e activeBandoIndex è ancora 0 (default iniziale), imposta Bando 2 come default
    if (
      (this.activeBandoNumber === undefined ||
        this.activeBandoNumber === null) &&
      this.activeBandoIndex === 0
    ) {
      this.activeBandoIndex = 1; // Default: Bando 2
    }

    if (this.activeTipoIndex === 0) {
      // Sopralluoghi
      if (
        this.activeBandoIndex === 0 &&
        (!this.bando1SopLoaded || forceLoad) &&
        !this.isLoadingBando1Sop
      ) {
        this.loadDatiBando1Sop();
      } else if (
        this.activeBandoIndex === 1 &&
        (!this.bando2SopLoaded || forceLoad) &&
        !this.isLoadingBando2Sop
      ) {
        this.loadDatiBando2Sop();
      }
    } else if (this.activeTipoIndex === 1) {
      // Appuntamenti/Attivazioni
      if (
        this.activeBandoIndex === 0 &&
        (!this.bando1AppLoaded || forceLoad) &&
        !this.isLoadingBando1App
      ) {
        this.loadDatiBando1App();
      } else if (
        this.activeBandoIndex === 1 &&
        (!this.bando2AppLoaded || forceLoad) &&
        !this.isLoadingBando2App
      ) {
        this.loadDatiBando2App();
      }
    } else if (this.activeTipoIndex === 2) {
      // Stato Open Fiber
      this.loadDatiStatoOpenFiber();
    }
  }

  loadDatiStatoOpenFiber() {
    this.logger.info("[HOME WIP] LOAD DATI STATO OPEN FIBER");
    this.isLoadingApp = true;
    this.bando1AppLoaded = true; // Imposta subito per evitare chiamate multiple

    const collectionRef = this.firestore.collection(
      this.collection_pratiche,
    ).ref;
    let queryStatoOpenFiber = collectionRef.where(
      "tipoSedeEffettiva",
      "==",
      "C",
    );
    onSnapshot(queryStatoOpenFiber, (qs) => {
      this.isLoadingApp = false;

      // Reset delle variabili vincolo OF PRIMA di processare i nuovi dati
      // Questo assicura che ogni volta che arrivano nuovi dati da Firestore,
      // i contatori vengono azzerati e ricalcolati da zero
      this.resetVincoloOFBando2();

      // Reset array pratiche con lotti non validi
      this.praticheLottoNonValido = [];

      // Reset array pratiche non categorizzate
      this.praticheNonCategorizzate = [];

      this.praticheTipoC = qs.docs.map(
        (doc) => doc.data() as PraticaFlowdy2_Firestore,
      );
      // this.logger.info("[HOME WIP] LOAD DATI STATO OPEN FIBER - LE PRATICHE DI TIPO C SONO: "+ this.praticheTipoC.length);

      // Applica filtri se presenti (solo REGIONE per il complessivo)
      let praticheDaProcessare = this.praticheTipoC;
      if (this.filtroRegioneOF && this.filtroRegioneOF.length > 0) {
        praticheDaProcessare = praticheDaProcessare.filter((p) =>
          this.filtroRegioneOF.includes(p.regione),
        );
      }

      // Calcola i vincoli OF per ogni pratica filtrata (complessivo)
      praticheDaProcessare.forEach((pratica) => {
        this.loadDatiVincoloOF(pratica);
      });
      this.logger.info(
        "[HOME WIP] LOAD DATI STATO OPEN FIBER - LE PRATICHE DI TIPO C SONO: " +
          this.praticheTipoC.length,
      );

      // Log pratiche con lotti non validi
      if (this.praticheLottoNonValido.length > 0) {
        this.logger.warn(
          `[HOME WIP] TROVATE ${this.praticheLottoNonValido.length} PRATICHE CON LOTTO NON VALIDO (non 1, 5, 7 o 8):`,
        );
        this.praticheLottoNonValido.forEach((pratica) => {
          this.logger.warn(
            `[HOME WIP] - CUI: ${pratica.cui}, Lotto: "${pratica.lotto}", Regione: ${pratica.regione}, Azienda: ${pratica.azienda}`,
          );
        });
      } else {
        this.logger.info(
          "[HOME WIP] TUTTE LE PRATICHE HANNO UN LOTTO VALIDO (1, 5, 7 o 8)",
        );
      }

      // Prepara i dati per la tabella COMPLESSIVO
      this.prepareVincoliOFData();

      // Aggiorna le pratiche filtrate per la tabella PRATICHE (regione + statoOF)
      this.updatePraticheTipoCFiltrate();

      this.cdr.detectChanges();
    });
  }

  private resetVincoloOFBando2() {
    this.vincoloOFBando2 = 0;
    this.vincoloOFBando2Lotto1 = 0;
    this.vincoloOFBando2Lotto5 = 0;
    this.vincoloOFBando2Lotto7 = 0;
    this.vincoloOFBando2Lotto8 = 0;

    this.vincoloOFBando2_2_1 = 0;
    this.vincoloOFBando2_2_1_Lotto1 = 0;
    this.vincoloOFBando2_2_1_Lotto5 = 0;
    this.vincoloOFBando2_2_1_Lotto7 = 0;
    this.vincoloOFBando2_2_1_Lotto8 = 0;

    this.vincoloOFBando2_2_2 = 0;
    this.vincoloOFBando2_2_2_Lotto1 = 0;
    this.vincoloOFBando2_2_2_Lotto5 = 0;
    this.vincoloOFBando2_2_2_Lotto7 = 0;
    this.vincoloOFBando2_2_2_Lotto8 = 0;

    this.vincoloOFBando2_2_3 = 0;
    this.vincoloOFBando2_2_3_Lotto1 = 0;
    this.vincoloOFBando2_2_3_Lotto5 = 0;
    this.vincoloOFBando2_2_3_Lotto7 = 0;
    this.vincoloOFBando2_2_3_Lotto8 = 0;

    this.vincoloOFBando2_2_4 = 0;
    this.vincoloOFBando2_2_4_Lotto1 = 0;
    this.vincoloOFBando2_2_4_Lotto5 = 0;
    this.vincoloOFBando2_2_4_Lotto7 = 0;
    this.vincoloOFBando2_2_4_Lotto8 = 0;

    this.vincoloOFBando2_2_5 = 0;
    this.vincoloOFBando2_2_5_Lotto1 = 0;
    this.vincoloOFBando2_2_5_Lotto5 = 0;
    this.vincoloOFBando2_2_5_Lotto7 = 0;
    this.vincoloOFBando2_2_5_Lotto8 = 0;

    this.vincoloOFBando2_2_6 = 0;
    this.vincoloOFBando2_2_6_Lotto1 = 0;
    this.vincoloOFBando2_2_6_Lotto5 = 0;
    this.vincoloOFBando2_2_6_Lotto7 = 0;
    this.vincoloOFBando2_2_6_Lotto8 = 0;

    this.vincoloOFBando2_2_7 = 0;
    this.vincoloOFBando2_2_7_Lotto1 = 0;
    this.vincoloOFBando2_2_7_Lotto5 = 0;
    this.vincoloOFBando2_2_7_Lotto7 = 0;
    this.vincoloOFBando2_2_7_Lotto8 = 0;

    this.vincoloOFBando2_2_8 = 0;
    this.vincoloOFBando2_2_8_Lotto1 = 0;
    this.vincoloOFBando2_2_8_Lotto5 = 0;
    this.vincoloOFBando2_2_8_Lotto7 = 0;
    this.vincoloOFBando2_2_8_Lotto8 = 0;

    this.vincoloOFBando2_2_9 = 0;
    this.vincoloOFBando2_2_9_Lotto1 = 0;
    this.vincoloOFBando2_2_9_Lotto5 = 0;
    this.vincoloOFBando2_2_9_Lotto7 = 0;
    this.vincoloOFBando2_2_9_Lotto8 = 0;

    // Reset contatori ATTIVO, PASSIVO e SENZA SERVIZIO
    this.vincoloOFBando2_2_1_Attivo = 0;
    this.vincoloOFBando2_2_1_Passivo = 0;
    this.vincoloOFBando2_2_1_SenzaServizio = 0;
    this.vincoloOFBando2_2_2_Attivo = 0;
    this.vincoloOFBando2_2_2_Passivo = 0;
    this.vincoloOFBando2_2_2_SenzaServizio = 0;
    this.vincoloOFBando2_2_3_Attivo = 0;
    this.vincoloOFBando2_2_3_Passivo = 0;
    this.vincoloOFBando2_2_3_SenzaServizio = 0;
    this.vincoloOFBando2_2_4_Attivo = 0;
    this.vincoloOFBando2_2_4_Passivo = 0;
    this.vincoloOFBando2_2_4_SenzaServizio = 0;
    this.vincoloOFBando2_2_5_Attivo = 0;
    this.vincoloOFBando2_2_5_Passivo = 0;
    this.vincoloOFBando2_2_5_SenzaServizio = 0;
    this.vincoloOFBando2_2_6_Attivo = 0;
    this.vincoloOFBando2_2_6_Passivo = 0;
    this.vincoloOFBando2_2_6_SenzaServizio = 0;
    this.vincoloOFBando2_2_7_Attivo = 0;
    this.vincoloOFBando2_2_7_Passivo = 0;
    this.vincoloOFBando2_2_7_SenzaServizio = 0;
    this.vincoloOFBando2_2_8_Attivo = 0;
    this.vincoloOFBando2_2_8_Passivo = 0;
    this.vincoloOFBando2_2_8_SenzaServizio = 0;
    this.vincoloOFBando2_2_9_Attivo = 0;
    this.vincoloOFBando2_2_9_Passivo = 0;
    this.vincoloOFBando2_2_9_SenzaServizio = 0;

    // Reset contatori ATTIVATE, RILASCIATE FIBERCOP e IN ATTESA per categoria
    this.vincoloOFBando2_2_1_Attivate = 0;
    this.vincoloOFBando2_2_1_RilasciateFibercop = 0;
    this.vincoloOFBando2_2_1_InAttesa = 0;
    this.vincoloOFBando2_2_1_Null = 0;
    this.vincoloOFBando2_2_2_Attivate = 0;
    this.vincoloOFBando2_2_2_RilasciateFibercop = 0;
    this.vincoloOFBando2_2_2_InAttesa = 0;
    this.vincoloOFBando2_2_2_Null = 0;
    this.vincoloOFBando2_2_3_Attivate = 0;
    this.vincoloOFBando2_2_3_RilasciateFibercop = 0;
    this.vincoloOFBando2_2_3_InAttesa = 0;
    this.vincoloOFBando2_2_3_Null = 0;
    this.vincoloOFBando2_2_4_Attivate = 0;
    this.vincoloOFBando2_2_4_RilasciateFibercop = 0;
    this.vincoloOFBando2_2_4_InAttesa = 0;
    this.vincoloOFBando2_2_4_Null = 0;
    this.vincoloOFBando2_2_5_Attivate = 0;
    this.vincoloOFBando2_2_5_RilasciateFibercop = 0;
    this.vincoloOFBando2_2_5_InAttesa = 0;
    this.vincoloOFBando2_2_5_Null = 0;
    this.vincoloOFBando2_2_6_Attivate = 0;
    this.vincoloOFBando2_2_6_RilasciateFibercop = 0;
    this.vincoloOFBando2_2_6_InAttesa = 0;
    this.vincoloOFBando2_2_6_Null = 0;
    this.vincoloOFBando2_2_7_Attivate = 0;
    this.vincoloOFBando2_2_7_RilasciateFibercop = 0;
    this.vincoloOFBando2_2_7_InAttesa = 0;
    this.vincoloOFBando2_2_7_Null = 0;
    this.vincoloOFBando2_2_8_Attivate = 0;
    this.vincoloOFBando2_2_8_RilasciateFibercop = 0;
    this.vincoloOFBando2_2_8_InAttesa = 0;
    this.vincoloOFBando2_2_8_Null = 0;
    this.vincoloOFBando2_2_9_Attivate = 0;
    this.vincoloOFBando2_2_9_RilasciateFibercop = 0;
    this.vincoloOFBando2_2_9_InAttesa = 0;
    this.vincoloOFBando2_2_9_Null = 0;

    // Reset totali ATTIVO, PASSIVO e SENZA SERVIZIO complessivi
    this.vincoloOFBando2_Attivo = 0;
    this.vincoloOFBando2_Passivo = 0;
    this.vincoloOFBando2_SenzaServizio = 0;

    // Reset contatori ATTIVATE, RILASCIATE FIBERCOP e IN ATTESA
    this.vincoloOFBando2_Attivate = 0;
    this.vincoloOFBando2_RilasciateFibercop = 0;
    this.vincoloOFBando2_InAttesa = 0;
    this.vincoloOFBando2_Null = 0;

    // Reset contatori LAVORABILI
    this.vincoloOFBando2_Lavorabili = 0;
    this.vincoloOFBando2_Lavorabili_Lotto1 = 0;
    this.vincoloOFBando2_Lavorabili_Lotto5 = 0;
    this.vincoloOFBando2_Lavorabili_Lotto7 = 0;
    this.vincoloOFBando2_Lavorabili_Lotto8 = 0;
    this.vincoloOFBando2_Lavorabili_Attivo = 0;
    this.vincoloOFBando2_Lavorabili_Passivo = 0;
    this.vincoloOFBando2_Lavorabili_SenzaServizio = 0;
    this.vincoloOFBando2_Lavorabili_Attivate = 0;
    this.vincoloOFBando2_Lavorabili_RilasciateFibercop = 0;
    this.vincoloOFBando2_Lavorabili_InAttesa = 0;
    this.vincoloOFBando2_Lavorabili_Null = 0;

    // Reset contatori VINCOLO FIBERCOP (vincoloTipologiaID = 1)
    this.vincoloOFBando2_Fibercop = 0;
    this.vincoloOFBando2_Fibercop_Lotto1 = 0;
    this.vincoloOFBando2_Fibercop_Lotto5 = 0;
    this.vincoloOFBando2_Fibercop_Lotto7 = 0;
    this.vincoloOFBando2_Fibercop_Lotto8 = 0;
    this.vincoloOFBando2_Fibercop_Attivo = 0;
    this.vincoloOFBando2_Fibercop_Passivo = 0;
    this.vincoloOFBando2_Fibercop_SenzaServizio = 0;
    this.vincoloOFBando2_Fibercop_Attivate = 0;
    this.vincoloOFBando2_Fibercop_RilasciateFibercop = 0;
    this.vincoloOFBando2_Fibercop_InAttesa = 0;
    this.vincoloOFBando2_Fibercop_Null = 0;

    // Reset contatori VINCOLO INFRATEL (vincoloTipologiaID = 3)
    this.vincoloOFBando2_Infratel = 0;
    this.vincoloOFBando2_Infratel_Lotto1 = 0;
    this.vincoloOFBando2_Infratel_Lotto5 = 0;
    this.vincoloOFBando2_Infratel_Lotto7 = 0;
    this.vincoloOFBando2_Infratel_Lotto8 = 0;
    this.vincoloOFBando2_Infratel_Attivo = 0;
    this.vincoloOFBando2_Infratel_Passivo = 0;
    this.vincoloOFBando2_Infratel_SenzaServizio = 0;
    this.vincoloOFBando2_Infratel_Attivate = 0;
    this.vincoloOFBando2_Infratel_RilasciateFibercop = 0;
    this.vincoloOFBando2_Infratel_InAttesa = 0;
    this.vincoloOFBando2_Infratel_Null = 0;

    // Reset contatori FUORI PERIMETRO (vincoloTipologiaID = 4)
    this.vincoloOFBando2_FuoriPerimetro = 0;
    this.vincoloOFBando2_FuoriPerimetro_Lotto1 = 0;
    this.vincoloOFBando2_FuoriPerimetro_Lotto5 = 0;
    this.vincoloOFBando2_FuoriPerimetro_Lotto7 = 0;
    this.vincoloOFBando2_FuoriPerimetro_Lotto8 = 0;
    this.vincoloOFBando2_FuoriPerimetro_Attivo = 0;
    this.vincoloOFBando2_FuoriPerimetro_Passivo = 0;
    this.vincoloOFBando2_FuoriPerimetro_SenzaServizio = 0;
    this.vincoloOFBando2_FuoriPerimetro_Attivate = 0;
    this.vincoloOFBando2_FuoriPerimetro_RilasciateFibercop = 0;
    this.vincoloOFBando2_FuoriPerimetro_InAttesa = 0;
    this.vincoloOFBando2_FuoriPerimetro_Null = 0;
  }

  /**
   * Verifica se una pratica è categorizzata in una delle categorie note
   */
  private isPraticaCategorizzata(pratica: PraticaFlowdy2_Firestore): boolean {
    const statoOFTrimmed = pratica.statoOF
      ? pratica.statoOF.trim().toUpperCase()
      : null;

    // PRIORITÀ 1: Se statoOF = 'LAVORABILE', è sempre categorizzata come LAVORABILE
    // indipendentemente da vincoloTipologiaID o altri fattori
    if (statoOFTrimmed === "LAVORABILE") {
      return true;
    }

    const vincoloTipologiaIDNum =
      pratica.vincoloTipologiaID != null
        ? Number(pratica.vincoloTipologiaID)
        : null;

    // PRIORITÀ 2: Verifica VINCOLO FIBERCOP (vincoloTipologiaID = 1 con categoria 1.1-1.4)
    if (vincoloTipologiaIDNum === 1) {
      const categoriaCodice = pratica.vincoloCategoriaCodice;
      if (
        categoriaCodice === "1.1" ||
        categoriaCodice === "1.2" ||
        categoriaCodice === "1.3" ||
        categoriaCodice === "1.4"
      ) {
        return true;
      }
    }

    // PRIORITÀ 3: Verifica VINCOLO INFRATEL (vincoloTipologiaID = 3)
    if (vincoloTipologiaIDNum === 3) {
      return true;
    }

    // PRIORITÀ 4: Verifica FUORI PERIMETRO (vincoloTipologiaID = 4)
    if (vincoloTipologiaIDNum === 4) {
      return true;
    }

    // PRIORITÀ 5: Verifica categorie 2.1-2.9
    const categoriaCodice = pratica.vincoloCategoriaCodice;
    if (
      categoriaCodice === "2.1" ||
      categoriaCodice === "2.2" ||
      categoriaCodice === "2.3" ||
      categoriaCodice === "2.4" ||
      categoriaCodice === "2.5" ||
      categoriaCodice === "2.6" ||
      categoriaCodice === "2.7" ||
      categoriaCodice === "2.8" ||
      categoriaCodice === "2.9"
    ) {
      return true;
    }

    return false;
  }

  /**
   * Determina se una pratica appartiene a una specifica categoria (es. '2.1', '2.2', etc.)
   * usando la stessa logica di categorizzazione di loadDatiVincoloOF
   */
  private appartieneACategoria(
    pratica: PraticaFlowdy2_Firestore,
    categoriaCodice: string,
  ): boolean {
    const statoOFTrimmed = pratica.statoOF
      ? pratica.statoOF.trim().toUpperCase()
      : null;

    // PRIORITÀ 1: Se statoOF = 'LAVORABILE', non appartiene a nessuna categoria 2.x
    if (statoOFTrimmed === "LAVORABILE") {
      return false;
    }

    const vincoloTipologiaIDNum =
      pratica.vincoloTipologiaID != null
        ? Number(pratica.vincoloTipologiaID)
        : null;

    // PRIORITÀ 2: Se è VINCOLO FIBERCOP (vincoloTipologiaID = 1 con categoria 1.1-1.4), non appartiene a 2.x
    if (vincoloTipologiaIDNum === 1) {
      const catCodice = pratica.vincoloCategoriaCodice;
      if (
        catCodice === "1.1" ||
        catCodice === "1.2" ||
        catCodice === "1.3" ||
        catCodice === "1.4"
      ) {
        return false;
      }
    }

    // PRIORITÀ 3: Se è VINCOLO INFRATEL (vincoloTipologiaID = 3), non appartiene a 2.x
    if (vincoloTipologiaIDNum === 3) {
      return false;
    }

    // PRIORITÀ 4: Se è FUORI PERIMETRO (vincoloTipologiaID = 4), non appartiene a 2.x
    if (vincoloTipologiaIDNum === 4) {
      return false;
    }

    // PRIORITÀ 5: Verifica se la categoria corrisponde
    // La pratica appartiene alla categoria se vincoloCategoriaCodice corrisponde
    // OPPURE se statoOF inizia con il codice della categoria (es. "2.1" o "2.1 TRIPLETTA NON COMPLETA")
    const praticaCategoriaCodice = pratica.vincoloCategoriaCodice;
    if (praticaCategoriaCodice === categoriaCodice) {
      return true;
    }

    // Verifica anche se statoOF inizia con il codice della categoria
    if (statoOFTrimmed && statoOFTrimmed.startsWith(categoriaCodice)) {
      return true;
    }

    return false;
  }

  /**
   * Spiega perché una pratica non è categorizzata
   */
  private getMotivoNonCategorizzata(pratica: PraticaFlowdy2_Firestore): string {
    const vincoloTipologiaIDNum =
      pratica.vincoloTipologiaID != null
        ? Number(pratica.vincoloTipologiaID)
        : null;
    const statoOFTrimmed = pratica.statoOF
      ? pratica.statoOF.trim().toUpperCase()
      : null;
    const categoriaCodice = pratica.vincoloCategoriaCodice;

    const motivi: string[] = [];

    // Se statoOF = 'LAVORABILE', dovrebbe sempre essere categorizzata
    // Se arriva qui con statoOF = 'LAVORABILE', significa che c'è un bug nella logica
    if (statoOFTrimmed === "LAVORABILE") {
      motivi.push(
        'statoOF="LAVORABILE" ma non categorizzata (BUG: dovrebbe essere sempre categorizzata come LAVORABILE)',
      );
      return motivi.join("; ");
    }

    // Analizza statoOF
    if (!statoOFTrimmed) {
      motivi.push("statoOF è NULL o vuoto");
    } else {
      motivi.push(`statoOF="${pratica.statoOF}" (non è "LAVORABILE")`);
    }

    // Analizza vincoloTipologiaID
    if (vincoloTipologiaIDNum === null) {
      motivi.push("vincoloTipologiaID è NULL");
    } else if (vincoloTipologiaIDNum === 1) {
      if (
        !categoriaCodice ||
        (categoriaCodice !== "1.1" &&
          categoriaCodice !== "1.2" &&
          categoriaCodice !== "1.3" &&
          categoriaCodice !== "1.4")
      ) {
        motivi.push(
          `vincoloTipologiaID=1 ma vincoloCategoriaCodice="${categoriaCodice || "NULL"}" (atteso: 1.1, 1.2, 1.3 o 1.4 per VINCOLO FIBERCOP)`,
        );
      } else {
        motivi.push(
          "vincoloTipologiaID=1 con categoria 1.1-1.4 ma non categorizzata come VINCOLO FIBERCOP (possibile bug)",
        );
      }
    } else if (vincoloTipologiaIDNum === 2) {
      motivi.push(
        "vincoloTipologiaID=2 (non gestito come categoria specifica)",
      );
    } else if (vincoloTipologiaIDNum === 3) {
      motivi.push(
        "vincoloTipologiaID=3 ma non categorizzata come VINCOLO INFRATEL (possibile bug)",
      );
    } else if (vincoloTipologiaIDNum === 4) {
      motivi.push(
        "vincoloTipologiaID=4 ma non categorizzata come FUORI PERIMETRO (possibile bug)",
      );
    } else {
      motivi.push(
        `vincoloTipologiaID="${vincoloTipologiaIDNum}" (valore non riconosciuto)`,
      );
    }

    // Analizza vincoloCategoriaCodice
    if (!categoriaCodice) {
      motivi.push("vincoloCategoriaCodice è NULL o vuoto");
    } else if (
      categoriaCodice === "2.1" ||
      categoriaCodice === "2.2" ||
      categoriaCodice === "2.3" ||
      categoriaCodice === "2.4" ||
      categoriaCodice === "2.5" ||
      categoriaCodice === "2.6" ||
      categoriaCodice === "2.7" ||
      categoriaCodice === "2.8" ||
      categoriaCodice === "2.9"
    ) {
      motivi.push(
        `vincoloCategoriaCodice="${categoriaCodice}" ma non categorizzata (possibile bug)`,
      );
    } else {
      motivi.push(
        `vincoloCategoriaCodice="${categoriaCodice}" (non è 2.1-2.9)`,
      );
    }

    return motivi.join("; ");
  }

  private prepareVincoliOFData() {
    this.vincoliOFData = [];

    // Aggiungi riga ESPLETATE in testa se ci sono casi
    if (this.vincoloOFBando2_Lavorabili > 0) {
      this.vincoliOFData.push({
        categoria: "ESPLETATE",
        lotto1: this.vincoloOFBando2_Lavorabili_Lotto1,
        lotto5: this.vincoloOFBando2_Lavorabili_Lotto5,
        lotto7: this.vincoloOFBando2_Lavorabili_Lotto7,
        lotto8: this.vincoloOFBando2_Lavorabili_Lotto8,
        totale: this.vincoloOFBando2_Lavorabili,
        attivo: this.vincoloOFBando2_Lavorabili_Attivo,
        passivo: this.vincoloOFBando2_Lavorabili_Passivo,
        senzaServizio: this.vincoloOFBando2_Lavorabili_SenzaServizio,
        inAttesa:
          (this.vincoloOFBando2_Lavorabili_Null || 0) +
          (this.vincoloOFBando2_Lavorabili_InAttesa || 0),
        attivate: this.vincoloOFBando2_Lavorabili_Attivate,
        rilasciateFibercop: this.vincoloOFBando2_Lavorabili_RilasciateFibercop,
      });
    }

    // Aggiungi le categorie 2.1-2.9
    this.vincoliOFData.push(
      {
        categoria: "2.1 TRIPLETTA NON COMPLETA",
        lotto1: this.vincoloOFBando2_2_1_Lotto1,
        lotto5: this.vincoloOFBando2_2_1_Lotto5,
        lotto7: this.vincoloOFBando2_2_1_Lotto7,
        lotto8: this.vincoloOFBando2_2_1_Lotto8,
        totale: this.vincoloOFBando2_2_1,
        attivo: this.vincoloOFBando2_2_1_Attivo,
        passivo: this.vincoloOFBando2_2_1_Passivo,
        senzaServizio: this.vincoloOFBando2_2_1_SenzaServizio,
        inAttesa:
          (this.vincoloOFBando2_2_1_Null || 0) +
          (this.vincoloOFBando2_2_1_InAttesa || 0),
        attivate: this.vincoloOFBando2_2_1_Attivate,
        rilasciateFibercop: this.vincoloOFBando2_2_1_RilasciateFibercop,
      },
      {
        categoria: "2.2 OF NON VENDIBILE",
        lotto1: this.vincoloOFBando2_2_2_Lotto1,
        lotto5: this.vincoloOFBando2_2_2_Lotto5,
        lotto7: this.vincoloOFBando2_2_2_Lotto7,
        lotto8: this.vincoloOFBando2_2_2_Lotto8,
        totale: this.vincoloOFBando2_2_2,
        attivo: this.vincoloOFBando2_2_2_Attivo,
        passivo: this.vincoloOFBando2_2_2_Passivo,
        senzaServizio: this.vincoloOFBando2_2_2_SenzaServizio,
        inAttesa:
          (this.vincoloOFBando2_2_2_Null || 0) +
          (this.vincoloOFBando2_2_2_InAttesa || 0),
        attivate: this.vincoloOFBando2_2_2_Attivate,
        rilasciateFibercop: this.vincoloOFBando2_2_2_RilasciateFibercop,
      },
      {
        categoria: "2.3 MANCA MOC OF",
        lotto1: this.vincoloOFBando2_2_3_Lotto1,
        lotto5: this.vincoloOFBando2_2_3_Lotto5,
        lotto7: this.vincoloOFBando2_2_3_Lotto7,
        lotto8: this.vincoloOFBando2_2_3_Lotto8,
        totale: this.vincoloOFBando2_2_3,
        attivo: this.vincoloOFBando2_2_3_Attivo,
        passivo: this.vincoloOFBando2_2_3_Passivo,
        senzaServizio: this.vincoloOFBando2_2_3_SenzaServizio,
        inAttesa:
          (this.vincoloOFBando2_2_3_Null || 0) +
          (this.vincoloOFBando2_2_3_InAttesa || 0),
        attivate: this.vincoloOFBando2_2_3_Attivate,
        rilasciateFibercop: this.vincoloOFBando2_2_3_RilasciateFibercop,
      },
      {
        categoria: "2.4 ASSENZA SEGNALE OF",
        lotto1: this.vincoloOFBando2_2_4_Lotto1,
        lotto5: this.vincoloOFBando2_2_4_Lotto5,
        lotto7: this.vincoloOFBando2_2_4_Lotto7,
        lotto8: this.vincoloOFBando2_2_4_Lotto8,
        totale: this.vincoloOFBando2_2_4,
        attivo: this.vincoloOFBando2_2_4_Attivo,
        passivo: this.vincoloOFBando2_2_4_Passivo,
        senzaServizio: this.vincoloOFBando2_2_4_SenzaServizio,
        inAttesa:
          (this.vincoloOFBando2_2_4_Null || 0) +
          (this.vincoloOFBando2_2_4_InAttesa || 0),
        attivate: this.vincoloOFBando2_2_4_Attivate,
        rilasciateFibercop: this.vincoloOFBando2_2_4_RilasciateFibercop,
      },
      {
        categoria: "2.5 MANCANO 1 ORDINE",
        lotto1: this.vincoloOFBando2_2_5_Lotto1,
        lotto5: this.vincoloOFBando2_2_5_Lotto5,
        lotto7: this.vincoloOFBando2_2_5_Lotto7,
        lotto8: this.vincoloOFBando2_2_5_Lotto8,
        totale: this.vincoloOFBando2_2_5,
        attivo: this.vincoloOFBando2_2_5_Attivo,
        passivo: this.vincoloOFBando2_2_5_Passivo,
        senzaServizio: this.vincoloOFBando2_2_5_SenzaServizio,
        inAttesa:
          (this.vincoloOFBando2_2_5_Null || 0) +
          (this.vincoloOFBando2_2_5_InAttesa || 0),
        attivate: this.vincoloOFBando2_2_5_Attivate,
        rilasciateFibercop: this.vincoloOFBando2_2_5_RilasciateFibercop,
      },
      {
        categoria: "2.6 MANCANO 2 ORDINI",
        lotto1: this.vincoloOFBando2_2_6_Lotto1,
        lotto5: this.vincoloOFBando2_2_6_Lotto5,
        lotto7: this.vincoloOFBando2_2_6_Lotto7,
        lotto8: this.vincoloOFBando2_2_6_Lotto8,
        totale: this.vincoloOFBando2_2_6,
        attivo: this.vincoloOFBando2_2_6_Attivo,
        passivo: this.vincoloOFBando2_2_6_Passivo,
        senzaServizio: this.vincoloOFBando2_2_6_SenzaServizio,
        inAttesa:
          (this.vincoloOFBando2_2_6_Null || 0) +
          (this.vincoloOFBando2_2_6_InAttesa || 0),
        attivate: this.vincoloOFBando2_2_6_Attivate,
        rilasciateFibercop: this.vincoloOFBando2_2_6_RilasciateFibercop,
      },
      {
        categoria: "2.7 MANCANO 3 ORDINI",
        lotto1: this.vincoloOFBando2_2_7_Lotto1,
        lotto5: this.vincoloOFBando2_2_7_Lotto5,
        lotto7: this.vincoloOFBando2_2_7_Lotto7,
        lotto8: this.vincoloOFBando2_2_7_Lotto8,
        totale: this.vincoloOFBando2_2_7,
        attivo: this.vincoloOFBando2_2_7_Attivo,
        passivo: this.vincoloOFBando2_2_7_Passivo,
        senzaServizio: this.vincoloOFBando2_2_7_SenzaServizio,
        inAttesa:
          (this.vincoloOFBando2_2_7_Null || 0) +
          (this.vincoloOFBando2_2_7_InAttesa || 0),
        attivate: this.vincoloOFBando2_2_7_Attivate,
        rilasciateFibercop: this.vincoloOFBando2_2_7_RilasciateFibercop,
      },
      {
        categoria: "2.8 ORDINI EMESSI",
        lotto1: this.vincoloOFBando2_2_8_Lotto1,
        lotto5: this.vincoloOFBando2_2_8_Lotto5,
        lotto7: this.vincoloOFBando2_2_8_Lotto7,
        lotto8: this.vincoloOFBando2_2_8_Lotto8,
        totale: this.vincoloOFBando2_2_8,
        attivo: this.vincoloOFBando2_2_8_Attivo,
        passivo: this.vincoloOFBando2_2_8_Passivo,
        senzaServizio: this.vincoloOFBando2_2_8_SenzaServizio,
        inAttesa:
          (this.vincoloOFBando2_2_8_Null || 0) +
          (this.vincoloOFBando2_2_8_InAttesa || 0),
        attivate: this.vincoloOFBando2_2_8_Attivate,
        rilasciateFibercop: this.vincoloOFBando2_2_8_RilasciateFibercop,
      },
      {
        categoria: "2.9 ORDINE ANNULLATO",
        lotto1: this.vincoloOFBando2_2_9_Lotto1,
        lotto5: this.vincoloOFBando2_2_9_Lotto5,
        lotto7: this.vincoloOFBando2_2_9_Lotto7,
        lotto8: this.vincoloOFBando2_2_9_Lotto8,
        totale: this.vincoloOFBando2_2_9,
        attivo: this.vincoloOFBando2_2_9_Attivo,
        passivo: this.vincoloOFBando2_2_9_Passivo,
        senzaServizio: this.vincoloOFBando2_2_9_SenzaServizio,
        inAttesa:
          (this.vincoloOFBando2_2_9_Null || 0) +
          (this.vincoloOFBando2_2_9_InAttesa || 0),
        attivate: this.vincoloOFBando2_2_9_Attivate,
        rilasciateFibercop: this.vincoloOFBando2_2_9_RilasciateFibercop,
      },
    );

    // Aggiungi riga VINCOLO FIBERCOP solo se ci sono casi da mostrare
    if (this.vincoloOFBando2_Fibercop > 0) {
      this.vincoliOFData.push({
        categoria: "VINCOLO FIBERCOP",
        lotto1: this.vincoloOFBando2_Fibercop_Lotto1,
        lotto5: this.vincoloOFBando2_Fibercop_Lotto5,
        lotto7: this.vincoloOFBando2_Fibercop_Lotto7,
        lotto8: this.vincoloOFBando2_Fibercop_Lotto8,
        totale: this.vincoloOFBando2_Fibercop,
        attivo: this.vincoloOFBando2_Fibercop_Attivo,
        passivo: this.vincoloOFBando2_Fibercop_Passivo,
        senzaServizio: this.vincoloOFBando2_Fibercop_SenzaServizio,
        inAttesa:
          (this.vincoloOFBando2_Fibercop_Null || 0) +
          (this.vincoloOFBando2_Fibercop_InAttesa || 0),
        attivate: this.vincoloOFBando2_Fibercop_Attivate,
        rilasciateFibercop: this.vincoloOFBando2_Fibercop_RilasciateFibercop,
      });
    }

    // Aggiungi riga VINCOLO INFRATEL solo se ci sono casi da mostrare
    if (this.vincoloOFBando2_Infratel > 0) {
      this.vincoliOFData.push({
        categoria: "VINCOLO INFRATEL",
        lotto1: this.vincoloOFBando2_Infratel_Lotto1,
        lotto5: this.vincoloOFBando2_Infratel_Lotto5,
        lotto7: this.vincoloOFBando2_Infratel_Lotto7,
        lotto8: this.vincoloOFBando2_Infratel_Lotto8,
        totale: this.vincoloOFBando2_Infratel,
        attivo: this.vincoloOFBando2_Infratel_Attivo,
        passivo: this.vincoloOFBando2_Infratel_Passivo,
        senzaServizio: this.vincoloOFBando2_Infratel_SenzaServizio,
        inAttesa:
          (this.vincoloOFBando2_Infratel_Null || 0) +
          (this.vincoloOFBando2_Infratel_InAttesa || 0),
        attivate: this.vincoloOFBando2_Infratel_Attivate,
        rilasciateFibercop: this.vincoloOFBando2_Infratel_RilasciateFibercop,
      });
    }

    // Aggiungi riga FUORI PERIMETRO solo se ci sono casi da mostrare
    if (this.vincoloOFBando2_FuoriPerimetro > 0) {
      this.vincoliOFData.push({
        categoria: "FUORI PERIMETRO",
        lotto1: this.vincoloOFBando2_FuoriPerimetro_Lotto1,
        lotto5: this.vincoloOFBando2_FuoriPerimetro_Lotto5,
        lotto7: this.vincoloOFBando2_FuoriPerimetro_Lotto7,
        lotto8: this.vincoloOFBando2_FuoriPerimetro_Lotto8,
        totale: this.vincoloOFBando2_FuoriPerimetro,
        attivo: this.vincoloOFBando2_FuoriPerimetro_Attivo,
        passivo: this.vincoloOFBando2_FuoriPerimetro_Passivo,
        senzaServizio: this.vincoloOFBando2_FuoriPerimetro_SenzaServizio,
        inAttesa:
          (this.vincoloOFBando2_FuoriPerimetro_Null || 0) +
          (this.vincoloOFBando2_FuoriPerimetro_InAttesa || 0),
        attivate: this.vincoloOFBando2_FuoriPerimetro_Attivate,
        rilasciateFibercop:
          this.vincoloOFBando2_FuoriPerimetro_RilasciateFibercop,
      });
    }

    // Calcola la somma di tutte le categorie categorizzate
    const totaleCategorizzate =
      this.vincoloOFBando2_Lavorabili +
      this.vincoloOFBando2_2_1 +
      this.vincoloOFBando2_2_2 +
      this.vincoloOFBando2_2_3 +
      this.vincoloOFBando2_2_4 +
      this.vincoloOFBando2_2_5 +
      this.vincoloOFBando2_2_6 +
      this.vincoloOFBando2_2_7 +
      this.vincoloOFBando2_2_8 +
      this.vincoloOFBando2_2_9 +
      this.vincoloOFBando2_Fibercop +
      this.vincoloOFBando2_Infratel +
      this.vincoloOFBando2_FuoriPerimetro;

    // Calcola le pratiche non categorizzate (differenza tra totale e categorie)
    const praticheNonCategorizzate = this.vincoloOFBando2 - totaleCategorizzate;

    // Identifica le pratiche non categorizzate
    if (praticheNonCategorizzate > 0) {
      // Applica gli stessi filtri usati per il complessivo
      let praticheDaAnalizzare = this.praticheTipoC;
      if (this.filtroRegioneOF && this.filtroRegioneOF.length > 0) {
        praticheDaAnalizzare = praticheDaAnalizzare.filter((p) =>
          this.filtroRegioneOF.includes(p.regione),
        );
      }

      // Filtra le pratiche che non corrispondono a nessuna categoria nota
      this.praticheNonCategorizzate = praticheDaAnalizzare.filter((pratica) => {
        const isCategorizzata = this.isPraticaCategorizzata(pratica);
        if (!isCategorizzata) {
          const motivo = this.getMotivoNonCategorizzata(pratica);
          const impresa = pratica.aziendaFase2
            ? pratica.aziendaFase2
            : pratica.aziendaFase1
              ? pratica.aziendaFase1
              : pratica.azienda;
          this.logger.warn(
            `[HOME WIP] PRATICA NON CATEGORIZZATA - CUI: ${pratica.cui || "N/A"}, Regione: ${pratica.regione || "N/A"}, Azienda: ${impresa || "N/A"}, Lotto: ${pratica.lotto || "NULL"}`,
          );
          this.logger.warn(`[HOME WIP] MOTIVO: ${motivo}`);
          this.logger.warn(
            `[HOME WIP] DETTAGLI: statoOF="${pratica.statoOF || "NULL"}", vincoloCategoriaCodice="${pratica.vincoloCategoriaCodice || "NULL"}", vincoloTipologiaID="${pratica.vincoloTipologiaID !== null && pratica.vincoloTipologiaID !== undefined ? pratica.vincoloTipologiaID : "NULL"}"`,
          );
        }
        return !isCategorizzata;
      });

      this.logger.warn(
        `[HOME WIP] TROVATE ${praticheNonCategorizzate} PRATICHE NON CATEGORIZZATE (Totale: ${this.vincoloOFBando2}, Categorizzate: ${totaleCategorizzate})`,
      );
      this.vincoliOFData.push({
        categoria: "NON CATEGORIZZATE",
        lotto1: 0,
        lotto5: 0,
        lotto7: 0,
        lotto8: 0,
        totale: praticheNonCategorizzate,
        attivo: 0,
        passivo: 0,
        senzaServizio: 0,
        inAttesa: 0,
        attivate: 0,
        rilasciateFibercop: 0,
      });
    } else {
      this.praticheNonCategorizzate = [];
    }

    /* this.logger.info("* VINCOLO INFRATEL " + this.vincoloOFBando2_Infratel);
    this.logger.info("* VINCOLO FIBERCOP " + this.vincoloOFBando2_Fibercop);
    this.logger.info("* FUORI PERIMETRO " + this.vincoloOFBando2_FuoriPerimetro); */
  }

  isRowHighlighted(categoria: string): boolean {
    if (
      !this.filtroCategoriaVincoloOF ||
      !this.filtroCategoriaVincoloOF.length
    ) {
      return false;
    }
    // Verifica se la categoria inizia con il codice del filtro (es. "2.1 TRIPLETTA" inizia con "2.1")
    return categoria.startsWith(this.filtroCategoriaVincoloOF);
  }

  get totaliLotto1(): number {
    return (
      this.vincoloOFBando2_Lavorabili_Lotto1 +
      this.vincoloOFBando2_2_1_Lotto1 +
      this.vincoloOFBando2_2_2_Lotto1 +
      this.vincoloOFBando2_2_3_Lotto1 +
      this.vincoloOFBando2_2_4_Lotto1 +
      this.vincoloOFBando2_2_5_Lotto1 +
      this.vincoloOFBando2_2_6_Lotto1 +
      this.vincoloOFBando2_2_7_Lotto1 +
      this.vincoloOFBando2_2_8_Lotto1 +
      this.vincoloOFBando2_2_9_Lotto1 +
      this.vincoloOFBando2_Fibercop_Lotto1 +
      this.vincoloOFBando2_Infratel_Lotto1 +
      this.vincoloOFBando2_FuoriPerimetro_Lotto1
    );
  }

  get totaliLotto5(): number {
    return (
      this.vincoloOFBando2_Lavorabili_Lotto5 +
      this.vincoloOFBando2_2_1_Lotto5 +
      this.vincoloOFBando2_2_2_Lotto5 +
      this.vincoloOFBando2_2_3_Lotto5 +
      this.vincoloOFBando2_2_4_Lotto5 +
      this.vincoloOFBando2_2_5_Lotto5 +
      this.vincoloOFBando2_2_6_Lotto5 +
      this.vincoloOFBando2_2_7_Lotto5 +
      this.vincoloOFBando2_2_8_Lotto5 +
      this.vincoloOFBando2_2_9_Lotto5 +
      this.vincoloOFBando2_Fibercop_Lotto5 +
      this.vincoloOFBando2_Infratel_Lotto5 +
      this.vincoloOFBando2_FuoriPerimetro_Lotto5
    );
  }

  get totaliLotto7(): number {
    return (
      this.vincoloOFBando2_Lavorabili_Lotto7 +
      this.vincoloOFBando2_2_1_Lotto7 +
      this.vincoloOFBando2_2_2_Lotto7 +
      this.vincoloOFBando2_2_3_Lotto7 +
      this.vincoloOFBando2_2_4_Lotto7 +
      this.vincoloOFBando2_2_5_Lotto7 +
      this.vincoloOFBando2_2_6_Lotto7 +
      this.vincoloOFBando2_2_7_Lotto7 +
      this.vincoloOFBando2_2_8_Lotto7 +
      this.vincoloOFBando2_2_9_Lotto7 +
      this.vincoloOFBando2_Fibercop_Lotto7 +
      this.vincoloOFBando2_Infratel_Lotto7 +
      this.vincoloOFBando2_FuoriPerimetro_Lotto7
    );
  }

  get totaliLotto8(): number {
    return (
      this.vincoloOFBando2_Lavorabili_Lotto8 +
      this.vincoloOFBando2_2_1_Lotto8 +
      this.vincoloOFBando2_2_2_Lotto8 +
      this.vincoloOFBando2_2_3_Lotto8 +
      this.vincoloOFBando2_2_4_Lotto8 +
      this.vincoloOFBando2_2_5_Lotto8 +
      this.vincoloOFBando2_2_6_Lotto8 +
      this.vincoloOFBando2_2_7_Lotto8 +
      this.vincoloOFBando2_2_8_Lotto8 +
      this.vincoloOFBando2_2_9_Lotto8 +
      this.vincoloOFBando2_Fibercop_Lotto8 +
      this.vincoloOFBando2_Infratel_Lotto8 +
      this.vincoloOFBando2_FuoriPerimetro_Lotto8
    );
  }

  get totaleComplessivo(): number {
    // Usa vincoloOFBando2 che rappresenta il totale reale di tutte le pratiche processate
    return this.vincoloOFBando2;
  }

  get totaleAttivo(): number {
    return this.vincoloOFBando2_Attivo;
  }

  get totalePassivo(): number {
    return this.vincoloOFBando2_Passivo;
  }

  get totaleSenzaServizio(): number {
    return this.vincoloOFBando2_SenzaServizio;
  }

  get totaleAttivate(): number {
    return this.vincoloOFBando2_Attivate;
  }

  get totaleRilasciateFibercop(): number {
    return this.vincoloOFBando2_RilasciateFibercop;
  }

  get totaleInAttesa(): number {
    return (
      (this.vincoloOFBando2_Null || 0) + (this.vincoloOFBando2_InAttesa || 0)
    );
  }

  private azzeraContatoriVincoloOF() {
    // Contatori generali
    this.vincoloOFBando2 = 0;
    this.vincoloOFBando2_Attivo = 0;
    this.vincoloOFBando2_Passivo = 0;
    this.vincoloOFBando2_SenzaServizio = 0;
    this.vincoloOFBando2_Attivate = 0;
    this.vincoloOFBando2_RilasciateFibercop = 0;
    this.vincoloOFBando2_InAttesa = 0;
    this.vincoloOFBando2Lotto1 = 0;
    this.vincoloOFBando2Lotto5 = 0;
    this.vincoloOFBando2Lotto7 = 0;
    this.vincoloOFBando2Lotto8 = 0;

    // Contatori LAVORABILI
    this.vincoloOFBando2_Lavorabili = 0;
    this.vincoloOFBando2_Lavorabili_Lotto1 = 0;
    this.vincoloOFBando2_Lavorabili_Lotto5 = 0;
    this.vincoloOFBando2_Lavorabili_Lotto7 = 0;
    this.vincoloOFBando2_Lavorabili_Lotto8 = 0;
    this.vincoloOFBando2_Lavorabili_Attivo = 0;
    this.vincoloOFBando2_Lavorabili_Passivo = 0;
    this.vincoloOFBando2_Lavorabili_SenzaServizio = 0;

    // Contatori VINCOLO FIBERCOP (vincoloTipologiaID = 1)
    this.vincoloOFBando2_Fibercop = 0;
    this.vincoloOFBando2_Fibercop_Lotto1 = 0;
    this.vincoloOFBando2_Fibercop_Lotto5 = 0;
    this.vincoloOFBando2_Fibercop_Lotto7 = 0;
    this.vincoloOFBando2_Fibercop_Lotto8 = 0;
    this.vincoloOFBando2_Fibercop_Attivo = 0;
    this.vincoloOFBando2_Fibercop_Passivo = 0;
    this.vincoloOFBando2_Fibercop_SenzaServizio = 0;
    this.vincoloOFBando2_Fibercop_Attivate = 0;
    this.vincoloOFBando2_Fibercop_RilasciateFibercop = 0;
    this.vincoloOFBando2_Fibercop_InAttesa = 0;

    // Contatori VINCOLO INFRATEL (vincoloTipologiaID = 3)
    this.vincoloOFBando2_Infratel = 0;
    this.vincoloOFBando2_Infratel_Lotto1 = 0;
    this.vincoloOFBando2_Infratel_Lotto5 = 0;
    this.vincoloOFBando2_Infratel_Lotto7 = 0;
    this.vincoloOFBando2_Infratel_Lotto8 = 0;
    this.vincoloOFBando2_Infratel_Attivo = 0;
    this.vincoloOFBando2_Infratel_Passivo = 0;
    this.vincoloOFBando2_Infratel_SenzaServizio = 0;
    this.vincoloOFBando2_Infratel_Attivate = 0;
    this.vincoloOFBando2_Infratel_RilasciateFibercop = 0;
    this.vincoloOFBando2_Infratel_InAttesa = 0;

    // Contatori FUORI PERIMETRO (vincoloTipologiaID = 4)
    this.vincoloOFBando2_FuoriPerimetro = 0;
    this.vincoloOFBando2_FuoriPerimetro_Lotto1 = 0;
    this.vincoloOFBando2_FuoriPerimetro_Lotto5 = 0;
    this.vincoloOFBando2_FuoriPerimetro_Lotto7 = 0;
    this.vincoloOFBando2_FuoriPerimetro_Lotto8 = 0;
    this.vincoloOFBando2_FuoriPerimetro_Attivo = 0;
    this.vincoloOFBando2_FuoriPerimetro_Passivo = 0;
    this.vincoloOFBando2_FuoriPerimetro_SenzaServizio = 0;
    this.vincoloOFBando2_FuoriPerimetro_Attivate = 0;
    this.vincoloOFBando2_FuoriPerimetro_RilasciateFibercop = 0;
    this.vincoloOFBando2_FuoriPerimetro_InAttesa = 0;

    // Contatori categorie 2.1-2.9 (totali)
    this.vincoloOFBando2_2_1 = 0;
    this.vincoloOFBando2_2_2 = 0;
    this.vincoloOFBando2_2_3 = 0;
    this.vincoloOFBando2_2_4 = 0;
    this.vincoloOFBando2_2_5 = 0;
    this.vincoloOFBando2_2_6 = 0;
    this.vincoloOFBando2_2_7 = 0;
    this.vincoloOFBando2_2_8 = 0;
    this.vincoloOFBando2_2_9 = 0;

    // Contatori per lotto per categoria 2.1
    this.vincoloOFBando2_2_1_Lotto1 = 0;
    this.vincoloOFBando2_2_1_Lotto5 = 0;
    this.vincoloOFBando2_2_1_Lotto7 = 0;
    this.vincoloOFBando2_2_1_Lotto8 = 0;

    // Contatori per lotto per categoria 2.2
    this.vincoloOFBando2_2_2_Lotto1 = 0;
    this.vincoloOFBando2_2_2_Lotto5 = 0;
    this.vincoloOFBando2_2_2_Lotto7 = 0;
    this.vincoloOFBando2_2_2_Lotto8 = 0;

    // Contatori per lotto per categoria 2.3
    this.vincoloOFBando2_2_3_Lotto1 = 0;
    this.vincoloOFBando2_2_3_Lotto5 = 0;
    this.vincoloOFBando2_2_3_Lotto7 = 0;
    this.vincoloOFBando2_2_3_Lotto8 = 0;

    // Contatori per lotto per categoria 2.4
    this.vincoloOFBando2_2_4_Lotto1 = 0;
    this.vincoloOFBando2_2_4_Lotto5 = 0;
    this.vincoloOFBando2_2_4_Lotto7 = 0;
    this.vincoloOFBando2_2_4_Lotto8 = 0;

    // Contatori per lotto per categoria 2.5
    this.vincoloOFBando2_2_5_Lotto1 = 0;
    this.vincoloOFBando2_2_5_Lotto5 = 0;
    this.vincoloOFBando2_2_5_Lotto7 = 0;
    this.vincoloOFBando2_2_5_Lotto8 = 0;

    // Contatori per lotto per categoria 2.6
    this.vincoloOFBando2_2_6_Lotto1 = 0;
    this.vincoloOFBando2_2_6_Lotto5 = 0;
    this.vincoloOFBando2_2_6_Lotto7 = 0;
    this.vincoloOFBando2_2_6_Lotto8 = 0;

    // Contatori per lotto per categoria 2.7
    this.vincoloOFBando2_2_7_Lotto1 = 0;
    this.vincoloOFBando2_2_7_Lotto5 = 0;
    this.vincoloOFBando2_2_7_Lotto7 = 0;
    this.vincoloOFBando2_2_7_Lotto8 = 0;

    // Contatori per lotto per categoria 2.8
    this.vincoloOFBando2_2_8_Lotto1 = 0;
    this.vincoloOFBando2_2_8_Lotto5 = 0;
    this.vincoloOFBando2_2_8_Lotto7 = 0;
    this.vincoloOFBando2_2_8_Lotto8 = 0;

    // Contatori per lotto per categoria 2.9
    this.vincoloOFBando2_2_9_Lotto1 = 0;
    this.vincoloOFBando2_2_9_Lotto5 = 0;
    this.vincoloOFBando2_2_9_Lotto7 = 0;
    this.vincoloOFBando2_2_9_Lotto8 = 0;

    // Contatori ATTIVO/PASSIVO/SENZA SERVIZIO per categoria 2.1
    this.vincoloOFBando2_2_1_Attivo = 0;
    this.vincoloOFBando2_2_1_Passivo = 0;
    this.vincoloOFBando2_2_1_SenzaServizio = 0;

    // Contatori ATTIVO/PASSIVO/SENZA SERVIZIO per categoria 2.2
    this.vincoloOFBando2_2_2_Attivo = 0;
    this.vincoloOFBando2_2_2_Passivo = 0;
    this.vincoloOFBando2_2_2_SenzaServizio = 0;

    // Contatori ATTIVO/PASSIVO/SENZA SERVIZIO per categoria 2.3
    this.vincoloOFBando2_2_3_Attivo = 0;
    this.vincoloOFBando2_2_3_Passivo = 0;
    this.vincoloOFBando2_2_3_SenzaServizio = 0;

    // Contatori ATTIVO/PASSIVO/SENZA SERVIZIO per categoria 2.4
    this.vincoloOFBando2_2_4_Attivo = 0;
    this.vincoloOFBando2_2_4_Passivo = 0;
    this.vincoloOFBando2_2_4_SenzaServizio = 0;

    // Contatori ATTIVO/PASSIVO/SENZA SERVIZIO per categoria 2.5
    this.vincoloOFBando2_2_5_Attivo = 0;
    this.vincoloOFBando2_2_5_Passivo = 0;
    this.vincoloOFBando2_2_5_SenzaServizio = 0;

    // Contatori ATTIVO/PASSIVO/SENZA SERVIZIO per categoria 2.6
    this.vincoloOFBando2_2_6_Attivo = 0;
    this.vincoloOFBando2_2_6_Passivo = 0;
    this.vincoloOFBando2_2_6_SenzaServizio = 0;

    // Contatori ATTIVO/PASSIVO/SENZA SERVIZIO per categoria 2.7
    this.vincoloOFBando2_2_7_Attivo = 0;
    this.vincoloOFBando2_2_7_Passivo = 0;
    this.vincoloOFBando2_2_7_SenzaServizio = 0;

    // Contatori ATTIVO/PASSIVO/SENZA SERVIZIO per categoria 2.8
    this.vincoloOFBando2_2_8_Attivo = 0;
    this.vincoloOFBando2_2_8_Passivo = 0;
    this.vincoloOFBando2_2_8_SenzaServizio = 0;

    // Contatori ATTIVO/PASSIVO/SENZA SERVIZIO per categoria 2.9
    this.vincoloOFBando2_2_9_Attivo = 0;
    this.vincoloOFBando2_2_9_Passivo = 0;
    this.vincoloOFBando2_2_9_SenzaServizio = 0;
  }

  private loadDatiVincoloOF(pratica: PraticaFlowdy2_Firestore) {
    // if (pratica.bando === 'BANDO 2') {
    this.vincoloOFBando2++;

    // Incrementa contatori ATTIVO/PASSIVO/SENZA SERVIZIO complessivi
    if (pratica.servizioOF === "ATTIVO") {
      this.vincoloOFBando2_Attivo++;
    } else if (pratica.servizioOF === "PASSIVO") {
      this.vincoloOFBando2_Passivo++;
    } else if (!pratica.servizioOF || pratica.servizioOF.trim() === "") {
      this.vincoloOFBando2_SenzaServizio++;
    }

    if (pratica.statoPF && pratica.statoPF.length > 0) {
      const statoPFUpper = pratica.statoPF.toUpperCase();

      if (statoPFUpper === "SEDE ATTIVATA") {
        this.vincoloOFBando2_Attivate++;
      } else if (
        statoPFUpper === "PRONTO" ||
        statoPFUpper === "ROUTER INSTALLATO" ||
        statoPFUpper === "KO"
      ) {
        this.vincoloOFBando2_RilasciateFibercop++;
      } else if (statoPFUpper === "IN ATTESA") {
        this.vincoloOFBando2_InAttesa++;
      }
    } else {
      // statoPF mancante: conta in IN ATTESA (aggregato con NULL)
      this.vincoloOFBando2_InAttesa++;
    }

    if (pratica.lotto == "1") {
      this.vincoloOFBando2Lotto1++;
    } else if (pratica.lotto == "5") {
      this.vincoloOFBando2Lotto5++;
    } else if (pratica.lotto == "7") {
      this.vincoloOFBando2Lotto7++;
    } else if (pratica.lotto == "8") {
      this.vincoloOFBando2Lotto8++;
    } else {
      // Traccia pratiche con lotti non validi
      const impresa = pratica.aziendaFase2
        ? pratica.aziendaFase2
        : pratica.aziendaFase1
          ? pratica.aziendaFase1
          : pratica.azienda;
      this.praticheLottoNonValido.push({
        cui: pratica.cui || "N/A",
        lotto: pratica.lotto || "NULL",
        regione: pratica.regione || "N/A",
        azienda: impresa || "N/A",
      });
    }

    // PRIORITÀ 1: Se statoOF = 'LAVORABILE', categorizza sempre come LAVORABILE
    // indipendentemente da vincoloTipologiaID o altri fattori
    const statoOFTrimmed = pratica.statoOF
      ? pratica.statoOF.trim().toUpperCase()
      : null;
    if (statoOFTrimmed === "LAVORABILE") {
      // Categorizza come LAVORABILE
      this.vincoloOFBando2_Lavorabili++;
      if (pratica.servizioOF === "ATTIVO") {
        this.vincoloOFBando2_Lavorabili_Attivo++;
      } else if (pratica.servizioOF === "PASSIVO") {
        this.vincoloOFBando2_Lavorabili_Passivo++;
      } else if (!pratica.servizioOF || pratica.servizioOF.trim() === "") {
        this.vincoloOFBando2_Lavorabili_SenzaServizio++;
      }
      if (pratica.statoPF && pratica.statoPF.length > 0) {
        const statoPFUpper = pratica.statoPF.toUpperCase();
        if (statoPFUpper === "SEDE ATTIVATA") {
          this.vincoloOFBando2_Lavorabili_Attivate++;
        } else if (
          statoPFUpper === "PRONTO" ||
          statoPFUpper === "ROUTER INSTALLATO" ||
          statoPFUpper === "KO"
        ) {
          this.vincoloOFBando2_Lavorabili_RilasciateFibercop++;
        } else if (statoPFUpper === "IN ATTESA") {
          this.vincoloOFBando2_Lavorabili_InAttesa++;
        }
      } else {
        this.vincoloOFBando2_Lavorabili_InAttesa++;
      }
      if (pratica.lotto == "1") {
        this.vincoloOFBando2_Lavorabili_Lotto1++;
      } else if (pratica.lotto == "5") {
        this.vincoloOFBando2_Lavorabili_Lotto5++;
      } else if (pratica.lotto == "7") {
        this.vincoloOFBando2_Lavorabili_Lotto7++;
      } else if (pratica.lotto == "8") {
        this.vincoloOFBando2_Lavorabili_Lotto8++;
      }
      return; // Esci dal metodo, pratica categorizzata come LAVORABILE
    }

    // PRIORITÀ 2: Controlla il vincoloTipologiaID per categorizzare VINCOLO FIBERCOP, VINCOLO INFRATEL e FUORI PERIMETRO
    const vincoloTipologiaIDNum =
      pratica.vincoloTipologiaID != null
        ? Number(pratica.vincoloTipologiaID)
        : null;

    // Verifica vincoloTipologiaID per tutte le pratiche NON LAVORABILI
    // Se vincoloTipologiaID non è valorizzato o è 2, procedi con la logica normale (switch su vincoloCategoriaCodice)
    if (vincoloTipologiaIDNum === null || vincoloTipologiaIDNum === 2) {
      // Procedi con il normale switch su vincoloCategoriaCodice (vedi più sotto)
    } else if (vincoloTipologiaIDNum === 1) {
      // VINCOLO FIBERCOP - ma solo se vincoloCategoriaCodice è 1.1, 1.2, 1.3 o 1.4
      const categoriaCodice = pratica.vincoloCategoriaCodice;
      if (
        categoriaCodice === "1.1" ||
        categoriaCodice === "1.2" ||
        categoriaCodice === "1.3" ||
        categoriaCodice === "1.4"
      ) {
        // Conteggia con vincoloOFBando2_Fibercop_* (sia per LAVORABILI che NON LAVORABILI)
        this.vincoloOFBando2_Fibercop++;
        if (pratica.servizioOF === "ATTIVO") {
          this.vincoloOFBando2_Fibercop_Attivo++;
        } else if (pratica.servizioOF === "PASSIVO") {
          this.vincoloOFBando2_Fibercop_Passivo++;
        } else if (!pratica.servizioOF || pratica.servizioOF.trim() === "") {
          this.vincoloOFBando2_Fibercop_SenzaServizio++;
        }
        if (pratica.statoPF && pratica.statoPF.length > 0) {
          const statoPFUpper = pratica.statoPF.toUpperCase();
          if (statoPFUpper === "SEDE ATTIVATA") {
            this.vincoloOFBando2_Fibercop_Attivate++;
          } else if (
            statoPFUpper === "PRONTO" ||
            statoPFUpper === "ROUTER INSTALLATO" ||
            statoPFUpper === "KO"
          ) {
            this.vincoloOFBando2_Fibercop_RilasciateFibercop++;
          } else if (statoPFUpper === "IN ATTESA") {
            this.vincoloOFBando2_Fibercop_InAttesa++;
          }
        } else {
          this.vincoloOFBando2_Fibercop_InAttesa++;
        }
        if (pratica.lotto == "1") {
          this.vincoloOFBando2_Fibercop_Lotto1++;
        } else if (pratica.lotto == "5") {
          this.vincoloOFBando2_Fibercop_Lotto5++;
        } else if (pratica.lotto == "7") {
          this.vincoloOFBando2_Fibercop_Lotto7++;
        } else if (pratica.lotto == "8") {
          this.vincoloOFBando2_Fibercop_Lotto8++;
        }
        return; // Esci dal metodo, non processare ulteriormente
      }
      // Se vincoloCategoriaCodice è 1.5, 1.6, 1.7, 1.8, 1.9, 1.10, 1.11, usa la logica attuale (switch)
    } else if (vincoloTipologiaIDNum === 3) {
      // VINCOLO INFRATEL (sia per LAVORABILI che NON LAVORABILI)
      this.vincoloOFBando2_Infratel++;
      if (pratica.servizioOF === "ATTIVO") {
        this.vincoloOFBando2_Infratel_Attivo++;
      } else if (pratica.servizioOF === "PASSIVO") {
        this.vincoloOFBando2_Infratel_Passivo++;
      } else if (!pratica.servizioOF || pratica.servizioOF.trim() === "") {
        this.vincoloOFBando2_Infratel_SenzaServizio++;
      }
      if (pratica.statoPF && pratica.statoPF.length > 0) {
        const statoPFUpper = pratica.statoPF.toUpperCase();
        if (statoPFUpper === "SEDE ATTIVATA") {
          this.vincoloOFBando2_Infratel_Attivate++;
        } else if (
          statoPFUpper === "PRONTO" ||
          statoPFUpper === "ROUTER INSTALLATO" ||
          statoPFUpper === "KO"
        ) {
          this.vincoloOFBando2_Infratel_RilasciateFibercop++;
        } else if (statoPFUpper === "IN ATTESA") {
          this.vincoloOFBando2_Infratel_InAttesa++;
        }
      } else {
        this.vincoloOFBando2_Infratel_InAttesa++;
      }
      if (pratica.lotto == "1") {
        this.vincoloOFBando2_Infratel_Lotto1++;
      } else if (pratica.lotto == "5") {
        this.vincoloOFBando2_Infratel_Lotto5++;
      } else if (pratica.lotto == "7") {
        this.vincoloOFBando2_Infratel_Lotto7++;
      } else if (pratica.lotto == "8") {
        this.vincoloOFBando2_Infratel_Lotto8++;
      }
      return; // Esci dal metodo, non processare ulteriormente
    } else if (vincoloTipologiaIDNum === 4) {
      // FUORI PERIMETRO (sia per LAVORABILI che NON LAVORABILI)
      this.vincoloOFBando2_FuoriPerimetro++;
      if (pratica.servizioOF === "ATTIVO") {
        this.vincoloOFBando2_FuoriPerimetro_Attivo++;
      } else if (pratica.servizioOF === "PASSIVO") {
        this.vincoloOFBando2_FuoriPerimetro_Passivo++;
      } else if (!pratica.servizioOF || pratica.servizioOF.trim() === "") {
        this.vincoloOFBando2_FuoriPerimetro_SenzaServizio++;
      }
      if (pratica.statoPF && pratica.statoPF.length > 0) {
        const statoPFUpper = pratica.statoPF.toUpperCase();
        if (statoPFUpper === "SEDE ATTIVATA") {
          this.vincoloOFBando2_FuoriPerimetro_Attivate++;
        } else if (
          statoPFUpper === "PRONTO" ||
          statoPFUpper === "ROUTER INSTALLATO" ||
          statoPFUpper === "KO"
        ) {
          this.vincoloOFBando2_FuoriPerimetro_RilasciateFibercop++;
        } else if (statoPFUpper === "IN ATTESA") {
          this.vincoloOFBando2_FuoriPerimetro_InAttesa++;
        }
      } else {
        this.vincoloOFBando2_FuoriPerimetro_InAttesa++;
      }
      if (pratica.lotto == "1") {
        this.vincoloOFBando2_FuoriPerimetro_Lotto1++;
      } else if (pratica.lotto == "5") {
        this.vincoloOFBando2_FuoriPerimetro_Lotto5++;
      } else if (pratica.lotto == "7") {
        this.vincoloOFBando2_FuoriPerimetro_Lotto7++;
      } else if (pratica.lotto == "8") {
        this.vincoloOFBando2_FuoriPerimetro_Lotto8++;
      }
      return; // Esci dal metodo, non processare ulteriormente
    }

    // Se è LAVORABILE o se non è stato processato sopra (vincoloTipologiaID null/2 o 1 con categoria 1.5-1.11),
    // procedi con il normale switch su vincoloCategoriaCodice
    switch (pratica.vincoloCategoriaCodice) {
      case "2.1":
        this.vincoloOFBando2_2_1++;
        if (pratica.servizioOF === "ATTIVO") {
          this.vincoloOFBando2_2_1_Attivo++;
        } else if (pratica.servizioOF === "PASSIVO") {
          this.vincoloOFBando2_2_1_Passivo++;
        } else if (!pratica.servizioOF || pratica.servizioOF.trim() === "") {
          this.vincoloOFBando2_2_1_SenzaServizio++;
        }
        if (pratica.statoPF && pratica.statoPF.length > 0) {
          const statoPFUpper = pratica.statoPF.toUpperCase();
          if (statoPFUpper === "SEDE ATTIVATA") {
            this.vincoloOFBando2_2_1_Attivate++;
          } else if (
            statoPFUpper === "PRONTO" ||
            statoPFUpper === "ROUTER INSTALLATO" ||
            statoPFUpper === "KO"
          ) {
            this.vincoloOFBando2_2_1_RilasciateFibercop++;
          } else if (statoPFUpper === "IN ATTESA") {
            this.vincoloOFBando2_2_1_InAttesa++;
          }
        } else {
          this.vincoloOFBando2_2_1_InAttesa++;
        }
        if (pratica.lotto == "1") {
          this.vincoloOFBando2_2_1_Lotto1++;
        } else if (pratica.lotto == "5") {
          this.vincoloOFBando2_2_1_Lotto5++;
        } else if (pratica.lotto == "7") {
          this.vincoloOFBando2_2_1_Lotto7++;
        } else if (pratica.lotto == "8") {
          this.vincoloOFBando2_2_1_Lotto8++;
        }
        break;
      case "2.2":
        this.vincoloOFBando2_2_2++;
        if (pratica.servizioOF === "ATTIVO") {
          this.vincoloOFBando2_2_2_Attivo++;
        } else if (pratica.servizioOF === "PASSIVO") {
          this.vincoloOFBando2_2_2_Passivo++;
        } else if (!pratica.servizioOF || pratica.servizioOF.trim() === "") {
          this.vincoloOFBando2_2_2_SenzaServizio++;
        }
        if (pratica.statoPF && pratica.statoPF.length > 0) {
          const statoPFUpper = pratica.statoPF.toUpperCase();
          if (statoPFUpper === "SEDE ATTIVATA") {
            this.vincoloOFBando2_2_2_Attivate++;
          } else if (
            statoPFUpper === "PRONTO" ||
            statoPFUpper === "ROUTER INSTALLATO" ||
            statoPFUpper === "KO"
          ) {
            this.vincoloOFBando2_2_2_RilasciateFibercop++;
          } else if (statoPFUpper === "IN ATTESA") {
            this.vincoloOFBando2_2_2_InAttesa++;
          }
        } else {
          this.vincoloOFBando2_2_2_InAttesa++;
        }
        if (pratica.lotto == "1") {
          this.vincoloOFBando2_2_2_Lotto1++;
        } else if (pratica.lotto == "5") {
          this.vincoloOFBando2_2_2_Lotto5++;
        } else if (pratica.lotto == "7") {
          this.vincoloOFBando2_2_2_Lotto7++;
        } else if (pratica.lotto == "8") {
          this.vincoloOFBando2_2_2_Lotto8++;
        }
        break;
      case "2.3":
        this.vincoloOFBando2_2_3++;
        if (pratica.servizioOF === "ATTIVO") {
          this.vincoloOFBando2_2_3_Attivo++;
        } else if (pratica.servizioOF === "PASSIVO") {
          this.vincoloOFBando2_2_3_Passivo++;
        } else if (!pratica.servizioOF || pratica.servizioOF.trim() === "") {
          this.vincoloOFBando2_2_3_SenzaServizio++;
        }
        if (pratica.statoPF && pratica.statoPF.length > 0) {
          const statoPFUpper = pratica.statoPF.toUpperCase();
          if (statoPFUpper === "SEDE ATTIVATA") {
            this.vincoloOFBando2_2_3_Attivate++;
          } else if (
            statoPFUpper === "PRONTO" ||
            statoPFUpper === "ROUTER INSTALLATO" ||
            statoPFUpper === "KO"
          ) {
            this.vincoloOFBando2_2_3_RilasciateFibercop++;
          } else if (statoPFUpper === "IN ATTESA") {
            this.vincoloOFBando2_2_3_InAttesa++;
          }
        } else {
          this.vincoloOFBando2_2_3_InAttesa++;
        }
        if (pratica.lotto == "1") {
          this.vincoloOFBando2_2_3_Lotto1++;
        } else if (pratica.lotto == "5") {
          this.vincoloOFBando2_2_3_Lotto5++;
        } else if (pratica.lotto == "7") {
          this.vincoloOFBando2_2_3_Lotto7++;
        } else if (pratica.lotto == "8") {
          this.vincoloOFBando2_2_3_Lotto8++;
        }
        break;
      case "2.4":
        this.vincoloOFBando2_2_4++;
        if (pratica.servizioOF === "ATTIVO") {
          this.vincoloOFBando2_2_4_Attivo++;
        } else if (pratica.servizioOF === "PASSIVO") {
          this.vincoloOFBando2_2_4_Passivo++;
        } else if (!pratica.servizioOF || pratica.servizioOF.trim() === "") {
          this.vincoloOFBando2_2_4_SenzaServizio++;
        }
        if (pratica.statoPF && pratica.statoPF.length > 0) {
          const statoPFUpper = pratica.statoPF.toUpperCase();
          if (statoPFUpper === "SEDE ATTIVATA") {
            this.vincoloOFBando2_2_4_Attivate++;
          } else if (
            statoPFUpper === "PRONTO" ||
            statoPFUpper === "ROUTER INSTALLATO" ||
            statoPFUpper === "KO"
          ) {
            this.vincoloOFBando2_2_4_RilasciateFibercop++;
          } else if (statoPFUpper === "IN ATTESA") {
            this.vincoloOFBando2_2_4_InAttesa++;
          }
        } else {
          this.vincoloOFBando2_2_4_InAttesa++;
        }
        if (pratica.lotto == "1") {
          this.vincoloOFBando2_2_4_Lotto1++;
        } else if (pratica.lotto == "5") {
          this.vincoloOFBando2_2_4_Lotto5++;
        } else if (pratica.lotto == "7") {
          this.vincoloOFBando2_2_4_Lotto7++;
        } else if (pratica.lotto == "8") {
          this.vincoloOFBando2_2_4_Lotto8++;
        }
        break;
      case "2.5":
        this.vincoloOFBando2_2_5++;
        if (pratica.servizioOF === "ATTIVO") {
          this.vincoloOFBando2_2_5_Attivo++;
        } else if (pratica.servizioOF === "PASSIVO") {
          this.vincoloOFBando2_2_5_Passivo++;
        } else if (!pratica.servizioOF || pratica.servizioOF.trim() === "") {
          this.vincoloOFBando2_2_5_SenzaServizio++;
        }
        if (pratica.statoPF && pratica.statoPF.length > 0) {
          const statoPFUpper = pratica.statoPF.toUpperCase();
          if (statoPFUpper === "SEDE ATTIVATA") {
            this.vincoloOFBando2_2_5_Attivate++;
          } else if (
            statoPFUpper === "PRONTO" ||
            statoPFUpper === "ROUTER INSTALLATO" ||
            statoPFUpper === "KO"
          ) {
            this.vincoloOFBando2_2_5_RilasciateFibercop++;
          } else if (statoPFUpper === "IN ATTESA") {
            this.vincoloOFBando2_2_5_InAttesa++;
          }
        } else {
          this.vincoloOFBando2_2_5_InAttesa++;
        }
        if (pratica.lotto == "1") {
          this.vincoloOFBando2_2_5_Lotto1++;
        } else if (pratica.lotto == "5") {
          this.vincoloOFBando2_2_5_Lotto5++;
        } else if (pratica.lotto == "7") {
          this.vincoloOFBando2_2_5_Lotto7++;
        } else if (pratica.lotto == "8") {
          this.vincoloOFBando2_2_5_Lotto8++;
        }
        break;
      case "2.6":
        this.vincoloOFBando2_2_6++;
        if (pratica.servizioOF === "ATTIVO") {
          this.vincoloOFBando2_2_6_Attivo++;
        } else if (pratica.servizioOF === "PASSIVO") {
          this.vincoloOFBando2_2_6_Passivo++;
        } else if (!pratica.servizioOF || pratica.servizioOF.trim() === "") {
          this.vincoloOFBando2_2_6_SenzaServizio++;
        }
        if (pratica.statoPF && pratica.statoPF.length > 0) {
          const statoPFUpper = pratica.statoPF.toUpperCase();
          if (statoPFUpper === "SEDE ATTIVATA") {
            this.vincoloOFBando2_2_6_Attivate++;
          } else if (
            statoPFUpper === "PRONTO" ||
            statoPFUpper === "ROUTER INSTALLATO" ||
            statoPFUpper === "KO"
          ) {
            this.vincoloOFBando2_2_6_RilasciateFibercop++;
          } else if (statoPFUpper === "IN ATTESA") {
            this.vincoloOFBando2_2_6_InAttesa++;
          }
        } else {
          this.vincoloOFBando2_2_6_InAttesa++;
        }
        if (pratica.lotto == "1") {
          this.vincoloOFBando2_2_6_Lotto1++;
        } else if (pratica.lotto == "5") {
          this.vincoloOFBando2_2_6_Lotto5++;
        } else if (pratica.lotto == "7") {
          this.vincoloOFBando2_2_6_Lotto7++;
        } else if (pratica.lotto == "8") {
          this.vincoloOFBando2_2_6_Lotto8++;
        }
        break;
      case "2.7":
        this.vincoloOFBando2_2_7++;
        if (pratica.servizioOF === "ATTIVO") {
          this.vincoloOFBando2_2_7_Attivo++;
        } else if (pratica.servizioOF === "PASSIVO") {
          this.vincoloOFBando2_2_7_Passivo++;
        } else if (!pratica.servizioOF || pratica.servizioOF.trim() === "") {
          this.vincoloOFBando2_2_7_SenzaServizio++;
        }
        if (pratica.statoPF && pratica.statoPF.length > 0) {
          const statoPFUpper = pratica.statoPF.toUpperCase();
          if (statoPFUpper === "SEDE ATTIVATA") {
            this.vincoloOFBando2_2_7_Attivate++;
          } else if (
            statoPFUpper === "PRONTO" ||
            statoPFUpper === "ROUTER INSTALLATO" ||
            statoPFUpper === "KO"
          ) {
            this.vincoloOFBando2_2_7_RilasciateFibercop++;
          } else if (statoPFUpper === "IN ATTESA") {
            this.vincoloOFBando2_2_7_InAttesa++;
          }
        } else {
          this.vincoloOFBando2_2_7_InAttesa++;
        }
        if (pratica.lotto == "1") {
          this.vincoloOFBando2_2_7_Lotto1++;
        } else if (pratica.lotto == "5") {
          this.vincoloOFBando2_2_7_Lotto5++;
        } else if (pratica.lotto == "7") {
          this.vincoloOFBando2_2_7_Lotto7++;
        } else if (pratica.lotto == "8") {
          this.vincoloOFBando2_2_7_Lotto8++;
        }
        break;
      case "2.8":
        this.vincoloOFBando2_2_8++;
        if (pratica.servizioOF === "ATTIVO") {
          this.vincoloOFBando2_2_8_Attivo++;
        } else if (pratica.servizioOF === "PASSIVO") {
          this.vincoloOFBando2_2_8_Passivo++;
        } else if (!pratica.servizioOF || pratica.servizioOF.trim() === "") {
          this.vincoloOFBando2_2_8_SenzaServizio++;
        }
        if (pratica.statoPF && pratica.statoPF.length > 0) {
          const statoPFUpper = pratica.statoPF.toUpperCase();
          if (statoPFUpper === "SEDE ATTIVATA") {
            this.vincoloOFBando2_2_8_Attivate++;
          } else if (
            statoPFUpper === "PRONTO" ||
            statoPFUpper === "ROUTER INSTALLATO" ||
            statoPFUpper === "KO"
          ) {
            this.vincoloOFBando2_2_8_RilasciateFibercop++;
          } else if (statoPFUpper === "IN ATTESA") {
            this.vincoloOFBando2_2_8_InAttesa++;
          }
        } else {
          this.vincoloOFBando2_2_8_InAttesa++;
        }
        if (pratica.lotto == "1") {
          this.vincoloOFBando2_2_8_Lotto1++;
        } else if (pratica.lotto == "5") {
          this.vincoloOFBando2_2_8_Lotto5++;
        } else if (pratica.lotto == "7") {
          this.vincoloOFBando2_2_8_Lotto7++;
        } else if (pratica.lotto == "8") {
          this.vincoloOFBando2_2_8_Lotto8++;
        }
        break;
      case "2.9":
        this.vincoloOFBando2_2_9++;
        if (pratica.servizioOF === "ATTIVO") {
          this.vincoloOFBando2_2_9_Attivo++;
        } else if (pratica.servizioOF === "PASSIVO") {
          this.vincoloOFBando2_2_9_Passivo++;
        } else if (!pratica.servizioOF || pratica.servizioOF.trim() === "") {
          this.vincoloOFBando2_2_9_SenzaServizio++;
        }
        if (pratica.statoPF && pratica.statoPF.length > 0) {
          const statoPFUpper = pratica.statoPF.toUpperCase();
          if (statoPFUpper === "SEDE ATTIVATA") {
            this.vincoloOFBando2_2_9_Attivate++;
          } else if (
            statoPFUpper === "PRONTO" ||
            statoPFUpper === "ROUTER INSTALLATO" ||
            statoPFUpper === "KO"
          ) {
            this.vincoloOFBando2_2_9_RilasciateFibercop++;
          } else if (statoPFUpper === "IN ATTESA") {
            this.vincoloOFBando2_2_9_InAttesa++;
          }
        } else {
          this.vincoloOFBando2_2_9_InAttesa++;
        }
        if (pratica.lotto == "1") {
          this.vincoloOFBando2_2_9_Lotto1++;
        } else if (pratica.lotto == "5") {
          this.vincoloOFBando2_2_9_Lotto5++;
        } else if (pratica.lotto == "7") {
          this.vincoloOFBando2_2_9_Lotto7++;
        } else if (pratica.lotto == "8") {
          this.vincoloOFBando2_2_9_Lotto8++;
        }
        break;
      default:
        // Casi non inclusi nelle categorie 2.1-2.9
        // Le pratiche LAVORABILI sono già state gestite all'inizio del metodo
        // Le pratiche con vincoloTipologiaID 1, 3, 4 sono già state processate prima del switch
        // Se arriva qui, la pratica non corrisponde a nessuna categoria nota e verrà conteggiata come NON CATEGORIZZATA
        break;
    }
  }

  onBandoTabChange(event: any) {
    // this.logger.info(`[HOME WIP] ON TAB BANDO CHANGE`);

    this.resetLoadingFlags();
    this.activeBandoIndex = event.index;
    if (this.activeTipoIndex == 0) {
      this.filtroRegioneSop = "";
      this.filtroImpresaSop = null;
      this.filtroTipoSedeEffettivaSop = "";
      this.labelRegioniSop = "Tutte le regioni";
      this.aggiornaOpzioniImpreseBando1Sop();
      this.aggiornaOpzioniImpreseBando2Sop();
      this.datiRaggruppatiBando1SopFiltrati = [
        ...this.datiRaggruppatiBando1Sop,
      ];
      this.datiRaggruppatiBando2SopFiltrati = [
        ...this.datiRaggruppatiBando2Sop,
      ];
      this.filterIsSetSop = false;
    } else if (this.activeTipoIndex == 1) {
      this.filtroRegioneApp = "";
      this.filtroImpresaApp = null;
      this.filtroTipoSedeEffettivaApp = "";
      this.labelRegioniApp = "Tutte le regioni";
      this.aggiornaOpzioniImpreseBando1App();
      this.aggiornaOpzioniImpreseBando2App();
      this.filterIsSetApp = false;
      this.datiRaggruppatiBando1AppFiltrati = [
        ...this.datiRaggruppatiBando1App,
      ];
      this.datiRaggruppatiBando2AppFiltrati = [
        ...this.datiRaggruppatiBando2App,
      ];
    }

    // Carica i dati del nuovo tab se non sono già stati caricati
    this.loadActiveTabData();
  }
  onTabChange(event: any) {
    this.resetLoadingFlags();
    this.activeTipoIndex = event.index;
    if (this.activeTipoIndex == 0) {
      this.filtroRegioneSop = "";
      this.filtroImpresaSop = null;
      this.filtroTipoSedeEffettivaSop = "";
      this.filterIsSetSop = false;
      this.datiRaggruppatiBando1SopFiltrati = [
        ...this.datiRaggruppatiBando1Sop,
      ];
      this.datiRaggruppatiBando2SopFiltrati = [
        ...this.datiRaggruppatiBando2Sop,
      ];
    } else if (this.activeTipoIndex == 1) {
      this.filtroRegioneApp = "";
      this.filtroImpresaApp = null;
      this.filtroTipoSedeEffettivaApp = "";
      this.filterIsSetApp = false;
      this.datiRaggruppatiBando1AppFiltrati = [
        ...this.datiRaggruppatiBando1App,
      ];
      this.datiRaggruppatiBando2AppFiltrati = [
        ...this.datiRaggruppatiBando2App,
      ];
    } else if (this.activeTipoIndex == 2) {
      // Reset filtri OF se si cambia tab
      this.filtroRegioneOF = [];
      this.filtroCategoriaVincoloOF = "";
      this.filterIsSetOF = false;
      this.labelRegioniOF = "Tutte le regioni";
      this.labelCategoriaVincoloOF = "Tutti i servizi OF";
    }
    this.activeBandoIndex = 1; // Default: Bando 2

    // Carica i dati del nuovo tab se non sono già stati caricati
    this.loadActiveTabData();
  }

  aggiornaSituazioneOF() {
    this.importID = uuidv4();
    this.csvbox_importer_aggiornaSituazioneOF.setUser({
      importID: this.importID,
    });
    this.csvbox_importer_aggiornaSituazioneOF.openModal();
  }

  loadDatiBando1App() {
    if (this.bando1AppLoaded) return; // Evita caricamenti multipli
    this.isLoadingApp = true;
    this.bando1AppLoaded = true; // Imposta subito per evitare chiamate multiple
    this.logger.info("[HOME WIP] LOAD DATI BANDO 1 APP");
    const collectionRef = this.firestore.collection(
      this.collection_pratiche,
    ).ref;
    let queryBando1;
    if (this.isImpresa) {
      queryBando1 = collectionRef
        .where("idAziendaFase2", "==", this.userService.getUser().azienda.id)
        .where("bando", "==", "BANDO 1")
        .orderBy("aziendaFase2", "asc");
    } else {
      queryBando1 = collectionRef
        .where("bando", "==", "BANDO 1")
        .orderBy("statoFlowdyFase1")
        .orderBy("aziendaFase2", "asc");
    }
    onSnapshot(queryBando1, (qs) => {
      this.logger.info(
        "[HOME WIP] DATI BANDO 1 APP ARRIVATI " + qs.docs.length,
      );
      this.isLoadingApp = false;
      const tipiSedeEffettivaAppSet = new Set<string>();
      const raggruppamentoPerImpresa: {
        [key: string]: {
          idImpresa: number;
          totale: number;
          noAppuntamentoMancaPF_noNTW: number;
          noAppuntamentoMancaPF_conNTW: number;
          noAppuntamentoPFPronto: number;
          appuntamentoFissato: number;
          appuntamentoScaduto: number;
          attivazioneKO: number;
          attivazioneOK: number;
          installazioneOK: number;
          datiPerRegione: {
            [regione: string]: {
              totale: number;
              noAppuntamentoMancaPF_noNTW: number;
              noAppuntamentoMancaPF_conNTW: number;
              noAppuntamentoPFPronto: number;
              appuntamentoFissato: number;
              appuntamentoScaduto: number;
              attivazioneKO: number;
              attivazioneOK: number;
              installazioneOK: number;
            };
          };
          datiPerTipoSedeEffettiva: {
            [tipoSede: string]: {
              totale: number;
              noAppuntamentoMancaPF_noNTW: number;
              noAppuntamentoMancaPF_conNTW: number;
              noAppuntamentoPFPronto: number;
              appuntamentoFissato: number;
              appuntamentoScaduto: number;
              attivazioneKO: number;
              attivazioneOK: number;
              installazioneOK: number;
            };
          };
        };
      } = {};

      this.totaliAppBando1 = 0;
      this.totaliAppBando1NoAppuntamentoMancaPF_noNTW = 0;
      this.totaliAppBando1NoAppuntamentoMancaPF_conNTW = 0;
      this.totaliAppBando1NoAppuntamentoPFPronto = 0;
      this.totaliAppBando1AppuntamentoFissato = 0;
      this.totaliAppBando1AppuntamentoScaduto = 0;
      this.totaliAppBando1AttivazioneKO = 0;
      this.totaliAppBando1AttivazioneOK = 0;
      this.totaliAppBando1installazioneOK = 0;
      let contatoreSITE = 0;
      qs.docs.forEach((doc) => {
        let praticaBando1DaFirestore: PraticaFlowdy2_Firestore =
          doc.data() as PraticaFlowdy2_Firestore;
        const impresa = praticaBando1DaFirestore.aziendaFase2
          ? praticaBando1DaFirestore.aziendaFase2
          : praticaBando1DaFirestore.azienda;
        const regione = praticaBando1DaFirestore.regione;
        const tipoSedeEffettiva =
          praticaBando1DaFirestore.tipoSedeEffettiva?.trim() ||
          "Non specificato";
        tipiSedeEffettivaAppSet.add(tipoSedeEffettiva);

        if (!raggruppamentoPerImpresa[impresa]) {
          // this.logger.info(impresa + " @ "+ regione);
          raggruppamentoPerImpresa[impresa] = {
            idImpresa: praticaBando1DaFirestore.idAziendaFase2
              ? praticaBando1DaFirestore.idAziendaFase2
              : praticaBando1DaFirestore.idAzienda,
            totale: 0,
            noAppuntamentoMancaPF_noNTW: 0,
            noAppuntamentoMancaPF_conNTW: 0,
            noAppuntamentoPFPronto: 0,
            appuntamentoFissato: 0,
            appuntamentoScaduto: 0,
            attivazioneKO: 0,
            attivazioneOK: 0,
            installazioneOK: 0,
            datiPerRegione: {},
            datiPerTipoSedeEffettiva: {},
          };
        }
        if (
          !raggruppamentoPerImpresa[impresa].datiPerTipoSedeEffettiva[
            tipoSedeEffettiva
          ]
        ) {
          raggruppamentoPerImpresa[impresa].datiPerTipoSedeEffettiva[
            tipoSedeEffettiva
          ] = {
            totale: 0,
            noAppuntamentoMancaPF_noNTW: 0,
            noAppuntamentoMancaPF_conNTW: 0,
            noAppuntamentoPFPronto: 0,
            appuntamentoFissato: 0,
            appuntamentoScaduto: 0,
            attivazioneKO: 0,
            attivazioneOK: 0,
            installazioneOK: 0,
          };
        }
        if (!raggruppamentoPerImpresa[impresa].datiPerRegione[regione]) {
          raggruppamentoPerImpresa[impresa].datiPerRegione[regione] = {
            totale: 0,
            noAppuntamentoMancaPF_noNTW: 0,
            noAppuntamentoMancaPF_conNTW: 0,
            noAppuntamentoPFPronto: 0,
            appuntamentoFissato: 0,
            appuntamentoScaduto: 0,
            attivazioneKO: 0,
            attivazioneOK: 0,
            installazioneOK: 0,
          };
        }

        if (
          praticaBando1DaFirestore.codiceStatoInfratelFase1 === "1-6" ||
          praticaBando1DaFirestore.showFase2
        ) {
          raggruppamentoPerImpresa[impresa].totale += 1;
          raggruppamentoPerImpresa[impresa].datiPerRegione[regione].totale += 1;
          raggruppamentoPerImpresa[impresa].datiPerTipoSedeEffettiva[
            tipoSedeEffettiva
          ].totale += 1;

          if (
            !praticaBando1DaFirestore.statoPF ||
            praticaBando1DaFirestore.statoPF === "" ||
            praticaBando1DaFirestore.statoPF.length < 1
          ) {
            if (
              !praticaBando1DaFirestore.ntwFC ||
              praticaBando1DaFirestore.ntwFC === "" ||
              praticaBando1DaFirestore.ntwFC.length < 1
            ) {
              raggruppamentoPerImpresa[impresa].noAppuntamentoMancaPF_noNTW++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione]
                .noAppuntamentoMancaPF_noNTW++;
              raggruppamentoPerImpresa[impresa].datiPerTipoSedeEffettiva[
                tipoSedeEffettiva
              ].noAppuntamentoMancaPF_noNTW++;
            } else {
              raggruppamentoPerImpresa[impresa].noAppuntamentoMancaPF_conNTW++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione]
                .noAppuntamentoMancaPF_conNTW++;
              raggruppamentoPerImpresa[impresa].datiPerTipoSedeEffettiva[
                tipoSedeEffettiva
              ].noAppuntamentoMancaPF_conNTW++;
            }
          } else {
            if (praticaBando1DaFirestore.statoPF === "IN ATTESA") {
              if (
                praticaBando1DaFirestore.statoFlowdyFase1 === "SOPRALLUOGO KO"
              ) {
                /* if(praticaBando1DaFirestore.azienda === 'SIRTI SPA'){
                      this.logger.info("PRATICA DI SIRTI CON SOPRALLUOGO KO MA PF IN ATTESA " + praticaBando1DaFirestore.cui + " - "+praticaBando1DaFirestore.codiceStatoInfratelFase1 + " ("+praticaBando1DaFirestore.showFase2+")" + praticaBando1DaFirestore.statoFlowdyFase1 + " "+ praticaBando1DaFirestore.statoPF)
                    } */
              }
              if (
                !praticaBando1DaFirestore.ntwFC ||
                praticaBando1DaFirestore.ntwFC === "" ||
                praticaBando1DaFirestore.ntwFC.length < 1
              ) {
                raggruppamentoPerImpresa[impresa].noAppuntamentoMancaPF_noNTW++;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione]
                  .noAppuntamentoMancaPF_noNTW++;
                raggruppamentoPerImpresa[impresa].datiPerTipoSedeEffettiva[
                  tipoSedeEffettiva
                ].noAppuntamentoMancaPF_noNTW++;
              } else {
                raggruppamentoPerImpresa[impresa]
                  .noAppuntamentoMancaPF_conNTW++;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione]
                  .noAppuntamentoMancaPF_conNTW++;
                raggruppamentoPerImpresa[impresa].datiPerTipoSedeEffettiva[
                  tipoSedeEffettiva
                ].noAppuntamentoMancaPF_conNTW++;
              }
            } else if (praticaBando1DaFirestore.statoPF === "PRONTO") {
              if (!praticaBando1DaFirestore.dataAppuntamentoFase2) {
                raggruppamentoPerImpresa[impresa].noAppuntamentoPFPronto++;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione]
                  .noAppuntamentoPFPronto++;
                raggruppamentoPerImpresa[impresa].datiPerTipoSedeEffettiva[
                  tipoSedeEffettiva
                ].noAppuntamentoPFPronto++;
              } else {
                if (
                  praticaBando1DaFirestore.statoFlowdyFase2 ===
                  "APPUNTAMENTO FISSATO"
                ) {
                  if (
                    !this.checkAppuntamentoPassato(praticaBando1DaFirestore)
                  ) {
                    raggruppamentoPerImpresa[impresa].appuntamentoFissato++;
                    raggruppamentoPerImpresa[impresa].datiPerRegione[regione]
                      .appuntamentoFissato++;
                    raggruppamentoPerImpresa[impresa].datiPerTipoSedeEffettiva[
                      tipoSedeEffettiva
                    ].appuntamentoFissato++;
                  } else {
                    raggruppamentoPerImpresa[impresa].appuntamentoScaduto++;
                    raggruppamentoPerImpresa[impresa].datiPerRegione[regione]
                      .appuntamentoScaduto++;
                    raggruppamentoPerImpresa[impresa].datiPerTipoSedeEffettiva[
                      tipoSedeEffettiva
                    ].appuntamentoScaduto++;
                  }
                } else {
                }
              }
            } else if (praticaBando1DaFirestore.statoPF === "KO") {
              raggruppamentoPerImpresa[impresa].attivazioneKO++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione]
                .attivazioneKO++;
              raggruppamentoPerImpresa[impresa].datiPerTipoSedeEffettiva[
                tipoSedeEffettiva
              ].attivazioneKO++;
            } else if (
              praticaBando1DaFirestore.statoPF === "ROUTER INSTALLATO"
            ) {
              raggruppamentoPerImpresa[impresa].installazioneOK++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione]
                .installazioneOK++;
              raggruppamentoPerImpresa[impresa].datiPerTipoSedeEffettiva[
                tipoSedeEffettiva
              ].installazioneOK++;
            } else if (praticaBando1DaFirestore.statoPF === "SEDE ATTIVATA") {
              raggruppamentoPerImpresa[impresa].attivazioneOK++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione]
                .attivazioneOK++;
              raggruppamentoPerImpresa[impresa].datiPerTipoSedeEffettiva[
                tipoSedeEffettiva
              ].attivazioneOK++;
            } else {
              this.logger.info(
                "[APPUNTAMENTI BANDO 1] CASO STRANO SU STATO PF " +
                  praticaBando1DaFirestore.cui +
                  " STATO FLOWDY " +
                  praticaBando1DaFirestore.statoFlowdyFase2 +
                  " MA CON STATO PF " +
                  praticaBando1DaFirestore.statoPF,
              );
            }
          }
        } else {
        }
      });

      this.datiRaggruppatiBando1App = Object.entries(
        raggruppamentoPerImpresa,
      ).map(([impresa, dati]) => ({
        impresa,
        idImpresa: dati.idImpresa,
        totale: dati.totale,
        noAppuntamentoMancaPF_noNTW: dati.noAppuntamentoMancaPF_noNTW,
        noAppuntamentoMancaPF_conNTW: dati.noAppuntamentoMancaPF_conNTW,
        noAppuntamentoPFPronto: dati.noAppuntamentoPFPronto,
        appuntamentoFissato: dati.appuntamentoFissato,
        appuntamentoScaduto: dati.appuntamentoScaduto,
        attivazioneKO: dati.attivazioneKO,
        attivazioneOK: dati.attivazioneOK,
        installazioneOK: dati.installazioneOK,
        datiPerRegione: dati.datiPerRegione,
        datiPerTipoSedeEffettiva: dati.datiPerTipoSedeEffettiva,
      }));
      this.aggiornaOpzioniImpreseBando1App();
      this.aggiornaOpzioniTipoSedeBando1App(
        Array.from(tipiSedeEffettivaAppSet),
      );
      if (
        (this.filtroRegioneApp && this.filtroRegioneApp.length > 0) ||
        (this.filtroImpresaApp != null &&
          this.filtroImpresaApp !== undefined) ||
        (this.filtroTipoSedeEffettivaApp &&
          this.filtroTipoSedeEffettivaApp.length > 0)
      ) {
        const savedBandoIndex = this.activeBandoIndex;
        this.activeBandoIndex = 0;
        this.applyFiltersBando1App();
        this.activeBandoIndex = savedBandoIndex;
      } else {
        this.datiRaggruppatiBando1AppFiltrati = this.datiRaggruppatiBando1App;
        // Calcola i totali solo se il filtro non è attivo
        for (
          let index = 0;
          index < this.datiRaggruppatiBando1App.length;
          index++
        ) {
          this.totaliAppBando1 += this.datiRaggruppatiBando1App[index].totale;
          this.totaliAppBando1NoAppuntamentoMancaPF_noNTW +=
            this.datiRaggruppatiBando1App[index].noAppuntamentoMancaPF_noNTW;
          this.totaliAppBando1NoAppuntamentoMancaPF_conNTW +=
            this.datiRaggruppatiBando1App[index].noAppuntamentoMancaPF_conNTW;
          this.totaliAppBando1NoAppuntamentoPFPronto +=
            this.datiRaggruppatiBando1App[index].noAppuntamentoPFPronto;
          this.totaliAppBando1AppuntamentoFissato +=
            this.datiRaggruppatiBando1App[index].appuntamentoFissato;
          this.totaliAppBando1AppuntamentoScaduto +=
            this.datiRaggruppatiBando1App[index].appuntamentoScaduto;
          this.totaliAppBando1AttivazioneKO +=
            this.datiRaggruppatiBando1App[index].attivazioneKO;
          this.totaliAppBando1AttivazioneOK +=
            this.datiRaggruppatiBando1App[index].attivazioneOK;
          this.totaliAppBando1installazioneOK +=
            this.datiRaggruppatiBando1App[index].installazioneOK;
        }
      }

      if (contatoreSITE > 0) {
        //   this.logger.info("PRATICHE DI SITE "+ contatoreSITE);
      }
    });
  }

  checkAppuntamentoPassato(pratica: PraticaFlowdy2_Firestore): boolean {
    if (pratica.dataAppuntamentoFase2) {
      const oggi = new Date();
      const dataAppuntamentoDaControllare = new Date(
        pratica.dataAppuntamentoFase2.toDate().getFullYear(),
        pratica.dataAppuntamentoFase2.toDate().getMonth(),
        pratica.dataAppuntamentoFase2.toDate().getDate() + 2,
      );
      if (pratica.dataAppuntamentoFase2 && !pratica.installazioneRouterOk) {
        if (dataAppuntamentoDaControllare < oggi) {
          return true;
        }
        return false;
      }
    }

    return false;
  }

  loadDatiBando2App() {
    if (this.bando2AppLoaded) return; // Evita caricamenti multipli
    this.logger.info("[HOME WIP] LOAD DATI BANDO 2 APP");
    this.isLoadingApp = true;
    this.bando2AppLoaded = true; // Imposta subito per evitare chiamate multiple
    const collectionRef = this.firestore.collection(
      this.collection_pratiche,
    ).ref;
    let queryBando2;
    if (this.isImpresa) {
      queryBando2 = collectionRef
        .where("idAziendaFase2", "==", this.userService.getUser().azienda.id)
        .where("bando", "==", "BANDO 2")
        .orderBy("statoFlowdyFase2")
        .orderBy("aziendaFase2", "asc");
    } else {
      queryBando2 = collectionRef
        .where("bando", "==", "BANDO 2")
        .orderBy("statoFlowdyFase2")
        .orderBy("azienda", "asc");
    }
    onSnapshot(queryBando2, (qs) => {
      this.logger.info(
        "[HOME WIP] DATI BANDO 2 APP ARRIVATI " + qs.docs.length,
      );
      this.isLoadingApp = false;
      this.totaliAppBando2 = 0;
      this.totaliAppBando2NoAppuntamentoMancaPF_noNTW = 0;
      this.totaliAppBando2NoAppuntamentoMancaPF_conNTW = 0;
      this.totaliAppBando2NoAppuntamentoPFPronto = 0;
      this.totaliAppBando2AppuntamentoFissato = 0;
      this.totaliAppBando2AppuntamentoScaduto = 0;
      this.totaliAppBando2AttivazioneKO = 0;
      this.totaliAppBando2AttivazioneOK = 0;
      this.totaliAppBando2installazioneOK = 0;
      const tipiSedeEffettivaAppSet = new Set<string>();
      const raggruppamentoPerImpresa: {
        [key: string]: {
          idImpresa: number;
          totale: number;
          noAppuntamentoMancaPF_noNTW: number;
          noAppuntamentoMancaPF_conNTW: number;
          noAppuntamentoPFPronto: number;
          appuntamentoFissato: number;
          appuntamentoScaduto: number;
          attivazioneKO: number;
          attivazioneOK: number;
          installazioneOK: number;
          datiPerRegione: {
            [regione: string]: {
              totale: number;
              noAppuntamentoMancaPF_noNTW: number;
              noAppuntamentoMancaPF_conNTW: number;
              noAppuntamentoPFPronto: number;
              appuntamentoFissato: number;
              appuntamentoScaduto: number;
              attivazioneKO: number;
              attivazioneOK: number;
              installazioneOK: number;
            };
          };
          datiPerTipoSedeEffettiva: {
            [tipoSede: string]: {
              totale: number;
              noAppuntamentoMancaPF_noNTW: number;
              noAppuntamentoMancaPF_conNTW: number;
              noAppuntamentoPFPronto: number;
              appuntamentoFissato: number;
              appuntamentoScaduto: number;
              attivazioneKO: number;
              attivazioneOK: number;
              installazioneOK: number;
            };
          };
        };
      } = {};

      qs.docs.forEach((doc) => {
        let praticaBando2DaFirestore: PraticaFlowdy2_Firestore =
          doc.data() as PraticaFlowdy2_Firestore;
        const impresa = praticaBando2DaFirestore.aziendaFase2
          ? praticaBando2DaFirestore.aziendaFase2
          : praticaBando2DaFirestore.azienda;
        const regione = praticaBando2DaFirestore.regione;
        const tipoSedeEffettiva =
          praticaBando2DaFirestore.tipoSedeEffettiva?.trim() ||
          praticaBando2DaFirestore.tipoSede?.trim() ||
          "Non specificato";
        tipiSedeEffettivaAppSet.add(tipoSedeEffettiva);

        if (!raggruppamentoPerImpresa[impresa]) {
          raggruppamentoPerImpresa[impresa] = {
            idImpresa: praticaBando2DaFirestore.idAziendaFase2
              ? praticaBando2DaFirestore.idAziendaFase2
              : praticaBando2DaFirestore.idAzienda,
            totale: 0,
            noAppuntamentoMancaPF_noNTW: 0,
            noAppuntamentoMancaPF_conNTW: 0,
            noAppuntamentoPFPronto: 0,
            appuntamentoFissato: 0,
            appuntamentoScaduto: 0,
            attivazioneKO: 0,
            attivazioneOK: 0,
            installazioneOK: 0,
            datiPerRegione: {},
            datiPerTipoSedeEffettiva: {},
          };
        }
        if (
          !raggruppamentoPerImpresa[impresa].datiPerTipoSedeEffettiva![
            tipoSedeEffettiva
          ]
        ) {
          raggruppamentoPerImpresa[impresa].datiPerTipoSedeEffettiva![
            tipoSedeEffettiva
          ] = {
            totale: 0,
            noAppuntamentoMancaPF_noNTW: 0,
            noAppuntamentoMancaPF_conNTW: 0,
            noAppuntamentoPFPronto: 0,
            appuntamentoFissato: 0,
            appuntamentoScaduto: 0,
            attivazioneKO: 0,
            attivazioneOK: 0,
            installazioneOK: 0,
          };
        }
        if (!raggruppamentoPerImpresa[impresa].datiPerRegione[regione]) {
          raggruppamentoPerImpresa[impresa].datiPerRegione[regione] = {
            totale: 0,
            noAppuntamentoMancaPF_noNTW: 0,
            noAppuntamentoMancaPF_conNTW: 0,
            noAppuntamentoPFPronto: 0,
            appuntamentoFissato: 0,
            appuntamentoScaduto: 0,
            attivazioneKO: 0,
            attivazioneOK: 0,
            installazioneOK: 0,
          };
        }
        if (
          praticaBando2DaFirestore.codiceStatoInfratelFase1 === "1-6" ||
          praticaBando2DaFirestore.showFase2
        ) {
          raggruppamentoPerImpresa[impresa].totale += 1;
          raggruppamentoPerImpresa[impresa].datiPerRegione[regione].totale += 1;
          raggruppamentoPerImpresa[impresa].datiPerTipoSedeEffettiva![
            tipoSedeEffettiva
          ].totale += 1;

          if (
            !praticaBando2DaFirestore.statoPF ||
            praticaBando2DaFirestore.statoPF === "" ||
            praticaBando2DaFirestore.statoPF.length < 1
          ) {
            if (
              !praticaBando2DaFirestore.ntwFC ||
              praticaBando2DaFirestore.ntwFC === "" ||
              praticaBando2DaFirestore.ntwFC.length < 1
            ) {
              raggruppamentoPerImpresa[impresa].noAppuntamentoMancaPF_noNTW++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione]
                .noAppuntamentoMancaPF_noNTW++;
              raggruppamentoPerImpresa[impresa].datiPerTipoSedeEffettiva![
                tipoSedeEffettiva
              ].noAppuntamentoMancaPF_noNTW++;
            } else {
              raggruppamentoPerImpresa[impresa].noAppuntamentoMancaPF_conNTW++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione]
                .noAppuntamentoMancaPF_conNTW++;
              raggruppamentoPerImpresa[impresa].datiPerTipoSedeEffettiva![
                tipoSedeEffettiva
              ].noAppuntamentoMancaPF_conNTW++;
            }
          } else {
            if (praticaBando2DaFirestore.statoPF === "IN ATTESA") {
              if (
                praticaBando2DaFirestore.statoFlowdyFase1 === "SOPRALLUOGO KO"
              ) {
                /*  if(praticaBando2DaFirestore.azienda === 'SIRTI SPA'){
                  this.logger.info("PRATICA DI SIRTI CON SOPRALLUOGO KO MA PF IN ATTESA " + praticaBando2DaFirestore.cui + " - "+praticaBando2DaFirestore.codiceStatoInfratelFase1 + " ("+praticaBando2DaFirestore.showFase2+")" + praticaBando2DaFirestore.statoFlowdyFase1 + " "+ praticaBando2DaFirestore.statoPF)
                } */
              }
              if (
                !praticaBando2DaFirestore.ntwFC ||
                praticaBando2DaFirestore.ntwFC === "" ||
                praticaBando2DaFirestore.ntwFC.length < 1
              ) {
                raggruppamentoPerImpresa[impresa].noAppuntamentoMancaPF_noNTW++;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione]
                  .noAppuntamentoMancaPF_noNTW++;
                raggruppamentoPerImpresa[impresa].datiPerTipoSedeEffettiva![
                  tipoSedeEffettiva
                ].noAppuntamentoMancaPF_noNTW++;
              } else {
                raggruppamentoPerImpresa[impresa]
                  .noAppuntamentoMancaPF_conNTW++;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione]
                  .noAppuntamentoMancaPF_conNTW++;
                raggruppamentoPerImpresa[impresa].datiPerTipoSedeEffettiva![
                  tipoSedeEffettiva
                ].noAppuntamentoMancaPF_conNTW++;
              }
            } else if (praticaBando2DaFirestore.statoPF === "PRONTO") {
              if (!praticaBando2DaFirestore.dataAppuntamentoFase2) {
                raggruppamentoPerImpresa[impresa].noAppuntamentoPFPronto++;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione]
                  .noAppuntamentoPFPronto++;
                raggruppamentoPerImpresa[impresa].datiPerTipoSedeEffettiva![
                  tipoSedeEffettiva
                ].noAppuntamentoPFPronto++;
              } else {
                if (
                  praticaBando2DaFirestore.statoFlowdyFase2 ===
                  "APPUNTAMENTO FISSATO"
                ) {
                  if (
                    !this.checkAppuntamentoPassato(praticaBando2DaFirestore)
                  ) {
                    raggruppamentoPerImpresa[impresa].appuntamentoFissato++;
                    raggruppamentoPerImpresa[impresa].datiPerRegione[regione]
                      .appuntamentoFissato++;
                    raggruppamentoPerImpresa[impresa].datiPerTipoSedeEffettiva![
                      tipoSedeEffettiva
                    ].appuntamentoFissato++;
                  } else {
                    raggruppamentoPerImpresa[impresa].appuntamentoScaduto++;
                    raggruppamentoPerImpresa[impresa].datiPerRegione[regione]
                      .appuntamentoScaduto++;
                    raggruppamentoPerImpresa[impresa].datiPerTipoSedeEffettiva![
                      tipoSedeEffettiva
                    ].appuntamentoScaduto++;
                  }
                } else {
                  this.logger.info(
                    "CASO STRANO " +
                      praticaBando2DaFirestore.cui +
                      " STATO FLOWDY " +
                      praticaBando2DaFirestore.statoFlowdyFase2 +
                      " MA CON STATO PF " +
                      praticaBando2DaFirestore.statoPF +
                      " E DATA APPUNTAMENTO " +
                      praticaBando2DaFirestore.dataAppuntamentoFase2.toDate(),
                  );
                }
              }
            } else if (praticaBando2DaFirestore.statoPF === "KO") {
              raggruppamentoPerImpresa[impresa].attivazioneKO++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione]
                .attivazioneKO++;
              raggruppamentoPerImpresa[impresa].datiPerTipoSedeEffettiva![
                tipoSedeEffettiva
              ].attivazioneKO++;
            } else if (
              praticaBando2DaFirestore.statoPF === "ROUTER INSTALLATO"
            ) {
              raggruppamentoPerImpresa[impresa].installazioneOK++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione]
                .installazioneOK++;
              raggruppamentoPerImpresa[impresa].datiPerTipoSedeEffettiva![
                tipoSedeEffettiva
              ].installazioneOK++;
            } else if (praticaBando2DaFirestore.statoPF === "SEDE ATTIVATA") {
              raggruppamentoPerImpresa[impresa].attivazioneOK++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione]
                .attivazioneOK++;
              raggruppamentoPerImpresa[impresa].datiPerTipoSedeEffettiva![
                tipoSedeEffettiva
              ].attivazioneOK++;
            } else {
              // this.logger.info("CASO STRANO dentro "+ praticaBando2DaFirestore.cui + " STATO FLOWDY "+ praticaBando2DaFirestore.statoFlowdyFase2 + " MA CON STATO PF "+ praticaBando2DaFirestore.statoPF );
            }
          }
        } else {
        }
      });
      this.datiRaggruppatiBando2App = Object.entries(
        raggruppamentoPerImpresa,
      ).map(([impresa, dati]) => ({
        impresa,
        idImpresa: dati.idImpresa,
        totale: dati.totale,
        noAppuntamentoMancaPF_noNTW: dati.noAppuntamentoMancaPF_noNTW,
        noAppuntamentoMancaPF_conNTW: dati.noAppuntamentoMancaPF_conNTW,
        noAppuntamentoPFPronto: dati.noAppuntamentoPFPronto,
        appuntamentoFissato: dati.appuntamentoFissato,
        appuntamentoScaduto: dati.appuntamentoScaduto,
        attivazioneKO: dati.attivazioneKO,
        attivazioneOK: dati.attivazioneOK,
        installazioneOK: dati.installazioneOK,
        datiPerRegione: dati.datiPerRegione,
        datiPerTipoSedeEffettiva: dati.datiPerTipoSedeEffettiva,
      }));
      this.aggiornaOpzioniImpreseBando2App();
      this.aggiornaOpzioniTipoSedeBando2App(
        Array.from(tipiSedeEffettivaAppSet),
      );
      // Preserva i filtri se attivi per Appuntamenti Bando 2
      if (
        (this.filtroRegioneApp && this.filtroRegioneApp.length > 0) ||
        (this.filtroImpresaApp != null &&
          this.filtroImpresaApp !== undefined) ||
        (this.filtroTipoSedeEffettivaApp &&
          this.filtroTipoSedeEffettivaApp.length > 0)
      ) {
        // Salva temporaneamente activeBandoIndex per applicare il filtro corretto
        const savedBandoIndex = this.activeBandoIndex;
        this.activeBandoIndex = 1;
        this.applyFiltersBando2App();
        this.activeBandoIndex = savedBandoIndex;
      } else {
        this.datiRaggruppatiBando2AppFiltrati = this.datiRaggruppatiBando2App;
        // Calcola i totali solo se il filtro non è attivo
        for (
          let index = 0;
          index < this.datiRaggruppatiBando2AppFiltrati.length;
          index++
        ) {
          this.totaliAppBando2 +=
            this.datiRaggruppatiBando2AppFiltrati[index].totale;
          this.totaliAppBando2NoAppuntamentoMancaPF_noNTW +=
            this.datiRaggruppatiBando2AppFiltrati[
              index
            ].noAppuntamentoMancaPF_noNTW;
          this.totaliAppBando2NoAppuntamentoMancaPF_conNTW +=
            this.datiRaggruppatiBando2AppFiltrati[
              index
            ].noAppuntamentoMancaPF_conNTW;
          this.totaliAppBando2NoAppuntamentoPFPronto +=
            this.datiRaggruppatiBando2AppFiltrati[index].noAppuntamentoPFPronto;
          this.totaliAppBando2AppuntamentoFissato +=
            this.datiRaggruppatiBando2AppFiltrati[index].appuntamentoFissato;
          this.totaliAppBando2AppuntamentoScaduto +=
            this.datiRaggruppatiBando2AppFiltrati[index].appuntamentoScaduto;
          this.totaliAppBando2AttivazioneKO +=
            this.datiRaggruppatiBando2AppFiltrati[index].attivazioneKO;
          this.totaliAppBando2AttivazioneOK +=
            this.datiRaggruppatiBando2AppFiltrati[index].attivazioneOK;
          this.totaliAppBando2installazioneOK +=
            this.datiRaggruppatiBando2AppFiltrati[index].installazioneOK;
        }
      }
    });
  }

  loadDatiBando1Sop() {
    if (this.bando1SopLoaded || this.isLoadingBando1Sop) {
      return; // Evita caricamenti multipli
    }
    this.isLoadingSop = true;
    this.isLoadingBando1Sop = true; // Imposta subito per evitare chiamate multiple
    this.bando1SopLoaded = true; // Imposta subito per evitare chiamate multiple

    const collectionRef = this.firestore.collection(
      this.collection_pratiche,
    ).ref;
    let queryBando1;
    if (this.isImpresa) {
      queryBando1 = collectionRef
        .where("idAziendaFase1", "==", this.userService.getUser().azienda.id)
        .where("bando", "==", "BANDO 1")
        .orderBy("aziendaFase1", "asc");
    } else {
      queryBando1 = collectionRef
        .where("bando", "==", "BANDO 1")
        .orderBy("aziendaFase1", "asc");
    }
    this.logger.info("[HOME WIP] LOADING DATI BANDO 1 SOP ");

    onSnapshot(queryBando1, (qs) => {
      this.isLoadingSop = false;
      this.logger.info(
        "[HOME WIP] DATI BANDO 1 SOP ARRIVATI " + qs.docs.length,
      );
      const tipiSedeEffettivaSet = new Set<string>();
      const raggruppamentoPerImpresa: {
        [key: string]: {
          idImpresa: number;
          totale: number;
          noSopralluogo: number;
          noSopralluogoPF: number;
          sopralluogoPianificato: number;
          sopralluogoEseguito: number;
          sopralluogoKO: number;
          datiPerRegione: {
            [regione: string]: {
              totale: number;
              noSopralluogo: number;
              noSopralluogoPF: number;
              sopralluogoPianificato: number;
              sopralluogoEseguito: number;
              sopralluogoKO: number;
            };
          };
          datiPerTipoSedeEffettiva: {
            [tipoSede: string]: {
              totale: number;
              noSopralluogo: number;
              noSopralluogoPF: number;
              sopralluogoPianificato: number;
              sopralluogoEseguito: number;
              sopralluogoKO: number;
            };
          };
        };
      } = {};

      this.totaliSopralluogoBando1 = 0;
      this.totaliNoSopralluogoBando1 = 0;
      this.totaliNoSopralluogoPFBando1 = 0;
      this.totaliSopralluogoPianificatoBando1 = 0;
      this.totaliSopralluogoEseguitoBando1 = 0;
      this.totaliSopralluogoKOBando1 = 0;
      qs.docs.forEach((doc) => {
        let praticaBando1DaFirestore: PraticaFlowdy2_Firestore =
          doc.data() as PraticaFlowdy2_Firestore;
        const impresa = praticaBando1DaFirestore.aziendaFase1
          ? praticaBando1DaFirestore.aziendaFase1
          : praticaBando1DaFirestore.azienda;
        const regione = praticaBando1DaFirestore.regione;
        const tipoSedeEffettiva =
          praticaBando1DaFirestore.tipoSedeEffettiva?.trim() ||
          "Non specificato";
        tipiSedeEffettivaSet.add(tipoSedeEffettiva);

        if (!raggruppamentoPerImpresa[impresa]) {
          raggruppamentoPerImpresa[impresa] = {
            idImpresa: praticaBando1DaFirestore.idAziendaFase1
              ? praticaBando1DaFirestore.idAziendaFase1
              : praticaBando1DaFirestore.idAzienda,
            totale: 0,
            noSopralluogo: 0,
            noSopralluogoPF: 0,
            sopralluogoPianificato: 0,
            sopralluogoEseguito: 0,
            sopralluogoKO: 0,
            datiPerRegione: {},
            datiPerTipoSedeEffettiva: {},
          };
        }
        if (
          !raggruppamentoPerImpresa[impresa].datiPerTipoSedeEffettiva[
            tipoSedeEffettiva
          ]
        ) {
          raggruppamentoPerImpresa[impresa].datiPerTipoSedeEffettiva[
            tipoSedeEffettiva
          ] = {
            totale: 0,
            noSopralluogo: 0,
            noSopralluogoPF: 0,
            sopralluogoPianificato: 0,
            sopralluogoEseguito: 0,
            sopralluogoKO: 0,
          };
        }
        if (!raggruppamentoPerImpresa[impresa].datiPerRegione[regione]) {
          raggruppamentoPerImpresa[impresa].datiPerRegione[regione] = {
            totale: 0,
            noSopralluogo: 0,
            noSopralluogoPF: 0,
            sopralluogoPianificato: 0,
            sopralluogoEseguito: 0,
            sopralluogoKO: 0,
          };
        }
        raggruppamentoPerImpresa[impresa].totale += 1;
        raggruppamentoPerImpresa[impresa].datiPerRegione[regione].totale += 1;
        raggruppamentoPerImpresa[impresa].datiPerTipoSedeEffettiva[
          tipoSedeEffettiva
        ].totale += 1;

        /* if(praticaBando1DaFirestore.showFase2){
            if(impresa==='COGEPA'){
              this.logger.info("[HOME WIP] PRATICA DI COGEPA CON SHOWFASE 2 " + praticaBando1DaFirestore.cui + " aziendaFase1 " + praticaBando1DaFirestore.aziendaFase1 + " "+ praticaBando1DaFirestore.statoFlowdyFase1  + " CONSIDERATA SOPRALLUOGO PIANIFICATO");
            } 
            if(!praticaBando1DaFirestore.dataSopralluogo || praticaBando1DaFirestore.dataSopralluogo == null){
              raggruppamentoPerImpresa[impresa].noSopralluogoPF++;
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione].noSopralluogoPF++;


              if(!praticaBando1DaFirestore.dataAppuntamentoFase2 || praticaBando1DaFirestore.dataAppuntamentoFase2== null){
                raggruppamentoPerImpresa[impresa].noSopralluogoPF++;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].noSopralluogoPF++;
              }else{
               
                if(praticaBando1DaFirestore.statoFlowdyFase1==='SOPRALLUOGO EFFETTUATO'){
                  raggruppamentoPerImpresa[impresa].sopralluogoEseguito++;
                  raggruppamentoPerImpresa[impresa].datiPerRegione[regione].sopralluogoEseguito++;
                }else{
                 if(praticaBando1DaFirestore.dataAppuntamentoFase2 && praticaBando1DaFirestore.statoFlowdyFase2 !== 'ATTIVAZIONE KO FO'){
                 
                    raggruppamentoPerImpresa[impresa].sopralluogoPianificato++;
                    raggruppamentoPerImpresa[impresa].datiPerRegione[regione].sopralluogoPianificato++;
                  }else{
                    raggruppamentoPerImpresa[impresa].noSopralluogoPF++;
                    raggruppamentoPerImpresa[impresa].datiPerRegione[regione].noSopralluogoPF++;
                  }
                 
                }
               
              }
              

            }else{
              
              if(praticaBando1DaFirestore.statoFlowdyFase1==='SOPRALLUOGO EFFETTUATO' || (praticaBando1DaFirestore.sopralluogoOk && praticaBando1DaFirestore.dataSopralluogo)){
                raggruppamentoPerImpresa[impresa].sopralluogoEseguito++;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].sopralluogoEseguito++;
              }else{
               
                raggruppamentoPerImpresa[impresa].sopralluogoPianificato++;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].sopralluogoPianificato++;
              }
            }
            
          }else{ */

        if (
          praticaBando1DaFirestore.statoFlowdyFase1 === "IN ATTESA ODA" ||
          praticaBando1DaFirestore.statoFlowdyFase1 === "DA ASSEGNARE" ||
          praticaBando1DaFirestore.statoFlowdyFase1 === "ASSEGNATA"
        ) {
          raggruppamentoPerImpresa[impresa].noSopralluogo++;
          raggruppamentoPerImpresa[impresa].datiPerRegione[regione]
            .noSopralluogo++;
          raggruppamentoPerImpresa[impresa].datiPerTipoSedeEffettiva[
            tipoSedeEffettiva
          ].noSopralluogo++;
        } else if (
          praticaBando1DaFirestore.statoFlowdyFase1 ===
          "SOPRALLUOGO PIANIFICATO"
        ) {
          raggruppamentoPerImpresa[impresa].sopralluogoPianificato++;
          raggruppamentoPerImpresa[impresa].datiPerRegione[regione]
            .sopralluogoPianificato++;
          raggruppamentoPerImpresa[impresa].datiPerTipoSedeEffettiva[
            tipoSedeEffettiva
          ].sopralluogoPianificato++;
        } else if (
          praticaBando1DaFirestore.statoFlowdyFase1 === "SOPRALLUOGO KO"
        ) {
          raggruppamentoPerImpresa[impresa].sopralluogoKO++;
          raggruppamentoPerImpresa[impresa].datiPerRegione[regione]
            .sopralluogoKO++;
          raggruppamentoPerImpresa[impresa].datiPerTipoSedeEffettiva[
            tipoSedeEffettiva
          ].sopralluogoKO++;
        } else {
          if (praticaBando1DaFirestore.sopralluogoOk !== false) {
            raggruppamentoPerImpresa[impresa].sopralluogoEseguito++;
            raggruppamentoPerImpresa[impresa].datiPerRegione[regione]
              .sopralluogoEseguito++;
            raggruppamentoPerImpresa[impresa].datiPerTipoSedeEffettiva[
              tipoSedeEffettiva
            ].sopralluogoEseguito++;
          } /* else{
               raggruppamentoPerImpresa[impresa].sopralluogoKO++;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].sopralluogoKO++;

              } */
        }
        // }
      });

      this.datiRaggruppatiBando1Sop = Object.entries(
        raggruppamentoPerImpresa,
      ).map(([impresa, dati]) => ({
        impresa,
        idImpresa: dati.idImpresa,
        totale: dati.totale,
        noSopralluogo: dati.noSopralluogo,
        noSopralluogoPF: dati.noSopralluogoPF,
        sopralluogoPianificato: dati.sopralluogoPianificato,
        sopralluogoEseguito: dati.sopralluogoEseguito,
        sopralluogoKO: dati.sopralluogoKO,
        datiPerRegione: dati.datiPerRegione,
        datiPerTipoSedeEffettiva: dati.datiPerTipoSedeEffettiva,
      }));
      this.aggiornaOpzioniImpreseBando1Sop();
      this.aggiornaOpzioniTipoSedeBando1Sop(Array.from(tipiSedeEffettivaSet));
      // Preserva i filtri se attivi per Sopralluoghi Bando 1
      if (
        (this.filtroRegioneSop && this.filtroRegioneSop.length > 0) ||
        (this.filtroImpresaSop != null &&
          this.filtroImpresaSop !== undefined) ||
        (this.filtroTipoSedeEffettivaSop &&
          this.filtroTipoSedeEffettivaSop.length > 0)
      ) {
        const savedBandoIndex = this.activeBandoIndex;
        this.activeBandoIndex = 0;
        this.applyFiltersBando1Sop();
        this.activeBandoIndex = savedBandoIndex;
      } else {
        this.datiRaggruppatiBando1SopFiltrati = this.datiRaggruppatiBando1Sop;
        // Calcola i totali solo se il filtro non è attivo
        for (
          let index = 0;
          index < this.datiRaggruppatiBando1Sop.length;
          index++
        ) {
          // this.logger.info(this.datiRaggruppatiBando1Sop[index].impresa + " " + this.datiRaggruppatiBando1Sop[index].sopralluogoPianificato + " " + this.datiRaggruppatiBando1Sop[index].sopralluogoEseguito + " " + this.datiRaggruppatiBando1Sop[index].sopralluogoKO);

          this.totaliSopralluogoBando1 +=
            this.datiRaggruppatiBando1Sop[index].totale;
          this.totaliNoSopralluogoBando1 +=
            this.datiRaggruppatiBando1Sop[index].noSopralluogo;
          this.totaliNoSopralluogoPFBando1 +=
            this.datiRaggruppatiBando1Sop[index].noSopralluogoPF;
          this.totaliSopralluogoPianificatoBando1 +=
            this.datiRaggruppatiBando1Sop[index].sopralluogoPianificato;
          this.totaliSopralluogoKOBando1 +=
            this.datiRaggruppatiBando1Sop[index].sopralluogoKO;
          this.totaliSopralluogoEseguitoBando1 +=
            this.datiRaggruppatiBando1Sop[index].sopralluogoEseguito;
        }
      }

      // console.log("Dati raggruppati per impresa:", this.datiRaggruppatiBando1);
      this.isLoadingBando1Sop = false; // Reset del flag di caricamento
    });
  }

  loadDatiBando2Sop() {
    if (this.bando2SopLoaded) return; // Evita caricamenti multipli
    this.logger.info("[HOME WIP] LOAD DATI BANDO 2 SOP");
    this.isLoadingSop = true;
    this.bando2SopLoaded = true; // Imposta subito per evitare chiamate multiple
    const collectionRef = this.firestore.collection(
      this.collection_pratiche,
    ).ref;
    let queryBando2;
    if (this.isImpresa) {
      queryBando2 = collectionRef
        .where("idAziendaFase1", "==", this.userService.getUser().azienda.id)
        .where("bando", "==", "BANDO 2")
        .orderBy("azienda", "asc");
    } else {
      queryBando2 = collectionRef
        .where("bando", "==", "BANDO 2")
        .orderBy("aziendaFase1", "asc");
    }
    onSnapshot(queryBando2, (qs) => {
      this.logger.info(
        "[HOME WIP] DATI BANDO 2 SOP ARRIVATI " + qs.docs.length,
      );
      this.isLoadingSop = false;
      this.totaliSopralluogoBando2 = 0;
      this.totaliNoSopralluogoBando2 = 0;
      this.totaliNoSopralluogoPFBando2 = 0;
      this.totaliSopralluogoPianificatoBando2 = 0;
      this.totaliSopralluogoEseguitoBando2 = 0;
      this.totaliSopralluogoKOBando2 = 0;
      const tipiSedeEffettivaSet = new Set<string>();
      const raggruppamentoPerImpresa: {
        [key: string]: {
          idImpresa: number;
          totale: number;
          noSopralluogo: number;
          noSopralluogoPF: number;
          sopralluogoPianificato: number;
          sopralluogoEseguito: number;
          sopralluogoKO: number;
          datiPerRegione: {
            [regione: string]: {
              totale: number;
              noSopralluogo: number;
              noSopralluogoPF: number;
              sopralluogoPianificato: number;
              sopralluogoEseguito: number;
              sopralluogoKO: number;
            };
          };
          datiPerTipoSedeEffettiva: {
            [tipoSede: string]: {
              totale: number;
              noSopralluogo: number;
              noSopralluogoPF: number;
              sopralluogoPianificato: number;
              sopralluogoEseguito: number;
              sopralluogoKO: number;
            };
          };
        };
      } = {};

      qs.forEach((doc) => {
        let praticaBando2DaFirestore: PraticaFlowdy2_Firestore =
          doc.data() as PraticaFlowdy2_Firestore;
        const impresa = praticaBando2DaFirestore.aziendaFase1
          ? praticaBando2DaFirestore.aziendaFase1
          : praticaBando2DaFirestore.azienda;
        const regione = praticaBando2DaFirestore.regione;
        const tipoSedeEffettiva =
          praticaBando2DaFirestore.tipoSedeEffettiva?.trim() ||
          "Non specificato";
        tipiSedeEffettivaSet.add(tipoSedeEffettiva);
        if (!raggruppamentoPerImpresa[impresa]) {
          raggruppamentoPerImpresa[impresa] = {
            idImpresa: praticaBando2DaFirestore.idAziendaFase1
              ? praticaBando2DaFirestore.idAziendaFase1
              : praticaBando2DaFirestore.idAzienda,
            totale: 0,
            noSopralluogo: 0,
            noSopralluogoPF: 0,
            sopralluogoPianificato: 0,
            sopralluogoEseguito: 0,
            sopralluogoKO: 0,
            datiPerRegione: {},
            datiPerTipoSedeEffettiva: {},
          };
        }

        if (
          !raggruppamentoPerImpresa[impresa].datiPerTipoSedeEffettiva![
            tipoSedeEffettiva
          ]
        ) {
          raggruppamentoPerImpresa[impresa].datiPerTipoSedeEffettiva![
            tipoSedeEffettiva
          ] = {
            totale: 0,
            noSopralluogo: 0,
            noSopralluogoPF: 0,
            sopralluogoPianificato: 0,
            sopralluogoEseguito: 0,
            sopralluogoKO: 0,
          };
        }

        if (!raggruppamentoPerImpresa[impresa].datiPerRegione[regione]) {
          raggruppamentoPerImpresa[impresa].datiPerRegione[regione] = {
            totale: 0,
            noSopralluogo: 0,
            noSopralluogoPF: 0,
            sopralluogoPianificato: 0,
            sopralluogoEseguito: 0,
            sopralluogoKO: 0,
          };
        }
        raggruppamentoPerImpresa[impresa].totale += 1;
        raggruppamentoPerImpresa[impresa].datiPerRegione[regione].totale += 1;
        raggruppamentoPerImpresa[impresa].datiPerTipoSedeEffettiva![
          tipoSedeEffettiva
        ].totale += 1;

        /* if(praticaBando2DaFirestore.showFase2){
             
              if(!praticaBando2DaFirestore.dataSopralluogo || praticaBando2DaFirestore.dataSopralluogo == null){
                if(!praticaBando2DaFirestore.dataAppuntamentoFase2 || praticaBando2DaFirestore.dataAppuntamentoFase2== null){
                  raggruppamentoPerImpresa[impresa].noSopralluogoPF++;
                  raggruppamentoPerImpresa[impresa].datiPerRegione[regione].noSopralluogoPF++;
                }else{
                 
                  if(praticaBando2DaFirestore.statoFlowdyFase1==='SOPRALLUOGO EFFETTUATO'){
                    raggruppamentoPerImpresa[impresa].sopralluogoEseguito++;
                    raggruppamentoPerImpresa[impresa].datiPerRegione[regione].sopralluogoEseguito++;
                  }else{
                    
                   if(praticaBando2DaFirestore.dataAppuntamentoFase2 && praticaBando2DaFirestore.statoFlowdyFase2 !== 'ATTIVAZIONE KO FO'){
                      raggruppamentoPerImpresa[impresa].sopralluogoPianificato++;
                      raggruppamentoPerImpresa[impresa].datiPerRegione[regione].sopralluogoPianificato++;
                    }else{
                      raggruppamentoPerImpresa[impresa].noSopralluogoPF++;
                      raggruppamentoPerImpresa[impresa].datiPerRegione[regione].noSopralluogoPF++;
                    }
                   
                  }
                 
                }
                

              }else{
                
                if(praticaBando2DaFirestore.statoFlowdyFase1==='SOPRALLUOGO EFFETTUATO' || (praticaBando2DaFirestore.sopralluogoOk && praticaBando2DaFirestore.dataSopralluogo)){
                  raggruppamentoPerImpresa[impresa].sopralluogoEseguito++;
                  raggruppamentoPerImpresa[impresa].datiPerRegione[regione].sopralluogoEseguito++;
                }else{
                 
                  raggruppamentoPerImpresa[impresa].sopralluogoPianificato++;
                  raggruppamentoPerImpresa[impresa].datiPerRegione[regione].sopralluogoPianificato++;
                }
              }
              
             
            }else{} */
        if (
          praticaBando2DaFirestore.statoFlowdyFase1 === "IN ATTESA ODA" ||
          praticaBando2DaFirestore.statoFlowdyFase1 === "DA ASSEGNARE" ||
          praticaBando2DaFirestore.statoFlowdyFase1 === "ASSEGNATA"
        ) {
          raggruppamentoPerImpresa[impresa].noSopralluogo++;
          raggruppamentoPerImpresa[impresa].datiPerRegione[regione]
            .noSopralluogo++;
          raggruppamentoPerImpresa[impresa].datiPerTipoSedeEffettiva![
            tipoSedeEffettiva
          ].noSopralluogo++;
        } else if (
          praticaBando2DaFirestore.statoFlowdyFase1 ===
          "SOPRALLUOGO PIANIFICATO"
        ) {
          raggruppamentoPerImpresa[impresa].sopralluogoPianificato++;
          raggruppamentoPerImpresa[impresa].datiPerRegione[regione]
            .sopralluogoPianificato++;
          raggruppamentoPerImpresa[impresa].datiPerTipoSedeEffettiva![
            tipoSedeEffettiva
          ].sopralluogoPianificato++;
        } else if (
          praticaBando2DaFirestore.statoFlowdyFase1 === "SOPRALLUOGO KO"
        ) {
          raggruppamentoPerImpresa[impresa].sopralluogoKO++;
          raggruppamentoPerImpresa[impresa].datiPerRegione[regione]
            .sopralluogoKO++;
          raggruppamentoPerImpresa[impresa].datiPerTipoSedeEffettiva![
            tipoSedeEffettiva
          ].sopralluogoKO++;
        } else {
          if (praticaBando2DaFirestore.sopralluogoOk !== false) {
            raggruppamentoPerImpresa[impresa].sopralluogoEseguito++;
            raggruppamentoPerImpresa[impresa].datiPerRegione[regione]
              .sopralluogoEseguito++;
            raggruppamentoPerImpresa[impresa].datiPerTipoSedeEffettiva![
              tipoSedeEffettiva
            ].sopralluogoEseguito++;
          } /* else{
                  raggruppamentoPerImpresa[impresa].sopralluogoKO++;
                  raggruppamentoPerImpresa[impresa].datiPerRegione[regione].sopralluogoKO++;

                } */
        }
      });

      this.datiRaggruppatiBando2Sop = Object.entries(
        raggruppamentoPerImpresa,
      ).map(([impresa, dati]) => ({
        impresa,
        idImpresa: dati.idImpresa,
        totale: dati.totale,
        noSopralluogo: dati.noSopralluogo,
        noSopralluogoPF: dati.noSopralluogoPF,
        sopralluogoPianificato: dati.sopralluogoPianificato,
        sopralluogoEseguito: dati.sopralluogoEseguito,
        sopralluogoKO: dati.sopralluogoKO,
        datiPerRegione: dati.datiPerRegione,
        datiPerTipoSedeEffettiva: dati.datiPerTipoSedeEffettiva,
      }));
      this.aggiornaOpzioniImpreseBando2Sop();
      this.aggiornaOpzioniTipoSedeBando2Sop(Array.from(tipiSedeEffettivaSet));
      // Preserva i filtri se attivi per Sopralluoghi Bando 2
      if (
        (this.filtroRegioneSop && this.filtroRegioneSop.length > 0) ||
        (this.filtroImpresaSop != null &&
          this.filtroImpresaSop !== undefined) ||
        (this.filtroTipoSedeEffettivaSop &&
          this.filtroTipoSedeEffettivaSop.length > 0)
      ) {
        const savedBandoIndex = this.activeBandoIndex;
        this.activeBandoIndex = 1;
        this.applyFiltersBando2Sop();
        this.activeBandoIndex = savedBandoIndex;
      } else {
        this.datiRaggruppatiBando2SopFiltrati = this.datiRaggruppatiBando2Sop;
        // Calcola i totali solo se il filtro non è attivo
        for (
          let index = 0;
          index < this.datiRaggruppatiBando2Sop.length;
          index++
        ) {
          this.totaliSopralluogoBando2 +=
            this.datiRaggruppatiBando2Sop[index].totale;
          this.totaliNoSopralluogoBando2 +=
            this.datiRaggruppatiBando2Sop[index].noSopralluogo;
          this.totaliNoSopralluogoPFBando2 +=
            this.datiRaggruppatiBando2Sop[index].noSopralluogoPF;
          this.totaliSopralluogoPianificatoBando2 +=
            this.datiRaggruppatiBando2Sop[index].sopralluogoPianificato;
          this.totaliSopralluogoEseguitoBando2 +=
            this.datiRaggruppatiBando2Sop[index].sopralluogoEseguito;
          this.totaliSopralluogoKOBando2 +=
            this.datiRaggruppatiBando2Sop[index].sopralluogoKO;
        }
      }
    });
  }

  openPraticheFase1(bando: number, statoSopralluogo: string) {
    switch (statoSopralluogo) {
      case "noSopralluogo":
      case "noSopralluogoPF":
      case "sopralluogoPianificato":
      case "sopralluogoEseguito":
      case "sopralluogoKO":
        this.router.navigateByUrl("/", { skipLocationChange: true }).then(() =>
          this.router.navigate(["pratiche-bando" + bando + "/fase-1"], {
            queryParams: {
              statoSopralluogo: statoSopralluogo,
              ...(this.filtroRegioneSop
                ? { regione: this.filtroRegioneSop }
                : {}),
              from: "WIP_SOPRALLUOGHI",
            },
          }),
        );
        break;
      default:
        this.router.navigateByUrl("/", { skipLocationChange: true }).then(() =>
          this.router.navigate(["pratiche-bando" + bando + "/fase-1"], {
            queryParams: {
              statoSopralluogo: statoSopralluogo,
              from: "WIP_SOPRALLUOGHI",
              ...(this.filtroRegioneSop
                ? { regione: this.filtroRegioneSop }
                : {}),
            },
          }),
        );
        break;
    }
  }
  openPraticheFase1DiImpresa(
    bando: number,
    idImpresa: number,
    impresa: string,
    statoSopralluogo: string,
  ) {
    this.logger.info(
      "APRI PRATICHE FASE 1 DI IMPRESA " +
        idImpresa +
        " - " +
        this.filtroRegioneSop,
      this.filtroTipoSedeEffettivaSop,
    );
    switch (statoSopralluogo) {
      case "ALL":
        this.router.navigateByUrl("/", { skipLocationChange: true }).then(() =>
          this.router.navigate(["pratiche-bando" + bando + "/fase-1"], {
            queryParams: {
              impresa: idImpresa,
              ragioneSocialeImpresa: impresa,
              from: "WIP_SOPRALLUOGHI",
              ...(this.filtroTipoSedeEffettivaSop &&
              this.filtroTipoSedeEffettivaSop.length > 0
                ? { tipoSedeEffettivaSop: this.filtroTipoSedeEffettivaSop }
                : {}),
            },
          }),
        );
        break;
      case "noSopralluogo":
      case "noSopralluogoPF":
      case "sopralluogoPianificato":
      case "sopralluogoEseguito":
      case "sopralluogoKO":
        this.router.navigateByUrl("/", { skipLocationChange: true }).then(() =>
          this.router.navigate(["pratiche-bando" + bando + "/fase-1"], {
            queryParams: {
              impresa: idImpresa,
              ragioneSocialeImpresa: impresa,
              statoSopralluogo: statoSopralluogo,
              ...(this.filtroRegioneSop
                ? { regione: this.filtroRegioneSop }
                : {}),
              ...(this.filtroTipoSedeEffettivaSop &&
              this.filtroTipoSedeEffettivaSop.length > 0
                ? { tipoSedeEffettivaSop: this.filtroTipoSedeEffettivaSop }
                : {}),
              from: "WIP_SOPRALLUOGHI",
            },
          }),
        );
        break;
      default:
        this.router.navigateByUrl("/", { skipLocationChange: true }).then(() =>
          this.router.navigate(["pratiche-bando" + bando + "/fase-1"], {
            queryParams: {
              impresa: idImpresa,
              ...(this.filtroTipoSedeEffettivaSop &&
              this.filtroTipoSedeEffettivaSop.length > 0
                ? { tipoSedeEffettivaSop: this.filtroTipoSedeEffettivaSop }
                : {}),
            },
          }),
        );
        break;
    }
  }

  filtraPerRegioneApp(regione: string) {
    this.filtroRegioneApp = regione;
    if (this.activeBandoIndex == 0) {
      if (
        this.filtroImpresaApp == null ||
        this.filtroImpresaApp === undefined
      ) {
        this.aggiornaOpzioniImpreseBando1App();
      }
      this.applyFiltersBando1App();
    } else {
      if (
        this.filtroImpresaApp == null ||
        this.filtroImpresaApp === undefined
      ) {
        this.aggiornaOpzioniImpreseBando2App();
      }
      this.applyFiltersBando2App();
    }
    this.filterIsSetApp =
      (regione?.length ?? 0) > 0 ||
      (this.filtroImpresaApp != null && this.filtroImpresaApp !== undefined) ||
      (this.filtroTipoSedeEffettivaApp?.length ?? 0) > 0;
    this.cdr.detectChanges();
  }

  filtraPerImpresaApp(idImpresa: number | null | undefined) {
    const id: number | null =
      idImpresa == null || idImpresa === undefined ? null : Number(idImpresa);
    this.filtroImpresaApp = id;
    this.filterIsSetApp =
      (this.filtroRegioneApp?.length ?? 0) > 0 ||
      (id != null && id !== undefined) ||
      (this.filtroTipoSedeEffettivaApp?.length ?? 0) > 0;

    if (this.activeBandoIndex == 0) {
      this.applyFiltersBando1App();
    } else if (this.activeBandoIndex == 1) {
      this.applyFiltersBando2App();
    }
    this.cdr.detectChanges();
  }

  filtraPerTipoSedeEffettivaApp(tipoSede: string | null | undefined) {
    this.filtroTipoSedeEffettivaApp = tipoSede?.trim() ?? "";
    this.filterIsSetApp =
      (this.filtroRegioneApp?.length ?? 0) > 0 ||
      (this.filtroImpresaApp != null && this.filtroImpresaApp !== undefined) ||
      (this.filtroTipoSedeEffettivaApp?.length ?? 0) > 0;

    if (this.activeBandoIndex == 0) {
      this.applyFiltersBando1App();
    } else if (this.activeBandoIndex == 1) {
      this.applyFiltersBando2App();
    }
    this.cdr.detectChanges();
  }

  private buildLabelFiltriApp(
    datiFiltrati: DatiAppuntamentiPerImpresa[],
    opzioniImprese?: { label: string; value: number }[],
  ): string {
    const opzioni = opzioniImprese ?? this.opzioniImpreseBando2App;
    const parti: string[] = [];
    if (this.filtroRegioneApp && this.filtroRegioneApp.length > 0) {
      parti.push("REGIONE " + this.filtroRegioneApp.toUpperCase());
    }
    if (this.filtroImpresaApp != null && this.filtroImpresaApp !== undefined) {
      const impresaSelezionata = datiFiltrati[0];
      const nomeImpresa =
        impresaSelezionata?.impresa ??
        opzioni.find((o) => o.value === this.filtroImpresaApp)?.label ??
        "";
      parti.push("IMPRESA " + nomeImpresa.toUpperCase());
    }
    if (
      this.filtroTipoSedeEffettivaApp &&
      this.filtroTipoSedeEffettivaApp.length > 0
    ) {
      parti.push("TIPO SEDE " + this.filtroTipoSedeEffettivaApp.toUpperCase());
    }
    if (parti.length === 0) return "TUTTE LE REGIONI";
    return parti.join(" E ");
  }

  private applyFiltersBando2App() {
    this.totaliAppBando2 = 0;
    this.totaliAppBando2NoAppuntamentoMancaPF_noNTW = 0;
    this.totaliAppBando2NoAppuntamentoMancaPF_conNTW = 0;
    this.totaliAppBando2NoAppuntamentoPFPronto = 0;
    this.totaliAppBando2AppuntamentoFissato = 0;
    this.totaliAppBando2AppuntamentoScaduto = 0;
    this.totaliAppBando2AttivazioneKO = 0;
    this.totaliAppBando2AttivazioneOK = 0;
    this.totaliAppBando2installazioneOK = 0;
    this.filterIsSetApp =
      this.filtroRegioneApp.length > 0 ||
      (this.filtroImpresaApp != null && this.filtroImpresaApp !== undefined) ||
      this.filtroTipoSedeEffettivaApp.length > 0;

    let datiFiltrati: DatiAppuntamentiPerImpresa[];

    if (
      !this.filtroRegioneApp &&
      (this.filtroImpresaApp == null || this.filtroImpresaApp === undefined) &&
      !this.filtroTipoSedeEffettivaApp
    ) {
      datiFiltrati = [...this.datiRaggruppatiBando2App];
      this.labelRegioniApp = "TUTTE LE REGIONI";
    } else {
      let datiBase = this.datiRaggruppatiBando2App;

      if (this.filtroRegioneApp) {
        datiBase = this.datiRaggruppatiBando2App
          .map((dato) => {
            const datiFiltratiPerRegione = Object.keys(dato.datiPerRegione)
              .filter((r) => r === this.filtroRegioneApp)
              .reduce(
                (acc, r) => {
                  const regioneData = dato.datiPerRegione[r];
                  acc.totale += regioneData.totale;
                  acc.noAppuntamentoMancaPF_noNTW +=
                    regioneData.noAppuntamentoMancaPF_noNTW;
                  acc.noAppuntamentoMancaPF_conNTW +=
                    regioneData.noAppuntamentoMancaPF_conNTW;
                  acc.noAppuntamentoPFPronto +=
                    regioneData.noAppuntamentoPFPronto;
                  acc.appuntamentoFissato += regioneData.appuntamentoFissato;
                  acc.appuntamentoScaduto += regioneData.appuntamentoScaduto;
                  acc.attivazioneKO += regioneData.attivazioneKO;
                  acc.attivazioneOK += regioneData.attivazioneOK;
                  acc.installazioneOK += regioneData.installazioneOK;
                  return acc;
                },
                {
                  totale: 0,
                  noAppuntamentoMancaPF_noNTW: 0,
                  noAppuntamentoMancaPF_conNTW: 0,
                  noAppuntamentoPFPronto: 0,
                  appuntamentoFissato: 0,
                  appuntamentoScaduto: 0,
                  attivazioneKO: 0,
                  attivazioneOK: 0,
                  installazioneOK: 0,
                },
              );

            return {
              ...dato,
              totale: datiFiltratiPerRegione.totale,
              noAppuntamentoMancaPF_noNTW:
                datiFiltratiPerRegione.noAppuntamentoMancaPF_noNTW,
              noAppuntamentoMancaPF_conNTW:
                datiFiltratiPerRegione.noAppuntamentoMancaPF_conNTW,
              noAppuntamentoPFPronto:
                datiFiltratiPerRegione.noAppuntamentoPFPronto,
              appuntamentoFissato: datiFiltratiPerRegione.appuntamentoFissato,
              appuntamentoScaduto: datiFiltratiPerRegione.appuntamentoScaduto,
              attivazioneKO: datiFiltratiPerRegione.attivazioneKO,
              attivazioneOK: datiFiltratiPerRegione.attivazioneOK,
              installazioneOK: datiFiltratiPerRegione.installazioneOK,
              datiPerRegione: Object.fromEntries(
                Object.entries(dato.datiPerRegione).filter(
                  ([r]) => r === this.filtroRegioneApp,
                ),
              ),
            };
          })
          .filter((dato) => dato.totale > 0);
      }

      if (
        this.filtroTipoSedeEffettivaApp &&
        this.filtroTipoSedeEffettivaApp.length > 0
      ) {
        datiBase = datiBase
          .map((dato) => {
            const datiPerTipo = dato.datiPerTipoSedeEffettiva;
            if (!datiPerTipo || !datiPerTipo[this.filtroTipoSedeEffettivaApp]) {
              return { ...dato, totale: 0 };
            }
            const datiTipo = datiPerTipo[this.filtroTipoSedeEffettivaApp];
            return {
              ...dato,
              totale: datiTipo.totale,
              noAppuntamentoMancaPF_noNTW: datiTipo.noAppuntamentoMancaPF_noNTW,
              noAppuntamentoMancaPF_conNTW:
                datiTipo.noAppuntamentoMancaPF_conNTW,
              noAppuntamentoPFPronto: datiTipo.noAppuntamentoPFPronto,
              appuntamentoFissato: datiTipo.appuntamentoFissato,
              appuntamentoScaduto: datiTipo.appuntamentoScaduto,
              attivazioneKO: datiTipo.attivazioneKO,
              attivazioneOK: datiTipo.attivazioneOK,
              installazioneOK: datiTipo.installazioneOK,
            };
          })
          .filter((dato) => dato.totale > 0);
      }

      if (
        this.filtroImpresaApp != null &&
        this.filtroImpresaApp !== undefined
      ) {
        const idCercato = Number(this.filtroImpresaApp);
        datiFiltrati = datiBase.filter(
          (d) => Number(d.idImpresa) === idCercato,
        );
      } else {
        datiFiltrati = datiBase;
      }
      this.labelRegioniApp = this.buildLabelFiltriApp(datiFiltrati);
    }

    this.datiRaggruppatiBando2AppFiltrati = datiFiltrati;

    for (
      let index = 0;
      index < this.datiRaggruppatiBando2AppFiltrati.length;
      index++
    ) {
      this.totaliAppBando2 +=
        this.datiRaggruppatiBando2AppFiltrati[index].totale;
      this.totaliAppBando2NoAppuntamentoMancaPF_noNTW +=
        this.datiRaggruppatiBando2AppFiltrati[
          index
        ].noAppuntamentoMancaPF_noNTW;
      this.totaliAppBando2NoAppuntamentoMancaPF_conNTW +=
        this.datiRaggruppatiBando2AppFiltrati[
          index
        ].noAppuntamentoMancaPF_conNTW;
      this.totaliAppBando2NoAppuntamentoPFPronto +=
        this.datiRaggruppatiBando2AppFiltrati[index].noAppuntamentoPFPronto;
      this.totaliAppBando2AppuntamentoFissato +=
        this.datiRaggruppatiBando2AppFiltrati[index].appuntamentoFissato;
      this.totaliAppBando2AppuntamentoScaduto +=
        this.datiRaggruppatiBando2AppFiltrati[index].appuntamentoScaduto;
      this.totaliAppBando2AttivazioneKO +=
        this.datiRaggruppatiBando2AppFiltrati[index].attivazioneKO;
      this.totaliAppBando2AttivazioneOK +=
        this.datiRaggruppatiBando2AppFiltrati[index].attivazioneOK;
      this.totaliAppBando2installazioneOK +=
        this.datiRaggruppatiBando2AppFiltrati[index].installazioneOK;
    }
  }

  openPraticheFase2(bando: number, statoAttivazione: string) {
    switch (statoAttivazione) {
      case "noAppuntamentoMancaPF_noNTW":
      case "noAppuntamentoMancaPF_conNTW":
      case "noAppuntamentoPFPronto":
      case "appuntamentoFissato":
      case "appuntamentoScaduto":
      case "attivazioneKO":
      case "attivazioneOK":
      case "installazioneOK":
        this.router.navigateByUrl("/", { skipLocationChange: true }).then(() =>
          this.router.navigate(["pratiche-bando" + bando + "/fase-2"], {
            queryParams: {
              statoAttivazione: statoAttivazione,
              ...(this.filtroRegioneApp
                ? { regione: this.filtroRegioneApp }
                : {}),
              ...(this.filtroTipoSedeEffettivaApp &&
              this.filtroTipoSedeEffettivaApp.length > 0
                ? { tipoSedeEffettivaApp: this.filtroTipoSedeEffettivaApp }
                : {}),
              from: "WIP_APPUNTAMENTI",
            },
          }),
        );
        break;
      default:
        this.router.navigateByUrl("/", { skipLocationChange: true }).then(() =>
          this.router.navigate(["pratiche-bando" + bando + "/fase-2"], {
            queryParams: {
              statoAttivazione: statoAttivazione,
              ...(this.filtroRegioneApp
                ? { regione: this.filtroRegioneApp }
                : {}),
              ...(this.filtroTipoSedeEffettivaApp &&
              this.filtroTipoSedeEffettivaApp.length > 0
                ? { tipoSedeEffettivaApp: this.filtroTipoSedeEffettivaApp }
                : {}),
              from: "WIP_APPUNTAMENTI",
            },
          }),
        );
        break;
    }
  }

  openPraticheFase2DiImpresa(
    bando: number,
    idImpresa: number,
    impresa: string,
    statoAttivazione: string,
  ) {
    switch (statoAttivazione) {
      case "ALL":
        this.router.navigateByUrl("/", { skipLocationChange: true }).then(() =>
          this.router.navigate(["pratiche-bando" + bando + "/fase-2"], {
            queryParams: {
              impresa: idImpresa,
              ragioneSocialeImpresa: impresa,
              ...(this.filtroRegioneApp
                ? { regione: this.filtroRegioneApp }
                : {}),
              ...(this.filtroTipoSedeEffettivaApp &&
              this.filtroTipoSedeEffettivaApp.length > 0
                ? { tipoSedeEffettivaApp: this.filtroTipoSedeEffettivaApp }
                : {}),
              from: "WIP_APPUNTAMENTI",
            },
          }),
        );
        break;
      case "noAppuntamentoMancaPF_noNTW":
      case "noAppuntamentoMancaPF_conNTW":
      case "noAppuntamentoPFPronto":
      case "appuntamentoFissato":
      case "appuntamentoScaduto":
      case "attivazioneKO":
      case "attivazioneOK":
      case "installazioneOK":
        this.router.navigateByUrl("/", { skipLocationChange: true }).then(() =>
          this.router.navigate(["pratiche-bando" + bando + "/fase-2"], {
            queryParams: {
              impresa: idImpresa,
              ragioneSocialeImpresa: impresa,
              statoAttivazione: statoAttivazione,
              ...(this.filtroRegioneApp
                ? { regione: this.filtroRegioneApp }
                : {}),
              ...(this.filtroTipoSedeEffettivaApp &&
              this.filtroTipoSedeEffettivaApp.length > 0
                ? { tipoSedeEffettivaApp: this.filtroTipoSedeEffettivaApp }
                : {}),
              from: "WIP_APPUNTAMENTI",
            },
          }),
        );
        break;
      default:
        this.router.navigateByUrl("/", { skipLocationChange: true }).then(() =>
          this.router.navigate(["pratiche-bando" + bando + "/fase-2"], {
            queryParams: {
              impresa: idImpresa,
              ...(this.filtroTipoSedeEffettivaApp &&
              this.filtroTipoSedeEffettivaApp.length > 0
                ? { tipoSedeEffettivaApp: this.filtroTipoSedeEffettivaApp }
                : {}),
            },
          }),
        );
        break;
    }
  }

  filtraPerRegioneSop(regione: string) {
    this.filtroRegioneSop = regione;
    if (this.activeBandoIndex == 0) {
      if (
        this.filtroImpresaSop == null ||
        this.filtroImpresaSop === undefined
      ) {
        this.aggiornaOpzioniImpreseBando1Sop();
      }
      this.applyFiltersBando1Sop();
    } else {
      if (
        this.filtroImpresaSop == null ||
        this.filtroImpresaSop === undefined
      ) {
        this.aggiornaOpzioniImpreseBando2Sop();
      }
      this.applyFiltersBando2Sop();
    }
    this.filterIsSetSop =
      (regione?.length ?? 0) > 0 ||
      (this.filtroImpresaSop != null && this.filtroImpresaSop !== undefined) ||
      (this.filtroTipoSedeEffettivaSop?.length ?? 0) > 0;
    this.cdr.detectChanges();
  }

  filtraPerTipoSedeEffettivaSop(tipoSede: string | null | undefined) {
    this.filtroTipoSedeEffettivaSop = tipoSede?.trim() ?? "";
    this.filterIsSetSop =
      (this.filtroRegioneSop?.length ?? 0) > 0 ||
      (this.filtroImpresaSop != null && this.filtroImpresaSop !== undefined) ||
      (this.filtroTipoSedeEffettivaSop?.length ?? 0) > 0;

    if (this.activeBandoIndex == 0) {
      this.applyFiltersBando1Sop();
    } else if (this.activeBandoIndex == 1) {
      this.applyFiltersBando2Sop();
    }
    this.cdr.detectChanges();
  }

  filtraPerImpresaSop(idImpresa: number | null | undefined) {
    const id: number | null =
      idImpresa == null || idImpresa === undefined ? null : Number(idImpresa);
    this.filtroImpresaSop = id;
    this.filterIsSetSop =
      (this.filtroRegioneSop?.length ?? 0) > 0 ||
      (id != null && id !== undefined) ||
      (this.filtroTipoSedeEffettivaSop?.length ?? 0) > 0;

    if (this.activeBandoIndex == 0) {
      this.applyFiltersBando1Sop();
    } else if (this.activeBandoIndex == 1) {
      this.applyFiltersBando2Sop();
    }
    this.cdr.detectChanges();
  }

  private applyFiltersBando1Sop() {
    this.totaliSopralluogoBando1 = 0;
    this.totaliNoSopralluogoBando1 = 0;
    this.totaliNoSopralluogoPFBando1 = 0;
    this.totaliSopralluogoPianificatoBando1 = 0;
    this.totaliSopralluogoEseguitoBando1 = 0;
    this.totaliSopralluogoKOBando1 = 0;
    this.filterIsSetSop =
      (this.filtroRegioneSop?.length ?? 0) > 0 ||
      (this.filtroImpresaSop != null && this.filtroImpresaSop !== undefined) ||
      (this.filtroTipoSedeEffettivaSop?.length ?? 0) > 0;

    let datiFiltrati: DatiSopralluogoPerImpresa[];

    if (
      !this.filtroRegioneSop &&
      (this.filtroImpresaSop == null || this.filtroImpresaSop === undefined) &&
      !this.filtroTipoSedeEffettivaSop
    ) {
      datiFiltrati = [...this.datiRaggruppatiBando1Sop];
      this.labelRegioniSop = "TUTTE LE REGIONI";
    } else {
      let datiBase = this.datiRaggruppatiBando1Sop;

      if (this.filtroRegioneSop) {
        datiBase = this.datiRaggruppatiBando1Sop
          .map((dato) => {
            const datiFiltratiPerRegione = Object.keys(dato.datiPerRegione)
              .filter((r) => r === this.filtroRegioneSop)
              .reduce(
                (acc, r) => {
                  const regioneData = dato.datiPerRegione[r];
                  acc.totale += regioneData.totale;
                  acc.noSopralluogo += regioneData.noSopralluogo;
                  acc.noSopralluogoPF += regioneData.noSopralluogoPF;
                  acc.sopralluogoPianificato +=
                    regioneData.sopralluogoPianificato;
                  acc.sopralluogoEseguito += regioneData.sopralluogoEseguito;
                  acc.sopralluogoKO += regioneData.sopralluogoKO;
                  return acc;
                },
                {
                  totale: 0,
                  noSopralluogo: 0,
                  noSopralluogoPF: 0,
                  sopralluogoPianificato: 0,
                  sopralluogoEseguito: 0,
                  sopralluogoKO: 0,
                },
              );

            return {
              ...dato,
              totale: datiFiltratiPerRegione.totale,
              noSopralluogo: datiFiltratiPerRegione.noSopralluogo,
              noSopralluogoPF: datiFiltratiPerRegione.noSopralluogoPF,
              sopralluogoPianificato:
                datiFiltratiPerRegione.sopralluogoPianificato,
              sopralluogoEseguito: datiFiltratiPerRegione.sopralluogoEseguito,
              sopralluogoKO: datiFiltratiPerRegione.sopralluogoKO,
              datiPerRegione: Object.fromEntries(
                Object.entries(dato.datiPerRegione).filter(
                  ([r]) => r === this.filtroRegioneSop,
                ),
              ),
            };
          })
          .filter((dato) => dato.totale > 0);
      }

      if (
        this.filtroTipoSedeEffettivaSop &&
        this.filtroTipoSedeEffettivaSop.length > 0
      ) {
        datiBase = datiBase
          .map((dato) => {
            const datiPerTipo = dato.datiPerTipoSedeEffettiva;
            if (!datiPerTipo || !datiPerTipo[this.filtroTipoSedeEffettivaSop]) {
              return { ...dato, totale: 0 };
            }
            const datiTipo = datiPerTipo[this.filtroTipoSedeEffettivaSop];
            return {
              ...dato,
              totale: datiTipo!.totale,
              noSopralluogo: datiTipo!.noSopralluogo,
              noSopralluogoPF: datiTipo!.noSopralluogoPF,
              sopralluogoPianificato: datiTipo!.sopralluogoPianificato,
              sopralluogoEseguito: datiTipo!.sopralluogoEseguito,
              sopralluogoKO: datiTipo!.sopralluogoKO,
            };
          })
          .filter((dato) => dato.totale > 0);
      }

      if (
        this.filtroImpresaSop != null &&
        this.filtroImpresaSop !== undefined
      ) {
        const idCercato = Number(this.filtroImpresaSop);
        datiFiltrati = datiBase.filter(
          (d) => Number(d.idImpresa) === idCercato,
        );
      } else {
        datiFiltrati = datiBase;
      }
      this.labelRegioniSop = this.buildLabelFiltriSop(
        datiFiltrati,
        this.opzioniImpreseBando1Sop,
      );
    }

    this.datiRaggruppatiBando1SopFiltrati = datiFiltrati;

    if (this.datiRaggruppatiBando1SopFiltrati.length > 0) {
      for (
        let index = 0;
        index < this.datiRaggruppatiBando1SopFiltrati.length;
        index++
      ) {
        this.totaliSopralluogoBando1 +=
          this.datiRaggruppatiBando1SopFiltrati[index].totale;
        this.totaliNoSopralluogoBando1 +=
          this.datiRaggruppatiBando1SopFiltrati[index].noSopralluogo;
        this.totaliNoSopralluogoPFBando1 +=
          this.datiRaggruppatiBando1SopFiltrati[index].noSopralluogoPF;
        this.totaliSopralluogoPianificatoBando1 +=
          this.datiRaggruppatiBando1SopFiltrati[index].sopralluogoPianificato;
        this.totaliSopralluogoEseguitoBando1 +=
          this.datiRaggruppatiBando1SopFiltrati[index].sopralluogoEseguito;
        this.totaliSopralluogoKOBando1 +=
          this.datiRaggruppatiBando1SopFiltrati[index].sopralluogoKO;
      }
    }
  }

  private applyFiltersBando1App() {
    this.totaliAppBando1 = 0;
    this.totaliAppBando1NoAppuntamentoMancaPF_noNTW = 0;
    this.totaliAppBando1NoAppuntamentoMancaPF_conNTW = 0;
    this.totaliAppBando1NoAppuntamentoPFPronto = 0;
    this.totaliAppBando1AppuntamentoFissato = 0;
    this.totaliAppBando1AppuntamentoScaduto = 0;
    this.totaliAppBando1AttivazioneKO = 0;
    this.totaliAppBando1AttivazioneOK = 0;
    this.totaliAppBando1installazioneOK = 0;
    this.filterIsSetApp =
      (this.filtroRegioneApp?.length ?? 0) > 0 ||
      (this.filtroImpresaApp != null && this.filtroImpresaApp !== undefined) ||
      (this.filtroTipoSedeEffettivaApp?.length ?? 0) > 0;

    let datiFiltrati: DatiAppuntamentiPerImpresa[];

    if (
      !this.filtroRegioneApp &&
      (this.filtroImpresaApp == null || this.filtroImpresaApp === undefined) &&
      !this.filtroTipoSedeEffettivaApp
    ) {
      datiFiltrati = [...this.datiRaggruppatiBando1App];
      this.labelRegioniApp = "TUTTE LE REGIONI";
    } else {
      let datiBase = this.datiRaggruppatiBando1App;

      if (this.filtroRegioneApp) {
        datiBase = this.datiRaggruppatiBando1App
          .map((dato) => {
            const datiFiltratiPerRegione = Object.keys(dato.datiPerRegione)
              .filter((r) => r === this.filtroRegioneApp)
              .reduce(
                (acc, r) => {
                  const regioneData = dato.datiPerRegione[r];
                  acc.totale += regioneData.totale;
                  acc.noAppuntamentoMancaPF_noNTW +=
                    regioneData.noAppuntamentoMancaPF_noNTW;
                  acc.noAppuntamentoMancaPF_conNTW +=
                    regioneData.noAppuntamentoMancaPF_conNTW;
                  acc.noAppuntamentoPFPronto +=
                    regioneData.noAppuntamentoPFPronto;
                  acc.appuntamentoFissato += regioneData.appuntamentoFissato;
                  acc.appuntamentoScaduto += regioneData.appuntamentoScaduto;
                  acc.attivazioneKO += regioneData.attivazioneKO;
                  acc.attivazioneOK += regioneData.attivazioneOK;
                  acc.installazioneOK += regioneData.installazioneOK;
                  return acc;
                },
                {
                  totale: 0,
                  noAppuntamentoMancaPF_noNTW: 0,
                  noAppuntamentoMancaPF_conNTW: 0,
                  noAppuntamentoPFPronto: 0,
                  appuntamentoFissato: 0,
                  appuntamentoScaduto: 0,
                  attivazioneKO: 0,
                  attivazioneOK: 0,
                  installazioneOK: 0,
                },
              );

            return {
              ...dato,
              totale: datiFiltratiPerRegione.totale,
              noAppuntamentoMancaPF_noNTW:
                datiFiltratiPerRegione.noAppuntamentoMancaPF_noNTW,
              noAppuntamentoMancaPF_conNTW:
                datiFiltratiPerRegione.noAppuntamentoMancaPF_conNTW,
              noAppuntamentoPFPronto:
                datiFiltratiPerRegione.noAppuntamentoPFPronto,
              appuntamentoFissato: datiFiltratiPerRegione.appuntamentoFissato,
              appuntamentoScaduto: datiFiltratiPerRegione.appuntamentoScaduto,
              attivazioneKO: datiFiltratiPerRegione.attivazioneKO,
              attivazioneOK: datiFiltratiPerRegione.attivazioneOK,
              installazioneOK: datiFiltratiPerRegione.installazioneOK,
              datiPerRegione: Object.fromEntries(
                Object.entries(dato.datiPerRegione).filter(
                  ([r]) => r === this.filtroRegioneApp,
                ),
              ),
            };
          })
          .filter((dato) => dato.totale > 0);
      }

      if (
        this.filtroTipoSedeEffettivaApp &&
        this.filtroTipoSedeEffettivaApp.length > 0
      ) {
        datiBase = datiBase
          .map((dato) => {
            const datiPerTipo = dato.datiPerTipoSedeEffettiva;
            if (!datiPerTipo || !datiPerTipo[this.filtroTipoSedeEffettivaApp]) {
              return { ...dato, totale: 0 };
            }
            const datiTipo = datiPerTipo[this.filtroTipoSedeEffettivaApp];
            return {
              ...dato,
              totale: datiTipo!.totale,
              noAppuntamentoMancaPF_noNTW:
                datiTipo!.noAppuntamentoMancaPF_noNTW,
              noAppuntamentoMancaPF_conNTW:
                datiTipo!.noAppuntamentoMancaPF_conNTW,
              noAppuntamentoPFPronto: datiTipo!.noAppuntamentoPFPronto,
              appuntamentoFissato: datiTipo!.appuntamentoFissato,
              appuntamentoScaduto: datiTipo!.appuntamentoScaduto,
              attivazioneKO: datiTipo!.attivazioneKO,
              attivazioneOK: datiTipo!.attivazioneOK,
              installazioneOK: datiTipo!.installazioneOK,
            };
          })
          .filter((dato) => dato.totale > 0);
      }

      if (
        this.filtroImpresaApp != null &&
        this.filtroImpresaApp !== undefined
      ) {
        const idCercato = Number(this.filtroImpresaApp);
        datiFiltrati = datiBase.filter(
          (d) => Number(d.idImpresa) === idCercato,
        );
      } else {
        datiFiltrati = datiBase;
      }
      this.labelRegioniApp = this.buildLabelFiltriApp(
        datiFiltrati,
        this.opzioniImpreseBando1App,
      );
    }

    this.datiRaggruppatiBando1AppFiltrati = datiFiltrati;

    if (this.datiRaggruppatiBando1AppFiltrati.length > 0) {
      for (
        let index = 0;
        index < this.datiRaggruppatiBando1AppFiltrati.length;
        index++
      ) {
        this.totaliAppBando1 +=
          this.datiRaggruppatiBando1AppFiltrati[index].totale;
        this.totaliAppBando1NoAppuntamentoMancaPF_noNTW +=
          this.datiRaggruppatiBando1AppFiltrati[
            index
          ].noAppuntamentoMancaPF_noNTW;
        this.totaliAppBando1NoAppuntamentoMancaPF_conNTW +=
          this.datiRaggruppatiBando1AppFiltrati[
            index
          ].noAppuntamentoMancaPF_conNTW;
        this.totaliAppBando1NoAppuntamentoPFPronto +=
          this.datiRaggruppatiBando1AppFiltrati[index].noAppuntamentoPFPronto;
        this.totaliAppBando1AppuntamentoFissato +=
          this.datiRaggruppatiBando1AppFiltrati[index].appuntamentoFissato;
        this.totaliAppBando1AppuntamentoScaduto +=
          this.datiRaggruppatiBando1AppFiltrati[index].appuntamentoScaduto;
        this.totaliAppBando1AttivazioneKO +=
          this.datiRaggruppatiBando1AppFiltrati[index].attivazioneKO;
        this.totaliAppBando1AttivazioneOK +=
          this.datiRaggruppatiBando1AppFiltrati[index].attivazioneOK;
        this.totaliAppBando1installazioneOK +=
          this.datiRaggruppatiBando1AppFiltrati[index].installazioneOK;
      }
    }
  }

  private buildLabelFiltriSop(
    datiFiltrati: DatiSopralluogoPerImpresa[],
    opzioniImprese?: { label: string; value: number }[],
  ): string {
    const opzioni = opzioniImprese ?? this.opzioniImpreseBando2Sop;
    const parti: string[] = [];
    if (this.filtroRegioneSop && this.filtroRegioneSop.length > 0) {
      parti.push("REGIONE " + this.filtroRegioneSop.toUpperCase());
    }
    if (this.filtroImpresaSop != null && this.filtroImpresaSop !== undefined) {
      const impresaSelezionata = datiFiltrati[0];
      const nomeImpresa =
        impresaSelezionata?.impresa ??
        opzioni.find((o) => o.value === this.filtroImpresaSop)?.label ??
        "";
      parti.push("IMPRESA " + nomeImpresa.toUpperCase());
    }
    if (
      this.filtroTipoSedeEffettivaSop &&
      this.filtroTipoSedeEffettivaSop.length > 0
    ) {
      parti.push("TIPO SEDE " + this.filtroTipoSedeEffettivaSop.toUpperCase());
    }
    if (parti.length === 0) return "TUTTE LE REGIONI";
    return parti.join(" E ");
  }

  private applyFiltersBando2Sop() {
    this.totaliSopralluogoBando2 = 0;
    this.totaliNoSopralluogoBando2 = 0;
    this.totaliNoSopralluogoPFBando2 = 0;
    this.totaliSopralluogoPianificatoBando2 = 0;
    this.totaliSopralluogoEseguitoBando2 = 0;
    this.totaliSopralluogoKOBando2 = 0;
    this.filterIsSetSop =
      this.filtroRegioneSop.length > 0 ||
      (this.filtroImpresaSop != null && this.filtroImpresaSop !== undefined) ||
      this.filtroTipoSedeEffettivaSop.length > 0;

    let datiFiltrati: DatiSopralluogoPerImpresa[];

    if (
      !this.filtroRegioneSop &&
      (this.filtroImpresaSop == null || this.filtroImpresaSop === undefined) &&
      !this.filtroTipoSedeEffettivaSop
    ) {
      datiFiltrati = [...this.datiRaggruppatiBando2Sop];
      this.labelRegioniSop = "TUTTE LE REGIONI";
    } else {
      let datiBase = this.datiRaggruppatiBando2Sop;

      if (this.filtroRegioneSop) {
        datiBase = this.datiRaggruppatiBando2Sop
          .map((dato) => {
            const datiFiltratiPerRegione = Object.keys(dato.datiPerRegione)
              .filter((r) => r === this.filtroRegioneSop)
              .reduce(
                (acc, r) => {
                  const regioneData = dato.datiPerRegione[r];
                  acc.totale += regioneData.totale;
                  acc.noSopralluogo += regioneData.noSopralluogo;
                  acc.noSopralluogoPF += regioneData.noSopralluogoPF;
                  acc.sopralluogoPianificato +=
                    regioneData.sopralluogoPianificato;
                  acc.sopralluogoEseguito += regioneData.sopralluogoEseguito;
                  acc.sopralluogoKO += regioneData.sopralluogoKO;
                  return acc;
                },
                {
                  totale: 0,
                  noSopralluogo: 0,
                  noSopralluogoPF: 0,
                  sopralluogoPianificato: 0,
                  sopralluogoEseguito: 0,
                  sopralluogoKO: 0,
                },
              );

            return {
              ...dato,
              totale: datiFiltratiPerRegione.totale,
              noSopralluogo: datiFiltratiPerRegione.noSopralluogo,
              noSopralluogoPF: datiFiltratiPerRegione.noSopralluogoPF,
              sopralluogoPianificato:
                datiFiltratiPerRegione.sopralluogoPianificato,
              sopralluogoEseguito: datiFiltratiPerRegione.sopralluogoEseguito,
              sopralluogoKO: datiFiltratiPerRegione.sopralluogoKO,
              datiPerRegione: Object.fromEntries(
                Object.entries(dato.datiPerRegione).filter(
                  ([r]) => r === this.filtroRegioneSop,
                ),
              ),
            };
          })
          .filter((dato) => dato.totale > 0);
      }

      if (
        this.filtroTipoSedeEffettivaSop &&
        this.filtroTipoSedeEffettivaSop.length > 0
      ) {
        datiBase = datiBase
          .map((dato) => {
            const datiPerTipo = dato.datiPerTipoSedeEffettiva;
            if (!datiPerTipo || !datiPerTipo[this.filtroTipoSedeEffettivaSop]) {
              return { ...dato, totale: 0 };
            }
            const datiTipo = datiPerTipo[this.filtroTipoSedeEffettivaSop];
            return {
              ...dato,
              totale: datiTipo.totale,
              noSopralluogo: datiTipo.noSopralluogo,
              noSopralluogoPF: datiTipo.noSopralluogoPF,
              sopralluogoPianificato: datiTipo.sopralluogoPianificato,
              sopralluogoEseguito: datiTipo.sopralluogoEseguito,
              sopralluogoKO: datiTipo.sopralluogoKO,
            };
          })
          .filter((dato) => dato.totale > 0);
      }

      if (
        this.filtroImpresaSop != null &&
        this.filtroImpresaSop !== undefined
      ) {
        const idCercato = Number(this.filtroImpresaSop);
        datiFiltrati = datiBase.filter(
          (d) => Number(d.idImpresa) === idCercato,
        );
      } else {
        datiFiltrati = datiBase;
      }
      this.labelRegioniSop = this.buildLabelFiltriSop(datiFiltrati);
    }

    this.datiRaggruppatiBando2SopFiltrati = datiFiltrati;

    if (this.datiRaggruppatiBando2SopFiltrati.length > 0) {
      for (
        let index = 0;
        index < this.datiRaggruppatiBando2SopFiltrati.length;
        index++
      ) {
        this.totaliSopralluogoBando2 +=
          this.datiRaggruppatiBando2SopFiltrati[index].totale;
        this.totaliNoSopralluogoBando2 +=
          this.datiRaggruppatiBando2SopFiltrati[index].noSopralluogo;
        this.totaliNoSopralluogoPFBando2 +=
          this.datiRaggruppatiBando2SopFiltrati[index].noSopralluogoPF;
        this.totaliSopralluogoPianificatoBando2 +=
          this.datiRaggruppatiBando2SopFiltrati[index].sopralluogoPianificato;
        this.totaliSopralluogoEseguitoBando2 +=
          this.datiRaggruppatiBando2SopFiltrati[index].sopralluogoEseguito;
        this.totaliSopralluogoKOBando2 +=
          this.datiRaggruppatiBando2SopFiltrati[index].sopralluogoKO;
      }
    }
  }

  removeFilterApp() {
    this.filtroRegioneApp = "";
    this.filtroImpresaApp = null;
    this.aggiornaOpzioniImpreseBando1App();
    this.aggiornaOpzioniImpreseBando2App();
    this.filtroTipoSedeEffettivaApp = "";
    this.filterIsSetApp = false;
    this.labelRegioniApp = "Tutte le regioni";
    if (this.activeBandoIndex == 0) {
      this.datiRaggruppatiBando1AppFiltrati = [
        ...this.datiRaggruppatiBando1App,
      ];
      this.totaliAppBando1NoAppuntamentoMancaPF_noNTW = 0;
      this.totaliAppBando1NoAppuntamentoMancaPF_conNTW = 0;
      this.totaliAppBando1NoAppuntamentoPFPronto = 0;
      this.totaliAppBando1AppuntamentoFissato = 0;
      this.totaliAppBando1AppuntamentoScaduto = 0;
      this.totaliAppBando1AttivazioneKO = 0;
      this.totaliAppBando1AttivazioneOK = 0;
      this.totaliAppBando1installazioneOK = 0;
      this.totaliAppBando1 = 0;
      for (
        let index = 0;
        index < this.datiRaggruppatiBando1App.length;
        index++
      ) {
        this.totaliAppBando1NoAppuntamentoMancaPF_noNTW +=
          this.datiRaggruppatiBando1App[index].noAppuntamentoMancaPF_noNTW;
        this.totaliAppBando1NoAppuntamentoMancaPF_conNTW +=
          this.datiRaggruppatiBando1App[index].noAppuntamentoMancaPF_conNTW;
        this.totaliAppBando1NoAppuntamentoPFPronto +=
          this.datiRaggruppatiBando1App[index].noAppuntamentoPFPronto;
        this.totaliAppBando1AppuntamentoFissato +=
          this.datiRaggruppatiBando1App[index].appuntamentoFissato;
        this.totaliAppBando1AppuntamentoScaduto +=
          this.datiRaggruppatiBando1App[index].appuntamentoScaduto;
        this.totaliAppBando1AttivazioneKO +=
          this.datiRaggruppatiBando1App[index].attivazioneKO;
        this.totaliAppBando1AttivazioneOK +=
          this.datiRaggruppatiBando1App[index].attivazioneOK;
        this.totaliAppBando1installazioneOK +=
          this.datiRaggruppatiBando1App[index].installazioneOK;
        this.totaliAppBando1 += this.datiRaggruppatiBando1App[index].totale;
      }
    } else {
      this.datiRaggruppatiBando2AppFiltrati = [
        ...this.datiRaggruppatiBando2App,
      ];
      this.totaliAppBando2NoAppuntamentoMancaPF_noNTW = 0;
      this.totaliAppBando2NoAppuntamentoMancaPF_conNTW = 0;
      this.totaliAppBando2NoAppuntamentoPFPronto = 0;
      this.totaliAppBando2AppuntamentoFissato = 0;
      this.totaliAppBando2AppuntamentoScaduto = 0;
      this.totaliAppBando2AttivazioneKO = 0;
      this.totaliAppBando2AttivazioneOK = 0;
      this.totaliAppBando2installazioneOK = 0;
      this.totaliAppBando2 = 0;
      for (
        let index = 0;
        index < this.datiRaggruppatiBando2App.length;
        index++
      ) {
        this.totaliAppBando2NoAppuntamentoMancaPF_noNTW +=
          this.datiRaggruppatiBando2App[index].noAppuntamentoMancaPF_noNTW;
        this.totaliAppBando2NoAppuntamentoMancaPF_conNTW +=
          this.datiRaggruppatiBando2App[index].noAppuntamentoMancaPF_conNTW;
        this.totaliAppBando2NoAppuntamentoPFPronto +=
          this.datiRaggruppatiBando2App[index].noAppuntamentoPFPronto;
        this.totaliAppBando2AppuntamentoFissato +=
          this.datiRaggruppatiBando2App[index].appuntamentoFissato;
        this.totaliAppBando2AppuntamentoScaduto +=
          this.datiRaggruppatiBando2App[index].appuntamentoScaduto;
        this.totaliAppBando2AttivazioneKO +=
          this.datiRaggruppatiBando2App[index].attivazioneKO;
        this.totaliAppBando2AttivazioneOK +=
          this.datiRaggruppatiBando2App[index].attivazioneOK;
        this.totaliAppBando2installazioneOK +=
          this.datiRaggruppatiBando2App[index].installazioneOK;
        this.totaliAppBando2 += this.datiRaggruppatiBando2App[index].totale;
      }
    }
  }

  filtraPerRegioneOF(regioni: string[]) {
    this.filtroRegioneOF = regioni || [];
    this.applyFiltersOF();
  }

  filtraPerCategoriaVincoloOF(categoria: string | null) {
    this.logger.info(
      "[HOME WIP] filtraPerCategoriaVincoloOF chiamato con valore: " +
        categoria,
    );
    this.filtroCategoriaVincoloOF = categoria || "";
    this.logger.info(
      "[HOME WIP] filtroCategoriaVincoloOF impostato a: '" +
        this.filtroCategoriaVincoloOF +
        "'",
    );
    this.applyFiltersOF();
  }

  filtraPerStatoOF(stato: string | null) {
    this.filtroStatoOF = stato || "";
    // Reset del prefisso quando si cambia manualmente il filtro dal dropdown
    this.filtroVincoloCategoriaPrefisso = "";
    this.updatePraticheTipoCFiltrate();
  }

  filtraPerCuiOF(cui: string) {
    this.filtroCuiOF = cui || "";
    this.updatePraticheTipoCFiltrate();
  }

  filtraPerCategoriaEMostraPratiche(categoria: string) {
    // Mappa la categoria della tabella complessivo al valore del filtro statoOF
    let valoreFiltro = "";

    // Reset del prefisso per tutte le categorie (verrà impostato solo per VINCOLO FIBERCOP, INFRATEL, FUORI PERIMETRO)
    this.filtroVincoloCategoriaPrefisso = "";

    if (categoria === "ESPLETATE") {
      valoreFiltro = "LAVORABILE";
    } else if (categoria.startsWith("2.")) {
      // Estrae il codice categoria (es. da '2.1 TRIPLETTA NON COMPLETA' estrae '2.1')
      valoreFiltro = categoria.substring(0, 3);
    } else if (categoria === "VINCOLO FIBERCOP") {
      valoreFiltro = "ALTRI";
      this.filtroVincoloCategoriaPrefisso = "1"; // vincoloCategoriaCodice inizia con 1
    } else if (categoria === "VINCOLO INFRATEL") {
      valoreFiltro = "ALTRI";
      this.filtroVincoloCategoriaPrefisso = "3"; // vincoloCategoriaCodice inizia con 3
    } else if (categoria === "FUORI PERIMETRO") {
      valoreFiltro = "ALTRI";
      this.filtroVincoloCategoriaPrefisso = "4"; // vincoloCategoriaCodice inizia con 4
    } else if (categoria === "NON CATEGORIZZATE") {
      // Per le pratiche non categorizzate, usa un valore speciale per filtrare quelle con statoOF vuoto/null
      this.logger.info(
        "[HOME WIP] Click su NON CATEGORIZZATE - filtro pratiche con statoOF vuoto/null",
      );
      valoreFiltro = "NON_CATEGORIZZATE";
      // Non serve filtrare per vincoloCategoriaCodice, solo per statoOF vuoto
      this.filtroVincoloCategoriaPrefisso = "";
    }

    this.logger.info(
      `[HOME WIP] Click su categoria: ${categoria}, imposto filtro statoOF a: '${valoreFiltro}'`,
    );

    // Imposta il filtro statoOF
    this.filtroStatoOF = valoreFiltro;

    // Aggiorna le pratiche filtrate
    this.updatePraticheTipoCFiltrate();

    // Passa alla tab "Pratiche" (indice 1)
    this.activeOFIndex = 1;

    // Forza l'aggiornamento della vista
    this.cdr.detectChanges();
  }

  applyFiltersOF() {
    // Aggiorna le label
    if (!this.filtroRegioneOF || this.filtroRegioneOF.length === 0) {
      this.labelRegioniOF = "Tutte le regioni";
    } else if (this.filtroRegioneOF.length === 1) {
      this.labelRegioniOF = "REGIONE " + this.filtroRegioneOF[0].toUpperCase();
    } else {
      this.labelRegioniOF = `${this.filtroRegioneOF.length} REGIONI SELEZIONATE`;
    }

    if (!this.filtroCategoriaVincoloOF) {
      this.labelCategoriaVincoloOF = "Tutti i servizi OF";
    } else {
      const categoriaLabel = this.opzioniCategoriaVincoloOF.find(
        (c) => c.value === this.filtroCategoriaVincoloOF,
      );
      this.labelCategoriaVincoloOF =
        "SERVIZIO " +
        (categoriaLabel ? categoriaLabel.label : "Tutti i servizi OF");
    }

    this.filterIsSetOF =
      (this.filtroRegioneOF && this.filtroRegioneOF.length > 0) ||
      (!!this.filtroCategoriaVincoloOF &&
        typeof this.filtroCategoriaVincoloOF === "string" &&
        this.filtroCategoriaVincoloOF.trim().length > 0);

    // Per la tabella COMPLESSIVO: calcola i vincoli OF filtrati per regione e servizio OF se presenti
    this.resetVincoloOFBando2();

    // Reset array pratiche con lotti non validi
    this.praticheLottoNonValido = [];

    // Reset array pratiche non categorizzate
    this.praticheNonCategorizzate = [];

    let pratichePerComplessivo = this.praticheTipoC;

    // Applica filtro regione se presente
    if (this.filtroRegioneOF && this.filtroRegioneOF.length > 0) {
      pratichePerComplessivo = pratichePerComplessivo.filter((p) =>
        this.filtroRegioneOF.includes(p.regione),
      );
    }

    // Applica filtro servizio OF se presente
    if (
      this.filtroCategoriaVincoloOF &&
      typeof this.filtroCategoriaVincoloOF === "string" &&
      this.filtroCategoriaVincoloOF.trim().length > 0
    ) {
      const filtroServizioOF = this.filtroCategoriaVincoloOF
        .trim()
        .toUpperCase();
      pratichePerComplessivo = pratichePerComplessivo.filter((p) => {
        const servizioOFTrimmed = p.servizioOF
          ? p.servizioOF.trim().toUpperCase()
          : null;
        return servizioOFTrimmed === filtroServizioOF;
      });
    }

    // Calcola i vincoli OF per la tabella COMPLESSIVO
    pratichePerComplessivo.forEach((pratica) => {
      this.loadDatiVincoloOF(pratica);
    });

    // Log pratiche con lotti non validi
    if (this.praticheLottoNonValido.length > 0) {
      this.logger.warn(
        `[HOME WIP] APPLY FILTERS OF - TROVATE ${this.praticheLottoNonValido.length} PRATICHE CON LOTTO NON VALIDO (non 1, 5, 7 o 8):`,
      );
      this.praticheLottoNonValido.forEach((pratica) => {
        this.logger.warn(
          `[HOME WIP] - CUI: ${pratica.cui}, Lotto: "${pratica.lotto}", Regione: ${pratica.regione}, Azienda: ${pratica.azienda}`,
        );
      });
    }

    // Prepara i dati per la tabella COMPLESSIVO
    this.prepareVincoliOFData();

    // Per la tabella PRATICHE: applica entrambi i filtri (regione e categoria vincolo)
    this.updatePraticheTipoCFiltrate();

    // Forza l'aggiornamento della vista
    this.cdr.detectChanges();
  }

  removeFilterOF() {
    this.filtroRegioneOF = [];
    this.filtroCategoriaVincoloOF = "";
    this.filtroStatoOF = "";
    this.filtroVincoloCategoriaPrefisso = "";
    this.filtroCuiOF = "";
    this.filtroVendibile = false;
    this.filterIsSetOF = false;
    this.labelRegioniOF = "Tutte le regioni";
    this.labelCategoriaVincoloOF = "Tutti gli stati OF";

    // Ricalcola i vincoli OF senza filtro
    this.resetVincoloOFBando2();

    // Reset array pratiche con lotti non validi
    this.praticheLottoNonValido = [];

    // Reset array pratiche non categorizzate
    this.praticheNonCategorizzate = [];

    // Aggiorna le pratiche filtrate per la tabella PRATICHE
    this.updatePraticheTipoCFiltrate();

    this.praticheTipoC.forEach((pratica) => {
      this.loadDatiVincoloOF(pratica);
    });

    // Log pratiche con lotti non validi
    if (this.praticheLottoNonValido.length > 0) {
      this.logger.warn(
        `[HOME WIP] REMOVE FILTER OF - TROVATE ${this.praticheLottoNonValido.length} PRATICHE CON LOTTO NON VALIDO (non 1, 5, 7 o 8):`,
      );
      this.praticheLottoNonValido.forEach((pratica) => {
        this.logger.warn(
          `[HOME WIP] - CUI: ${pratica.cui}, Lotto: "${pratica.lotto}", Regione: ${pratica.regione}, Azienda: ${pratica.azienda}`,
        );
      });
    }

    this.prepareVincoliOFData();
    this.cdr.detectChanges();
  }

  updatePraticheTipoCFiltrate() {
    let praticheBase = [...this.praticheTipoC]; // Crea una copia dell'array

    // Applica filtro regione se presente
    if (this.filtroRegioneOF && this.filtroRegioneOF.length > 0) {
      praticheBase = praticheBase.filter((p) =>
        this.filtroRegioneOF.includes(p.regione),
      );
    }

    // Applica filtro SERVIZIO OF (ATTIVO / PASSIVO) se presente
    //this.logger.info("[HOME WIP] updatePraticheTipoCFiltrate - filtroCategoriaVincoloOF: '" + this.filtroCategoriaVincoloOF + "'");
    //this.logger.info("[HOME WIP] updatePraticheTipoCFiltrate - tipo: " + typeof this.filtroCategoriaVincoloOF);
    if (
      this.filtroCategoriaVincoloOF &&
      typeof this.filtroCategoriaVincoloOF === "string" &&
      this.filtroCategoriaVincoloOF.trim().length > 0
    ) {
      const filtroServizioOF = this.filtroCategoriaVincoloOF.trim();
      this.logger.info(
        "[HOME WIP] FILTRO SERVIZIO OF APPLICATO: '" + filtroServizioOF + "'",
      );
      //this.logger.info("[HOME WIP] PRATICHE PRIMA DEL FILTRO SERVIZIO OF: " + praticheBase.length);

      // Log di esempio dei primi servizi OF per debug
      // const serviziOFEsempio = praticheBase.slice(0, 10).map(p => p.servizioOF);
      // this.logger.info("[HOME WIP] ESEMPIO SERVIZI OF NELLE PRIME 10 PRATICHE: " + JSON.stringify(serviziOFEsempio));

      // Conta tutti i valori unici di servizioOF per capire quali valori esistono
      const serviziOFUnici = [
        ...new Set(
          praticheBase.map((p) => p.servizioOF).filter((s) => s != null),
        ),
      ];
      //this.logger.info("[HOME WIP] VALORI UNICI DI servizioOF TROVATI: " + JSON.stringify(serviziOFUnici));

      praticheBase = praticheBase.filter((p) => {
        const servizioOFTrimmed = p.servizioOF
          ? p.servizioOF.trim().toUpperCase()
          : null;
        this.logger.info(
          "[HOME WIP] SERVIZIO OF TRIMMED: '" + servizioOFTrimmed + "'",
        );
        const filtroUpper = filtroServizioOF.toUpperCase();
        const match = servizioOFTrimmed === filtroUpper;
        return match;
      });
      // this.logger.info("[HOME WIP] PRATICHE FILTRATE PER SERVIZIO OF '" + filtroServizioOF + "': " + praticheBase.length);
    } else {
      // this.logger.info("[HOME WIP] FILTRO SERVIZIO OF NON APPLICATO - condizione non soddisfatta");
    }

    // Applica filtro STATO OF se presente
    // Per 'LAVORABILE' confronta esattamente con statoOF, per '2.1'-'2.9' verifica che statoOF inizi con il valore del filtro
    if (
      this.filtroStatoOF &&
      typeof this.filtroStatoOF === "string" &&
      this.filtroStatoOF.trim().length > 0
    ) {
      const filtroStatoOF = this.filtroStatoOF.trim().toUpperCase();
      praticheBase = praticheBase.filter((p) => {
        const statoOFTrimmed = p.statoOF ? p.statoOF.trim().toUpperCase() : "";

        // Se il filtro è 'LAVORABILE', confronta esattamente con statoOF
        if (filtroStatoOF === "LAVORABILE") {
          return statoOFTrimmed === filtroStatoOF;
        }
        // Se il filtro è 'NON_CATEGORIZZATE', cerca pratiche con statoOF vuoto o null
        else if (filtroStatoOF === "NON_CATEGORIZZATE") {
          return !p.statoOF || p.statoOF.trim() === "";
        }
        // Se il filtro è 'ALTRI', cerca pratiche che non sono LAVORABILE e non hanno categoria 2.1-2.9
        else if (filtroStatoOF === "ALTRI") {
          const categoriaCodice = p.vincoloCategoriaCodice;
          const isLavorabile = statoOFTrimmed === "LAVORABILE";
          const isCategoria2x =
            categoriaCodice &&
            (categoriaCodice === "2.1" ||
              categoriaCodice === "2.2" ||
              categoriaCodice === "2.3" ||
              categoriaCodice === "2.4" ||
              categoriaCodice === "2.5" ||
              categoriaCodice === "2.6" ||
              categoriaCodice === "2.7" ||
              categoriaCodice === "2.8" ||
              categoriaCodice === "2.9");

          // Se è impostato un prefisso specifico per vincoloCategoriaCodice, filtra anche per quello
          let matchPrefisso = true;
          if (
            this.filtroVincoloCategoriaPrefisso &&
            this.filtroVincoloCategoriaPrefisso.trim().length > 0
          ) {
            matchPrefisso =
              categoriaCodice &&
              categoriaCodice.startsWith(this.filtroVincoloCategoriaPrefisso);
          }

          return !isLavorabile && !isCategoria2x && matchPrefisso;
        }
        // Per i valori '2.1'-'2.9', usa la stessa logica di categorizzazione del COMPLESSIVO
        else {
          return this.appartieneACategoria(p, filtroStatoOF);
        }
      });
    }

    // Applica filtro CUI se presente (ricerca parziale case-insensitive)
    if (
      this.filtroCuiOF &&
      typeof this.filtroCuiOF === "string" &&
      this.filtroCuiOF.trim().length > 0
    ) {
      const filtroCui = this.filtroCuiOF.trim().toUpperCase();
      praticheBase = praticheBase.filter((p) => {
        const cuiTrimmed = p.cui ? p.cui.trim().toUpperCase() : "";
        return cuiTrimmed.includes(filtroCui);
      });
    }

    // Applica filtro VENDIBILE se attivo (ottimizzato: filtra solo se checkbox è selezionato)
    if (this.filtroVendibile) {
      praticheBase = praticheBase.filter((p) => {
        const statoOFTrimmed = p.statoOF ? p.statoOF.trim().toUpperCase() : "";
        return statoOFTrimmed === "LAVORABILE";
      });
    }

    // Crea un nuovo array per forzare il change detection di PrimeNG
    // Assegna direttamente il nuovo array (spread operator crea un nuovo riferimento)
    // Questo forza il change detection anche quando l'array è vuoto
    this.praticheTipoCFiltrate = [...praticheBase];
    this.logger.info(
      "[HOME WIP] PRATICHE TIPO C FILTRATE - LE PRATICHE DI TIPO C FILTRATE SONO: " +
        this.praticheTipoCFiltrate.length,
    );

    // Forza l'aggiornamento immediato della vista
    this.cdr.markForCheck();
  }

  removeFilterSop() {
    this.filtroRegioneSop = "";
    this.filtroImpresaSop = null;
    this.aggiornaOpzioniImpreseBando1Sop();
    this.aggiornaOpzioniImpreseBando2Sop();
    this.filtroTipoSedeEffettivaSop = "";
    this.filterIsSetSop = false;

    this.labelRegioniSop = "Tutte le regioni";
    if (this.activeBandoIndex == 0) {
      this.datiRaggruppatiBando1SopFiltrati = [
        ...this.datiRaggruppatiBando1Sop,
      ];
      this.totaliSopralluogoEseguitoBando1 = 0;
      this.totaliSopralluogoPianificatoBando1 = 0;
      this.totaliSopralluogoKOBando1 = 0;
      this.totaliNoSopralluogoBando1 = 0;
      this.totaliNoSopralluogoPFBando1 = 0;
      if (this.datiRaggruppatiBando1SopFiltrati.length > 0) {
        for (
          let index = 0;
          index < this.datiRaggruppatiBando1SopFiltrati.length;
          index++
        ) {
          this.totaliSopralluogoBando1 +=
            this.datiRaggruppatiBando1SopFiltrati[index].totale;
          this.totaliNoSopralluogoBando1 +=
            this.datiRaggruppatiBando1SopFiltrati[index].noSopralluogo;
          this.totaliNoSopralluogoPFBando1 +=
            this.datiRaggruppatiBando1SopFiltrati[index].noSopralluogoPF;
          this.totaliSopralluogoPianificatoBando1 +=
            this.datiRaggruppatiBando1SopFiltrati[index].sopralluogoPianificato;
          this.totaliSopralluogoEseguitoBando1 +=
            this.datiRaggruppatiBando1SopFiltrati[index].sopralluogoEseguito;
          this.totaliSopralluogoKOBando1 +=
            this.datiRaggruppatiBando1SopFiltrati[index].sopralluogoKO;
        }
      }
    } else {
      this.datiRaggruppatiBando2SopFiltrati = [
        ...this.datiRaggruppatiBando2Sop,
      ];
      this.totaliSopralluogoEseguitoBando2 = 0;
      this.totaliSopralluogoPianificatoBando2 = 0;
      this.totaliSopralluogoKOBando2 = 0;
      this.totaliNoSopralluogoBando2 = 0;
      this.totaliNoSopralluogoPFBando2 = 0;
      if (this.datiRaggruppatiBando2SopFiltrati.length > 0) {
        for (
          let index = 0;
          index < this.datiRaggruppatiBando2SopFiltrati.length;
          index++
        ) {
          this.totaliSopralluogoBando2 +=
            this.datiRaggruppatiBando2SopFiltrati[index].totale;
          this.totaliNoSopralluogoBando2 +=
            this.datiRaggruppatiBando2SopFiltrati[index].noSopralluogo;
          this.totaliNoSopralluogoPFBando2 +=
            this.datiRaggruppatiBando2SopFiltrati[index].noSopralluogoPF;
          this.totaliSopralluogoPianificatoBando2 +=
            this.datiRaggruppatiBando2SopFiltrati[index].sopralluogoPianificato;
          this.totaliSopralluogoEseguitoBando2 +=
            this.datiRaggruppatiBando2SopFiltrati[index].sopralluogoEseguito;
          this.totaliSopralluogoKOBando2 +=
            this.datiRaggruppatiBando2SopFiltrati[index].sopralluogoKO;
        }
      }
    }
  }

  scaricaReportAppuntamenti() {
    const dati =
      this.activeBandoIndex === 0
        ? this.datiRaggruppatiBando1AppFiltrati
        : this.datiRaggruppatiBando2AppFiltrati;
    const nomeFile =
      this.activeBandoIndex === 0
        ? "report_attivazioni_bando1.xlsx"
        : "report_attivazioni_bando2.xlsx";

    this.excelService.exportAppuntamentiToExcel(dati, nomeFile);
  }

  scaricaReportSopralluoghi() {
    const dati =
      this.activeBandoIndex === 0
        ? this.datiRaggruppatiBando1SopFiltrati
        : this.datiRaggruppatiBando2SopFiltrati;
    const nomeFile =
      this.activeBandoIndex === 0
        ? "report_sopralluoghi_bando1.xlsx"
        : "report_sopralluoghi_bando2.xlsx";

    this.excelService.exportSopralluoghiToExcel(dati, nomeFile);
  }

  scaricaReportVincoliOF() {
    const oggi = new Date();
    const giorno = oggi.getDate().toString().padStart(2, "0");
    const mese = (oggi.getMonth() + 1).toString().padStart(2, "0");
    const anno = oggi.getFullYear().toString().slice(-2);
    const nomeFile = `Report_Stato_Openfiber_${giorno}_${mese}_${anno}.xlsx`;
    this.excelService.exportVincoliOFToExcel(
      this.vincoliOFData,
      this.praticheTipoCFiltrate,
      this.praticheNonCategorizzate,
      nomeFile,
    );
  }

  openPratica(pratica: PraticaFlowdy2_Firestore) {
    const bando = pratica.bando === "BANDO 2" ? 2 : 1;
    // Determina la fase in base allo stato della pratica
    let fase = "fase-2"; // Default
    if (pratica.statoFlowdyFase3) {
      fase = "fase-3";
    } else if (pratica.statoFlowdyFase2) {
      fase = "fase-2";
    } else if (pratica.statoFlowdyFase1) {
      fase = "fase-1";
    }

    this.router.navigateByUrl("/", { skipLocationChange: true }).then(() =>
      this.router.navigate(["pratiche-bando" + bando + "/" + fase], {
        queryParams: {
          pratica: pratica.cui,
          from: "WIP_STATO_OPEN_FIBER",
        },
      }),
    );
  }

  getStileStatoOF(statoOF: string): any {
    if (!statoOF) {
      return {
        "background-color": "#6c757d",
        color: "#ffffff",
        "border-radius": "6px",
        padding: ".25em .5rem",
        "font-weight": "700",
        "font-size": "10px",
        "letter-spacing": ".3px",
      };
    }

    const stato = statoOF.toUpperCase();

    // Gestione ATTIVO e PASSIVO per servizioOF
    if (stato === "ATTIVO") {
      return {
        "background-color": "#B8D4F0",
        color: "#2c3e50",
        "border-radius": "6px",
        padding: ".25em .5rem",
        "font-weight": "700",
        "font-size": "10px",
        "letter-spacing": ".3px",
        border: "2px solid #7BA7D1",
      };
    } else if (stato === "PASSIVO") {
      return {
        "background-color": "#FFD4B3",
        color: "#2c3e50",
        "border-radius": "6px",
        padding: ".25em .5rem",
        "font-weight": "700",
        "font-size": "10px",
        "letter-spacing": ".3px",
        border: "2px solid #FFB380",
      };
    } else if (stato === "LAVORABILE") {
      return {
        "background-color": "#28a745",
        color: "#ffffff",
        "border-radius": "6px",
        padding: ".25em .5rem",
        "font-weight": "700",
        "font-size": "10px",
        "letter-spacing": ".3px",
        "box-shadow": "0 2px 4px rgba(40, 167, 69, 0.4)",
        border: "2px solid #1e7e34",
      };
    } else if (stato === "KO" || stato === "NON LAVORABILE") {
      return {
        "background-color": "#dc3545",
        color: "#ffffff",
        "border-radius": "6px",
        padding: ".25em .5rem",
        "font-weight": "700",
        "font-size": "10px",
        "letter-spacing": ".3px",
      };
    } else if (stato === "IN ATTESA") {
      return {
        "background-color": "#ffc107",
        color: "#000000",
        "border-radius": "6px",
        padding: ".25em .5rem",
        "font-weight": "700",
        "font-size": "10px",
        "letter-spacing": ".3px",
      };
    } else if (statoOF && statoOF.trim().startsWith("2.")) {
      // Per le categorie 2.1-2.9, usa il colore dalla stiliService
      return {
        "background-color": this.stiliService.getColoreCategoriaVincoloOF(
          statoOF.trim(),
        ),
        color: "#ffffff",
        "border-radius": "6px",
        padding: ".25em .5rem",
        "font-weight": "700",
        "font-size": "10px",
        "letter-spacing": ".3px",
        "box-shadow": "0 2px 4px rgba(0,0,0,0.2)",
      };
    } else {
      return {
        "background-color": "#6c757d",
        color: "#ffffff",
        "border-radius": "6px",
        padding: ".25em .5rem",
        "font-weight": "700",
        "font-size": "10px",
        "letter-spacing": ".3px",
      };
    }
  }

  getStileServizioOF(value: string): any {
    if (value === "ATTIVO") {
      return {
        "background-color": "#B8D4F0",
        color: "#2c3e50",
        "border-radius": "6px",
        padding: ".25em .5rem",
        "font-weight": "700",
        "font-size": "11px",
        "letter-spacing": ".3px",
        border: "2px solid #7BA7D1",
      };
    } else if (value === "PASSIVO") {
      return {
        "background-color": "#FFD4B3",
        color: "#2c3e50",
        "border-radius": "6px",
        padding: ".25em .5rem",
        "font-weight": "700",
        "font-size": "11px",
        "letter-spacing": ".3px",
        border: "2px solid #FFB380",
      };
    } else {
      return {
        "background-color": "#6c757d",
        color: "#ffffff",
        "border-radius": "6px",
        padding: ".25em .5rem",
        "font-weight": "700",
        "font-size": "11px",
        "letter-spacing": ".3px",
      };
    }
  }

  getTooltipStatoOF(pratica: PraticaFlowdy2_Firestore): string {
    const ordini: string[] = [];

    if (pratica.ordineScuola && pratica.ordineScuola.trim()) {
      ordini.push(
        `ORDINE Scuola: ${pratica.ordineScuola.trim().toUpperCase()}`,
      );
    }

    if (pratica.ordineBH && pratica.ordineBH.trim()) {
      ordini.push(`ORDINE BH: ${pratica.ordineBH.trim().toUpperCase()}`);
    }

    if (pratica.ordinePCN && pratica.ordinePCN.trim()) {
      ordini.push(`ORDINE PCN: ${pratica.ordinePCN.trim().toUpperCase()}`);
    }

    return ordini.length > 0 ? ordini.join("\n") : "";
  }

  getStileStatoOFFilter(value: string): any {
    if (value === "LAVORABILE") {
      return {
        "background-color": "#28a745",
        color: "#ffffff",
        "border-radius": "6px",
        padding: ".25em .5rem",
        "font-weight": "700",
        "font-size": "11px",
        "letter-spacing": ".3px",
        "box-shadow": "0 2px 4px rgba(40, 167, 69, 0.4)",
        border: "2px solid #1e7e34",
      };
    } else if (value === "NON_CATEGORIZZATE") {
      return {
        "background-color": "#dc3545",
        color: "#ffffff",
        "border-radius": "6px",
        padding: ".25em .5rem",
        "font-weight": "700",
        "font-size": "11px",
        "letter-spacing": ".3px",
        "box-shadow": "0 2px 4px rgba(220, 53, 69, 0.4)",
        border: "2px solid #bd2130",
      };
    } else if (value === "ALTRI") {
      return {
        "background-color": "#6c757d",
        color: "#ffffff",
        "border-radius": "6px",
        padding: ".25em .5rem",
        "font-weight": "700",
        "font-size": "11px",
        "letter-spacing": ".3px",
        "font-style": "italic",
      };
    } else if (value && value.startsWith("2.")) {
      // Per le categorie 2.1-2.9, usa il colore dalla stiliService
      return {
        "background-color":
          this.stiliService.getColoreCategoriaVincoloOF(value),
        color: "#ffffff",
        "border-radius": "6px",
        padding: ".25em .5rem",
        "font-weight": "700",
        "font-size": "11px",
        "letter-spacing": ".3px",
      };
    } else {
      return {
        "background-color": "#6c757d",
        color: "#ffffff",
        "border-radius": "6px",
        padding: ".25em .5rem",
        "font-weight": "700",
        "font-size": "11px",
        "letter-spacing": ".3px",
      };
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    // Reset dei flag di caricamento all'inizio di ngOnChanges
    this.resetLoadingFlags();

    if (changes["impresa"] && changes["impresa"].currentValue) {
      this.impresa = changes["impresa"].currentValue;
    }
    if (changes["isImpresa"] && changes["isImpresa"].currentValue) {
      this.isImpresa = changes["isImpresa"].currentValue;
    }
    if (changes["isPresidioTIM"] && changes["isPresidioTIM"].currentValue) {
      this.isPresidioTIM = changes["isPresidioTIM"].currentValue;
    }

    // Gestisce i cambiamenti dei parametri per i tab (input properties)
    if (changes["activeTabType"] || changes["activeBandoNumber"]) {
      this.setActiveTabsFromInputs();
    }

    if (
      (changes["isImpresa"] && changes["isImpresa"].currentValue) ||
      (changes["isPresidioTIM"] && changes["isPresidioTIM"].currentValue) ||
      (changes["impresa"] && changes["impresa"].currentValue)
    ) {
      // Reset dei flags di caricamento quando cambiano le condizioni utente
      this.bando1AppLoaded = false;
      this.bando2AppLoaded = false;
      this.bando1SopLoaded = false;
      this.bando2SopLoaded = false;

      // Carica solo i dati del tab attivo
      this.loadActiveTabData();
      this.isFirstLoad = false; // Marchia che il primo caricamento è stato fatto
    }
  }

  /**
   * Imposta i tab attivi basandosi sui parametri di input (input properties)
   */
  private setActiveTabsFromInputs() {
    let shouldForceLoad = false;
    let tipoIndexChanged = false;
    let bandoIndexChanged = false;

    // Imposta il bando prima (potrebbe influenzare il default del tipo)
    if (
      this.activeBandoNumber !== undefined &&
      this.activeBandoNumber !== null
    ) {
      const oldBandoIndex = this.activeBandoIndex;
      // Converti esplicitamente in numero per evitare problemi di tipo
      const bandoNumber = Number(this.activeBandoNumber);
      this.activeBandoIndex = bandoNumber === 1 ? 0 : bandoNumber === 2 ? 1 : 1; // Default: Bando 2
      bandoIndexChanged = oldBandoIndex !== this.activeBandoIndex;
      shouldForceLoad = true;
    }

    // Imposta il tipo di tab (Sopralluoghi vs Appuntamenti/Attivazioni)
    if (this.activeTabType !== undefined && this.activeTabType !== null) {
      const oldTipoIndex = this.activeTipoIndex;
      this.activeTipoIndex = this.activeTabType === "APPUNTAMENTI" ? 1 : 0;
      tipoIndexChanged = oldTipoIndex !== this.activeTipoIndex;
      shouldForceLoad = true;
    } else if (
      this.activeBandoNumber !== undefined &&
      this.activeBandoNumber !== null
    ) {
      // Se activeBandoNumber è impostato ma activeTabType no, usa il default (Sopralluoghi)
      const oldTipoIndex = this.activeTipoIndex;
      this.activeTipoIndex = 0; // Default a Sopralluoghi
      tipoIndexChanged = oldTipoIndex !== this.activeTipoIndex;
      shouldForceLoad = true;
    }

    // Carica i dati del tab selezionato, forzando il caricamento se necessario
    if (shouldForceLoad) {
      this.loadActiveTabData(true);
    } else {
      this.loadActiveTabData();
    }
  }
}
